// Version: 2.66
// v2.66: Number tiles use the shared .stat-card; inputs and selects take their look from index.css (input-sm for compact) (CV-50).
// v2.65: Sitemap and source links use the shared button classes (they were pill-shaped).
// v2.64: "Action required" in sentence case, like the reports.
// v2.63: The "invisible to Google Analytics" card only shows when some visits used an ad or tracker blocker (it showed "0%").
// v2.62: Buttons use the shared button system (CV-49): 8px corners, standard variants and sizes, one selected look; no inline radius, padding or font size.
// v2.61: Snippet status uses the version the API reports (snippet_current) and
//        ?panel=snippet opens the snippet ready to copy (dashboard link).
// v2.60: Rage clicks have Show on page: the spot marked on the page screenshot
//        the click heatmap takes (or Take one if there isn't one yet). The
//        analytics report links here with ?panel=rage, which opens the top one.
// v2.59: Rage clicks show what was clicked in words, with where on the page and
//        the device when it has no label, and the element selector (app.py v4.02).
// v2.58: Companies Visiting Your Site has a "Not a business" button (admins)
//        that hides an organisation, such as an internet provider, for every
//        client's dashboard and analytics report, plus a list to show them
//        again (app.py v3.99 /api/analytics/org-exclusions).
// v2.57: The Website Analytics Report settings panel now summarises the
//        schedule and links to the Schedules page (where it is edited) and to
//        Reports and Assessments (preview, send now, send a test).
// v2.56: Click heatmap — says when a screenshot was taken automatically, and
//        the empty state explains that screenshots are taken automatically
//        once a page has enough clicks (app.py v3.82).
// v2.55: Click heatmap — the page list shows desktop and mobile clicks
//        separately instead of one combined number, the Desktop and Mobile
//        buttons show their own counts, and each page opens on the device
//        with the most clicks. When the device shown has no clicks but the
//        other does, a note says so with a button to switch.
// v2.54: What to Fix This Month panel (top of Analytics), Page Map panel
//        (sitemap pages nobody visits, visited pages missing from the
//        sitemap, admin re-read), readable page names across page lists,
//        dated notes on the traffic chart (add/remove), and Email report
//        settings (weekly/monthly, day, time, recipients, preview, send
//        test, send now) in the admin Settings card.
// v2.53: Recent Visitors shows the first 5 visits, then 25 more at a time,
//        with the same Show / Show fewer buttons as the other lists.
// v2.52: Fix — the Goals panel crashed the Analytics page (CONVERSION_CARDS
//        was defined inside the page component, out of the panel's reach).
// v2.51: Long analytics lists (sources, pages, countries, browsers, campaigns,
//        referral sites, companies, attribution, calls to action, form fields,
//        searches, errors and more) show the first 5 rows with "Show all N" /
//        "Show fewer". Short lists (6 or fewer) show in full.
// v2.50: Snippet v2.94 panels — click heatmap over page screenshots (desktop/
//        mobile), visitors invisible to Google Analytics, the road to an
//        enquiry, when enquiries arrive, calls to action seen vs clicked, form
//        friction by field, speed vs enquiries, completed bookings/orders.
//        CURRENT_SV 2.94. Backend app.py v3.70, stgcore-shot v1.0.
// v2.49: View details anchors for the new Ask topics (app.py v3.69): an-visitors,
//        an-sections, an-goals, an-custom, an-attribution.
// v2.48: Taught questions are this-client-only by default; "Also teach all
//        clients" is opt-in with a confirmation warning (and on removal).
//        Taught list labels THIS CLIENT / ALL CLIENTS.
// v2.47: Teach in the admin Ask panel — each not-understood question can be
//        added (editable) as an example for a chosen answer via POST
//        /admin/ask/intents/examples (app.py v3.69, stgcore-ask v1.1); goes
//        live without a restart. Taught questions list with Remove.
// v2.46: Ask box chips are built from the client's own data (GET
//        /clients/<slug>/analytics/ask/suggestions, app.py v3.69) — their
//        branches, form options, sources and campaigns — falling back to the
//        standard examples if that call fails.
// v2.45: AskInsightsPanel (admin) above Settings — this client's Ask questions
//        from their private log (GET /clients/<slug>/analytics/ask/log, app.py
//        v3.69): answered rate, not-understood questions grouped by wording with
//        the closest intent and score, popular topics, recent questions.
// v2.44: CURRENT_SV bumped to 2.93 to match snippet v2.93 (app.py v3.67+), so the
//        Settings snippet banner treats 2.93 as current and flags older installs.
// v2.43: Shareable read-only analytics link (B3) in admin Settings — create /
//        copy / revoke a public link (POST /clients/<slug>/analytics/share),
//        for a prospect taster alongside the snippet. Backend app.py v3.68.
//        Merged onto user v2.42 (source of truth).
// v2.42: Enquiries by choice and by page (app.py v3.67). EnquiryChoicesPanel
//        shows the option chosen on marked form fields (location, service) per
//        submission; EnquiryPagesPanel ranks pages by enquiries with views and
//        rate. New an-choices and an-page-conv anchors for the Ask box. Admins
//        see a hint on how to switch on choice tracking when none is recorded.
// v2.41: Ask box at the top of the Analytics tab — plain-English questions
//        answered from the same data as the panels (app.py v3.66, stgcore-ask).
//        Answers show a figures card, a View details link that scrolls to and
//        highlights the matching panel, related questions, and suggestions when
//        a question isn't understood. Invisible an-* anchors added before the
//        panels for this. Companies Visiting Your Site is now shown to clients
//        too; the Add to pipeline button and pipeline note stay admin-only.
// v2.40: Company Visitors panel (A2, admin) — named organisations resolved from
//        visitor networks with an intent signal, one click to add as a website
//        lead in the sales pipeline. Consumes company_visitors from app.py v3.65.
// v2.39: Digital Hub analytics upgrades — admin CSV/Excel export of raw snippet
//        events (exportData → /analytics/export); SourcePerformancePanel ties each
//        traffic source to sessions, conversions and rate, click a source to drill
//        into its converting sessions (SourceConvSessions); AttributionPanel shows
//        first-touch vs last-touch side by side per source; RageClickPanel and
//        Page404Panel group rage clicks by element and 404s by missing path plus
//        referrer, with click-through links. Consumes new backend fields:
//        source_performance, attribution, rage_click_detail, page_404_detail.
// v2.38: Analytics section — ScrollFunnelPanel (scroll_milestone events, 25/50/75/100%
//        depth funnel), SectionViewsPanel (section_view events, data-cv-section landmarks),
//        LastTouchPanel (last_touch attribution from snippet v2.92), JsErrorsPanel with
//        expandable stack traces (error_stack field), scroll insights in InsightSummary,
//        scroll_milestone and section_view added to EVENT_ICONS, CURRENT_SV bumped to 2.92.
//        All panels degrade gracefully — show nothing until the backend processes the new
//        event types from the updated snippet.
// v2.37: (previous)
// v2.32: Referral Sites panel — each domain now expandable to show top referring
//        URLs (full path, query stripped). Powered by new top_urls field in
//        referral_domains from app.py v2.99.
// v2.31: Heatmap time axis replaced with day/night period band — four coloured
//        segments (Night/Morning/Day/Evening) with Tabler icons and time ranges,
//        giving instant visual orientation without dense numeric labels.
import { useState, useEffect, useCallback, useRef } from "react";
import { authFetch } from "./auth";

// Strip www. duplicates and exclude development environment domains
function cleanDomains(domains) {
  if (!Array.isArray(domains)) return [];
  const seen = new Set();
  return domains
    .filter(d => !d.endsWith("webcontainer-api.io"))
    .map(d => d.startsWith("www.") ? d.slice(4) : d)
    .filter(d => { if (seen.has(d)) return false; seen.add(d); return true; });
}

// Conversion types shown as cards; also used by the Goals panel (v2.52:
// moved to module level — the Goals panel couldn't see it inside the page).
const CONVERSION_CARDS = [
  { key: "phone_clicks",  eventType: "click_phone",  label: "Phone Clicks",    icon: "📞", color: "#30d158" },
  { key: "email_clicks",  eventType: "click_email",  label: "Email Clicks",    icon: "✉️", color: "#30d158" },
  { key: "form_submits",  eventType: "form_submit",  label: "Form Submits",    icon: "✅", color: "#30d158" },
  { key: "form_starts",   eventType: "form_start",   label: "Form Starts",     icon: "📝", color: "#e6b800" },
  { key: "downloads",     eventType: "download",     label: "Downloads",       icon: "⬇️", color: "#00d4ff" },
  { key: "outbound",      eventType: "outbound",     label: "Outbound Clicks", icon: "↗️", color: "var(--text-muted)" },
  { key: "video_plays",   eventType: "video_play",   label: "Video Plays",     icon: "▶️", color: "#00d4ff" },
  { key: "rage_clicks",   eventType: "rage_click",   label: "Rage Clicks",     icon: "😤", color: "#ff2d55" },
  { key: "page_404s",     eventType: "page_404",     label: "404 Pages",       icon: "🚫", color: "#ff2d55" },
  { key: "dead_clicks",   eventType: "dead_click",   label: "Dead Clicks",     icon: "👻", color: "#ff9f0a" },
];

// ── Shared UI ─────────────────────────────────────────────────────────────────

// v2.51: long lists show the first few rows, with "Show all N" / "Show fewer".
const SHOW_PILL = { alignSelf: "flex-start", display: "inline-flex", alignItems: "center", gap: 4, marginTop: 6, padding: "4px 10px",
                    fontSize: 11, fontWeight: 600, color: "var(--accent)", background: "transparent",
                    border: "1px solid var(--border)", borderRadius: 999, cursor: "pointer" };
function ShowMore({ children, limit = 5 }) {
  const [open, setOpen] = useState(false);
  const items = [].concat(children || []).flat().filter(x => x !== null && x !== undefined && x !== false);
  if (items.length <= limit + 1) return <>{items}</>;
  return (
    <>
      {open ? items : items.slice(0, limit)}
      <button className="btn btn-secondary btn-sm" style={{ alignSelf: "flex-start", marginTop: 6 }} type="button" onClick={() => setOpen(o => !o)}>
        {open ? "Show fewer ▴" : `Show all ${items.length} ▾`}
      </button>
    </>
  );
}

// ── v2.54: readable page names, what to fix, page map, chart notes, email report ──

// Page names from the summary (page titles with the site name removed). Set
// once per render of the Analytics page, read by the page lists.
let PAGE_NAMES = {};
function pagePath(pathOrUrl) {
  let p = pathOrUrl || "/";
  try { if (/^https?:\/\//.test(p)) p = new URL(p).pathname || "/"; } catch (e) { /* keep as is */ }
  p = p.split("?")[0].split("#")[0] || "/";
  if (p.length > 1 && p.endsWith("/")) p = p.replace(/\/+$/, "") || "/";
  return p;
}
function pageName(pathOrUrl) {
  const p = pagePath(pathOrUrl);
  if (p === "/") return "Homepage";
  return PAGE_NAMES[p] || p;
}
function PageName({ path, mono = false }) {
  const p = pagePath(path);
  const nm = pageName(p);
  return (
    <span title={p} style={{ display: "block", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
      <span style={mono ? { fontFamily: "var(--font-mono)" } : undefined}>{nm}</span>
      {nm !== p && p !== "/" && (
        <span style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)", marginLeft: 6 }}>{p}</span>
      )}
    </span>
  );
}

const FIX_COLOURS = { high: "#ff453a", medium: "#ff9f0a", low: "var(--text-muted)" };
const FIX_ANCHOR  = { errors: "errors", rage: "rage", fields: "fields", speed: "speed", hours: "hours",
                      ctas: "ctas", pagemap: "pagemap", insights: "page-insights" };

function FixListPanel({ recs }) {
  if (!recs?.length) return null;
  const jump = (panel) => {
    const el = document.getElementById(`an-${FIX_ANCHOR[panel] || panel}`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <SectionCard>
      <CardLabel>What to Fix This Month</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: -6, marginBottom: 12 }}>
        The changes most likely to win more enquiries, worked out from the panels below.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {recs.map((r, i) => (
          <div key={r.key || i} style={{ display: "flex", gap: 12, alignItems: "flex-start", padding: "10px 12px",
                                         background: "var(--surface2)", borderRadius: 8, borderLeft: `3px solid ${FIX_COLOURS[r.severity] || "var(--border)"}` }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 700 }}>{r.title}</div>
              <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3, lineHeight: 1.5 }}>{r.detail}</div>
            </div>
            <button className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }} type="button" onClick={() => jump(r.panel)}>Details</button>
          </div>
        ))}
      </div>
    </SectionCard>
  );
}

function PageMapPanel({ pm, slug, isAdmin, onRefreshed }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg]   = useState("");
  if (!pm) return null;
  const refresh = async () => {
    setBusy(true); setMsg("");
    try {
      const r = await authFetch(`/api/clients/${slug}/analytics/sitemap/refresh`, { method: "POST", body: "{}" });
      const d = await r.json();
      setMsg(d.error || `Read ${d.pages} pages from the sitemap.`);
      if (!d.error && onRefreshed) onRefreshed();
    } catch (e) { setMsg("Couldn't reach the server."); }
    setBusy(false);
  };
  const when = pm.fetched_at ? new Date(pm.fetched_at).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" }) + " GMT" : "";
  const un = pm.unvisited || [], missing = pm.not_in_sitemap || [];
  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <CardLabel style={{ marginBottom: 0 }}>Page Map — Pages Nobody Visits</CardLabel>
        {isAdmin && <button className="btn btn-secondary btn-sm" type="button" onClick={refresh} disabled={busy}>{busy ? "Reading sitemap…" : "Re-read sitemap"}</button>}
      </div>
      {pm.status === "ok" ? (
        <>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", margin: "12px 0" }}>
            <StatBadge value={pm.pages_total} label="Pages in sitemap" color="var(--accent)" />
            <StatBadge value={pm.visited} label="Visited" color="#30d158" />
            <StatBadge value={un.length} label="No visits" color={un.length ? "#ff9f0a" : "#30d158"} />
          </div>
          {un.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <ShowMore>{un.map(u => (
                <div key={u.path} style={{ display: "flex", justifyContent: "space-between", gap: 10, padding: "6px 0", fontSize: 12, borderBottom: "1px solid var(--border)" }}>
                  <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {u.name}<span style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)", marginLeft: 6 }}>{u.path}</span>
                  </span>
                  {u.lastmod && <span style={{ fontSize: 10, color: "var(--text-muted)", flexShrink: 0 }}>updated {u.lastmod}</span>}
                </div>
              ))}</ShowMore>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 8 }}>Link to these from busier pages and the menu, or remove them if they're out of date.</div>
            </div>
          ) : (
            <div style={{ fontSize: 12, color: "#30d158" }}>Every page in the sitemap had visits in this period.</div>
          )}
          {missing.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", marginBottom: 6 }}>Visited but missing from the sitemap — search engines may not find these</div>
              <ShowMore>{missing.map(m => (
                <div key={m.path} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: 12, borderBottom: "1px solid var(--border)" }}>
                  <span>{m.name}<span style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)", marginLeft: 6 }}>{m.path}</span></span>
                  <span style={{ fontFamily: "var(--font-mono)", color: "var(--text-muted)" }}>{m.views} views</span>
                </div>
              ))}</ShowMore>
            </div>
          )}
          <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 10 }}>Sitemap read {when}. It's re-read every week.</div>
        </>
      ) : (
        <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 10, lineHeight: 1.5 }}>
          {pm.status === "pending" ? "The website's page list is being read — check back in a minute." : (pm.error || "No sitemap was found for this website.")}
        </div>
      )}
      {msg && <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 8 }}>{msg}</div>}
    </SectionCard>
  );
}

// Traffic chart with dated notes ("new website launched")
function TrendWithNotes({ slug, daily }) {
  const [notes, setNotes] = useState([]);
  const [adding, setAdding] = useState(false);
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [text, setText] = useState("");
  const [err, setErr] = useState("");
  const load = useCallback(() => {
    authFetch(`/api/clients/${slug}/analytics/notes`).then(r => r.ok ? r.json() : null)
      .then(d => setNotes(d?.notes || [])).catch(() => {});
  }, [slug]);
  useEffect(() => { load(); }, [load]);
  const dates = (daily || []).map(d => d.date);
  const inRange = notes.filter(n => dates.length && n.date >= dates[0] && n.date <= dates[dates.length - 1]);
  const pos = (d) => {
    let i = dates.indexOf(d);
    if (i < 0) i = dates.findIndex(x => x > d);
    return dates.length > 1 ? (Math.max(0, i) / (dates.length - 1)) * 100 : 0;
  };
  const add = async () => {
    setErr("");
    const r = await authFetch(`/api/clients/${slug}/analytics/notes`, { method: "POST", body: JSON.stringify({ date, text }) });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { setErr(d.error || "Couldn't add the note."); return; }
    setText(""); setAdding(false); load();
  };
  const remove = async (id) => {
    setErr("");
    const r = await authFetch(`/api/clients/${slug}/analytics/notes/${id}`, { method: "DELETE" });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { setErr(d.error || "Couldn't remove the note."); return; }
    load();
  };
  const fmt = (d) => new Date(d + "T12:00:00").toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
  return (
    <>
      {inRange.length > 0 && (
        <div style={{ position: "relative", height: 18 }}>
          {inRange.map((n, i) => (
            <span key={n.id} title={`${fmt(n.date)}: ${n.text}`} style={{ position: "absolute", left: `${pos(n.date)}%`, transform: "translateX(-50%)",
              width: 16, height: 16, lineHeight: "16px", borderRadius: 999, background: "#ff9f0a", color: "#000", fontSize: 10, fontWeight: 700, textAlign: "center" }}>{i + 1}</span>
          ))}
        </div>
      )}
      <div style={{ position: "relative" }}>
        <AreaTrendChart data={daily} />
        {inRange.map(n => (
          <div key={n.id} style={{ position: "absolute", top: 0, bottom: 0, left: `${pos(n.date)}%`, borderLeft: "1px dashed #ff9f0a", pointerEvents: "none" }} />
        ))}
      </div>
      <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 4 }}>
        {inRange.map((n, i) => (
          <div key={n.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12 }}>
            <span style={{ width: 16, height: 16, lineHeight: "16px", borderRadius: 999, background: "#ff9f0a", color: "#000", fontSize: 10, fontWeight: 700, textAlign: "center", flexShrink: 0 }}>{i + 1}</span>
            <span style={{ color: "var(--text-muted)", flexShrink: 0 }}>{fmt(n.date)}</span>
            <span style={{ flex: 1, minWidth: 0 }}>{n.text}</span>
            <button className="btn btn-quiet btn-sm btn-icon" type="button" onClick={() => remove(n.id)} title="Remove note"
             >×</button>
          </div>
        ))}
      </div>
      {adding ? (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10, alignItems: "center" }}>
          <input className="input-sm" type="date" value={date} onChange={e => setDate(e.target.value)}/>
          <input className="input-sm" value={text} maxLength={120} onChange={e => setText(e.target.value)} placeholder="e.g. New website launched"
            onKeyDown={e => { if (e.key === "Enter") add(); }}
            style={{ flex: 1, minWidth: 180 }} />
          <button className="btn btn-primary btn-sm" type="button" onClick={add} disabled={!text.trim()}>Add</button>
          <button className="btn btn-secondary btn-sm" type="button" onClick={() => setAdding(false)}>Cancel</button>
        </div>
      ) : (
        <button className="btn btn-secondary btn-sm" style={{ alignSelf: "flex-start", marginTop: 6 }} type="button" onClick={() => setAdding(true)}>+ Add a note</button>
      )}
      {err && <div style={{ fontSize: 11, color: "#ff453a", marginTop: 6 }}>{err}</div>}
    </>
  );
}

const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// v2.57: the Website Analytics Report is now scheduled on the Schedules page
// and sent on demand from Reports and Assessments. This panel just says what
// is set up and links to both.
function ReportScheduleSettings({ slug }) {
  const [loaded, setLoaded] = useState(false);
  const [sched, setSched]   = useState(null);
  useEffect(() => {
    authFetch(`/api/clients/${slug}/analytics/report-schedule`).then(r => r.ok ? r.json() : null).then(d => {
      setSched(d?.schedule || null);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, [slug]);
  if (!loaded) return null;
  const when = sched
    ? (sched.frequency === "weekly" ? `Weekly, every ${WEEKDAYS[sched.day_of_week] || "Monday"}` : `Monthly, on day ${sched.day_of_month}`) + ` at ${sched.time_of_day}`
    : "";
  const link = { color: "var(--accent)", textDecoration: "none", fontWeight: 600 };
  return (
    <div style={{ marginTop: 18, paddingTop: 16, borderTop: "1px solid var(--border)" }}>
      <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Website Analytics Report</div>
      {sched ? (
        <div style={{ fontSize: 12, color: "var(--text)" }}>
          {when} to {(sched.recipients || []).join(", ") || "no recipients"}.
          <span style={{ color: "var(--text-muted)" }}>
            {" "}{sched.enabled !== false && sched.next_run_local ? `Next: ${sched.next_run_local}.` : "Paused."}
            {sched.last_run_local ? ` Last sent: ${sched.last_run_local}${sched.last_status === "failed" ? " (failed)" : ""}.` : ""}
          </span>
        </div>
      ) : (
        <div style={{ fontSize: 12, color: "var(--text-muted)" }}>Not scheduled.</div>
      )}
      <div style={{ fontSize: 12, marginTop: 8, display: "flex", gap: 16, flexWrap: "wrap" }}>
        <a href="/schedules" style={link}>{sched ? "Change schedule" : "Set up a schedule"} →</a>
        <a href="/new?type=analytics" style={link}>Preview or send now →</a>
      </div>
    </div>
  );
}

function SectionCard({ children, style }) {
  return (
    <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius-lg)", padding: "22px 24px", marginBottom: 16, ...style }}>
      {children}
    </div>
  );
}

function CardLabel({ children, style }) {
  return (
    <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.09em", marginBottom: 14, ...style }}>
      {children}
    </div>
  );
}

function EmptyState({ message }) {
  return <div style={{ padding: "32px 0", textAlign: "center", color: "var(--text-muted)", fontSize: 13 }}>{message}</div>;
}

// ── Traffic source pills ───────────────────────────────────────────────────────

const SOURCE_META = {
  direct:         { label: "Direct",        color: "#86868b", bg: "rgba(134,134,139,0.12)" },
  google_organic: { label: "Google",        color: "#34a853", bg: "rgba(52,168,83,0.12)"   },
  google_ads:     { label: "Google Ads",    color: "#fbbc04", bg: "rgba(251,188,4,0.12)"   },
  bing_organic:   { label: "Bing",          color: "#00809d", bg: "rgba(0,128,157,0.12)"   },
  bing_ads:       { label: "Bing Ads",      color: "#00b4d8", bg: "rgba(0,180,216,0.12)"   },
  linkedin:       { label: "LinkedIn",      color: "#0077b5", bg: "rgba(0,119,181,0.12)"   },
  facebook:       { label: "Facebook",      color: "#1877f2", bg: "rgba(24,119,242,0.12)"  },
  twitter:        { label: "X / Twitter",   color: "#1da1f2", bg: "rgba(29,161,242,0.12)"  },
  instagram:      { label: "Instagram",     color: "#e1306c", bg: "rgba(225,48,108,0.12)"  },
  tiktok:         { label: "TikTok",        color: "#ff0050", bg: "rgba(255,0,80,0.12)"    },
  reddit:         { label: "Reddit",        color: "#ff4500", bg: "rgba(255,69,0,0.12)"    },
  youtube:        { label: "YouTube",       color: "#ff0000", bg: "rgba(255,0,0,0.12)"     },
  ai_chatbot:     { label: "AI Chatbot",    color: "#7c3aed", bg: "rgba(124,58,237,0.12)"  },
  email:          { label: "Email",         color: "#00bfa5", bg: "rgba(0,191,165,0.12)"   },
  referral:       { label: "Referral",      color: "#00d4ff", bg: "rgba(0,212,255,0.12)"   },
  paid:           { label: "Paid",          color: "#e6b800", bg: "rgba(230,184,0,0.12)"   },
  social:         { label: "Social",        color: "#ff9f0a", bg: "rgba(255,159,10,0.12)"  },
  yahoo:          { label: "Yahoo",         color: "#720e9e", bg: "rgba(114,14,158,0.12)"  },
  duckduckgo:     { label: "DuckDuckGo",    color: "#de5833", bg: "rgba(222,88,51,0.12)"   },
  ecosia:         { label: "Ecosia",        color: "#4a9b2b", bg: "rgba(74,155,43,0.12)"   },
  baidu:          { label: "Baidu",         color: "#2932e1", bg: "rgba(41,50,225,0.12)"   },
};

function SourcePill({ source, size = "sm" }) {
  const m = SOURCE_META[source] || { label: source || "Direct", color: "#86868b", bg: "rgba(134,134,139,0.12)" };
  const fs = size === "lg" ? 12 : 10;
  const pad = size === "lg" ? "4px 10px" : "2px 8px";
  return (
    <span style={{
      display: "inline-block", fontSize: fs, fontWeight: 700, lineHeight: 1.4,
      padding: pad, borderRadius: 5,
      color: m.color, background: m.bg,
      border: `1px solid ${m.color}30`,
      whiteSpace: "nowrap",
    }}>{m.label}</span>
  );
}

// ── Hero metric card ───────────────────────────────────────────────────────────

function HeroMetric({ label, value, sub, accent = "var(--accent)", icon }) {
  return (
    <div style={{
      background: "var(--surface)", border: "1px solid var(--border)",
      borderRadius: "var(--radius-lg)", padding: "18px 22px",
      flex: "1 1 130px", minWidth: 130, position: "relative", overflow: "hidden",
    }}>
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0, height: 3,
        background: accent, borderRadius: "var(--radius-lg) var(--radius-lg) 0 0",
      }} />
      {icon && <div style={{ fontSize: 18, marginBottom: 8, color: accent }}>{icon}</div>}
      <div style={{ fontSize: 30, fontWeight: 800, color: accent, fontFamily: "var(--font-mono)", lineHeight: 1, marginBottom: 5 }}>{value}</div>
      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.1em" }}>{label}</div>
      {sub && <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 4 }}>{sub}</div>}
    </div>
  );
}

// ── Area sparkline (Analytics trend chart) ─────────────────────────────────────

function AreaTrendChart({ data, color = "var(--accent)", height = 80 }) {
  if (!data?.length) return null;
  const W = 600, H = height;
  const vals = data.map(d => d.views);
  const max  = Math.max(1, ...vals);
  const pts  = data.map((d, i) => {
    const x = (i / Math.max(data.length - 1, 1)) * W;
    const y = H - (d.views / max) * (H - 8);
    return [x.toFixed(1), y.toFixed(1)];
  });
  const linePts  = pts.map(p => p.join(",")).join(" ");
  const areaPath = `M${pts[0][0]},${H} ${pts.map(p => `L${p[0]},${p[1]}`).join(" ")} L${pts[pts.length-1][0]},${H} Z`;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} preserveAspectRatio="none">
      <defs>
        <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0.02" />
        </linearGradient>
      </defs>
      <path d={areaPath} fill="url(#areaGrad)" />
      <polyline points={linePts} fill="none" stroke={color} strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
      {pts.length > 0 && (
        <circle cx={pts[pts.length-1][0]} cy={pts[pts.length-1][1]} r={4} fill={color} />
      )}
    </svg>
  );
}

// ── Horizontal bar chart ───────────────────────────────────────────────────────

function HBarChart({ items, keyField, labelField, valueField, colorFn }) {
  if (!items?.length) return null;
  const max = Math.max(1, ...items.map(i => i[valueField]));
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {items.map((item, i) => {
        const pct = (item[valueField] / max) * 100;
        const color = colorFn ? colorFn(item) : "var(--accent)";
        return (
          <div key={item[keyField] || i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 120, flexShrink: 0 }}>{labelField ? item[labelField] : item[keyField]}</div>
            <div style={{ flex: 1, height: 8, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
              <div style={{ width: `${pct}%`, height: "100%", background: color, borderRadius: 4, transition: "width 0.4s ease" }} />
            </div>
            <div style={{ width: 36, textAlign: "right", fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color }}>{item[valueField]}</div>
          </div>
        );
      })}
    </div>
  );
}

function NoData({ tool }) {
  return (
    <SectionCard>
      <div style={{ textAlign: "center", padding: "32px 0", color: "var(--text-muted)" }}>
        <div style={{ fontSize: 13 }}>No {tool} data yet — scans run automatically on schedule.</div>
      </div>
    </SectionCard>
  );
}

function StatBadge({ value, label, color }) {
  return (
    <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius-lg)", padding: "14px 20px", minWidth: 90, flex: "1 1 90px" }}>
      <div style={{ fontSize: 26, fontWeight: 800, color, fontFamily: "var(--font-mono)", lineHeight: 1, marginBottom: 5 }}>{value}</div>
      <div style={{ fontSize: 10, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.1em", fontWeight: 700 }}>{label}</div>
    </div>
  );
}

function ScannedAt({ ts }) {
  if (!ts) return null;
  try {
    const cleaned = ts.replace(/\+00:00Z$/, '+00:00').replace(/Z$/, '');
    const d = new Date(cleaned);
    if (isNaN(d.getTime())) return null;
    const formatted = d.toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" }) + " GMT";
    return <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 16 }}>Last updated {formatted}</div>;
  } catch { return null; }
}


function useTool(slug, endpoint) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(() => {
    setLoading(true);
    fetch(`/api/clients/${slug}/${endpoint}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("stg_token") || ""}` },
    })
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug, endpoint]);
  useEffect(() => { load(); }, [load]);
  return { data, loading, reload: load };
}


// ── SEO History hook ─────────────────────────────────────────────────────────

function useSeoHistory(slug) {
  const [history, setHistory] = useState([]);
  useEffect(() => {
    fetch(`/api/clients/${slug}/seo/history`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("stg_token") || ""}` },
    })
      .then(r => r.json())
      .then(d => { if (Array.isArray(d)) setHistory(d); })
      .catch(() => {});
  }, [slug]);
  return history;
}

// ── Score sparkline ───────────────────────────────────────────────────────────

function ScoreSparkline({ points, color = "var(--accent)" }) {
  if (!points || points.length < 2) return null;
  const W = 180, H = 38, PAD = 4;
  const vals = points.map(p => p.v);
  const mn = Math.min(...vals), mx = Math.max(...vals);
  const range = mx - mn || 10;  // avoid flat-line divide-by-zero
  const xs = points.map((_, i) => PAD + (i / (points.length - 1)) * (W - PAD * 2));
  const ys = points.map(p => H - PAD - ((p.v - mn) / range) * (H - PAD * 2));
  const polyPts = xs.map((x, i) => `${x.toFixed(1)},${ys[i].toFixed(1)}`).join(" ");
  const last = points[points.length - 1];
  const prev = points[points.length - 2];
  const delta = last.v - prev.v;
  const deltaColor = delta > 0 ? "#30d158" : delta < 0 ? "#ff2d55" : "var(--text-muted)";

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <svg viewBox={`0 0 ${W} ${H}`} width={W} height={H} style={{ flexShrink: 0 }}>
        <polyline points={polyPts} fill="none" stroke={color} strokeWidth={2}
          strokeLinejoin="round" strokeLinecap="round" opacity={0.7} />
        <circle cx={xs[xs.length - 1].toFixed(1)} cy={ys[ys.length - 1].toFixed(1)} r={3} fill={color} />
      </svg>
      <div>
        <div style={{ fontSize: 15, fontWeight: 800, color, fontFamily: "var(--font-mono)", lineHeight: 1 }}>
          {last.v}
          {delta !== 0 && (
            <span style={{ fontSize: 10, marginLeft: 5, color: deltaColor, fontWeight: 600 }}>
              {delta > 0 ? "+" : ""}{delta}
            </span>
          )}
        </div>
        <div style={{ fontSize: 9, color: "var(--text-muted)", marginTop: 3, fontFamily: "var(--font-mono)" }}>
          {points[0].d} → {last.d}
        </div>
      </div>
    </div>
  );
}

// ── Score trend card ──────────────────────────────────────────────────────────

function SeoTrendCard({ history, metrics }) {
  if (!history || history.length < 2) return null;

  // Build {d, v} series for each metric, filtering out zero/missing values
  const series = metrics.map(({ label, color, extract }) => {
    const points = history
      .map(h => ({ d: h.date.slice(5), v: Math.round(extract(h) || 0) }))
      .filter(p => p.v > 0);
    return { label, color, points };
  }).filter(s => s.points.length >= 2);

  if (!series.length) return null;

  return (
    <SectionCard style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>
        Score trend — {history.length} scan{history.length !== 1 ? "s" : ""}
      </div>
      <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
        {series.map(({ label, color, points }) => (
          <div key={label} style={{ flex: "1 1 200px", minWidth: 200 }}>
            <div style={{ fontSize: 10, color: "var(--text-muted)", marginBottom: 6, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.07em" }}>{label}</div>
            <ScoreSparkline points={points} color={color} />
          </div>
        ))}
      </div>
    </SectionCard>
  );
}


// ── Domain Registrations ──────────────────────────────────────────────────────

function DomainRegistrationsSection({ slug }) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`/api/clients/${slug}/domain-expiry`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("stg_token") || ""}` },
    })
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  if (loading) return <div style={{ padding: 40, textAlign: "center" }}><span className="spinner" /></div>;
  if (!data?.available) return <NoData tool="domain expiry check" />;

  const domains = data.domains || [];

  const statusFor = (days) => {
    if (days === null || days === undefined) return { color: "#86868b", label: "Unknown" };
    if (days < 0)    return { color: "#ff2d55", label: "Expired" };
    if (days <= 30)  return { color: "#ff2d55", label: `${days}d` };
    if (days <= 90)  return { color: "#e6b800", label: `${days}d` };
    return { color: "#30d158", label: `${days}d` };
  };

  const issues = domains.filter(d => d.days_remaining !== null && d.days_remaining <= 90).length;

  return (
    <div>
      {/* Summary strip */}
      <div className="stat-tiles">{[
          { label: "Domains",       value: domains.length, tone:'accent' },
          { label: "Expiring soon", value: issues,         tone:issues > 0 ? 'red' : 'green' },
        ].map(({label,value,tone})=>(
          <div key={label} className="stat-card">
            <div className={`stat-value ${tone}`}>{value}</div>
            <div className="stat-label">{label}</div>
          </div>
        ))}
        {data.checked_at && (
          <div style={{ fontSize: 11, color: "var(--text-muted)", marginLeft: "auto", alignSelf: "center" }}>
            Last updated {new Date(data.checked_at).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" })} GMT
          </div>
        )}
      </div>

      {/* Domain cards */}
      {domains.length === 0 ? (
        <SectionCard><EmptyState message="No domains configured for this client." /></SectionCard>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {domains.map(d => {
            const { color, label: daysLabel } = statusFor(d.days_remaining);
            return (
              <SectionCard key={d.domain}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ width: 10, height: 10, borderRadius: "50%", background: color, flexShrink: 0 }} />
                    <div>
                      <div style={{ fontSize: 15, fontWeight: 700, color: "var(--text)", fontFamily: "var(--font-mono)" }}>{d.domain}</div>
                      {d.registrar && <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}>{d.registrar}</div>}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 24, flexWrap: "wrap", alignItems: "center" }}>
                    {d.expiry_date && (
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 600, marginBottom: 2 }}>Expires</div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)", fontFamily: "var(--font-mono)" }}>
                          {new Date(d.expiry_date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                        </div>
                      </div>
                    )}
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 600, marginBottom: 2 }}>Days Left</div>
                      <div style={{ fontSize: 20, fontWeight: 800, color, fontFamily: "var(--font-mono)", lineHeight: 1 }}>{daysLabel}</div>
                    </div>
                    <span style={{
                      fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 5,
                      background: `${color}20`, border: `1px solid ${color}60`, color,
                      fontFamily: "var(--font-mono)", whiteSpace: "nowrap",
                    }}>
                      {d.days_remaining === null ? "Unknown" : d.days_remaining < 0 ? "Expired" : d.days_remaining <= 30 ? "Critical" : d.days_remaining <= 90 ? "Warning" : "OK"}
                    </span>
                  </div>
                </div>
                {d.error && (
                  <div style={{ fontSize: 11, color: "#e6b800", marginTop: 8, padding: "6px 10px", background: "#e6b80010", borderRadius: 6, border: "1px solid #e6b80030" }}>
                    Could not retrieve WHOIS data: {d.error}
                  </div>
                )}
              </SectionCard>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── Certificates ──────────────────────────────────────────────────────────────

function CertsSection({ slug }) {
  const { data, loading } = useTool(slug, "certs");
  if (loading) return <div style={{ padding: 32, textAlign: "center" }}><span className="spinner" /></div>;
  if (!data?.available) return <NoData tool="certificate" />;
  const d = data.data;
  const expiry  = d?.expiry_checks || {};
  const ctLogs  = d?.ct_logs || {};
  const summary = d?.summary || {};
  const hosts   = Object.keys(expiry);
  const statusColor = (r) => r.expired ? "#ff2d55" : r.expiring_soon ? "#ff9f0a" : r.expiring_warning ? "#e6b800" : "#30d158";
  const statusLabel = (r) => r.expired ? "Expired" : r.expiring_soon ? `${r.days_remaining}d — Expiring Soon` : r.expiring_warning ? `${r.days_remaining}d — Expiring` : `${r.days_remaining}d`;
  return (
    <div>
      <ScannedAt ts={d?.scanned_at} />
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
        <StatBadge value={summary.total_checked || hosts.length} label="Checked" color="var(--accent)" />
        <StatBadge value={summary.expired || 0} label="Expired" color={summary.expired > 0 ? "#ff2d55" : "#30d158"} />
        <StatBadge value={summary.expiring_soon || 0} label="Expiring Soon" color={summary.expiring_soon > 0 ? "#ff9f0a" : "#30d158"} />
      </div>
      {hosts.length > 0 && (
        <SectionCard>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>SSL Certificate Expiry</div>
          {hosts.map((host, i) => {
            const r = expiry[host];
            return (
              <div key={host} style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 0", borderBottom: i < hosts.length - 1 ? "1px solid var(--border)" : "none" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontFamily: "var(--font-mono)", fontSize: 12, fontWeight: 600 }}>{host}</div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 1 }}>{r.issuer_org} · {r.common_name}</div>
                </div>
                <div style={{ textAlign: "right", flexShrink: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: statusColor(r) }}>{statusLabel(r)}</div>
                  <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>{(r.not_after || "").slice(0, 10)}</div>
                  {r.auto_renew ? <div style={{ fontSize: 9, fontWeight: 600, color: "#30d158", marginTop: 2 }}>↻ Auto-renews ({r.auto_renew_provider})</div>
                               : <div style={{ fontSize: 9, fontWeight: 600, color: "#e6b800", marginTop: 2 }}>⚠ Manual renewal</div>}
                </div>
              </div>
            );
          })}
        </SectionCard>
      )}
      {Object.entries(ctLogs).map(([domain, r]) => r.total > 0 && (
        <SectionCard key={domain}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <div style={{ fontFamily: "var(--font-mono)", fontWeight: 700, fontSize: 13 }}>{domain}</div>
            <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{r.total} certs in CT logs</div>
          </div>
          {(r.certs || []).slice(0, 5).map((c, i) => (
            <div key={i} style={{ padding: "5px 0", borderBottom: "1px solid var(--border)", display: "flex", gap: 8, fontSize: 11 }}>
              <span style={{ fontFamily: "var(--font-mono)", flex: 1 }}>{c.common_name}</span>
              <span style={{ color: "var(--text-muted)", flexShrink: 0 }}>{(c.not_after || "").slice(0, 10)}</span>
            </div>
          ))}
        </SectionCard>
      ))}
    </div>
  );
}


// ── SEO Section ──────────────────────────────────────────────────────────────

function ScoreRing({ score, label, size = 80 }) {
  const color = score >= 80 ? "#30d158" : score >= 60 ? "#e6b800" : "#ff2d55";
  const r = (size / 2) - 6;
  const circ = 2 * Math.PI * r;
  const dash = (score / 100) * circ;
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="var(--border)" strokeWidth={6} />
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={6}
          strokeDasharray={`${dash} ${circ}`} strokeLinecap="round" />
      </svg>
      <div style={{ marginTop: -size - 2, height: size, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div style={{ fontSize: size * 0.22, fontWeight: 800, color, fontFamily: "var(--font-mono)", lineHeight: 1 }}>{score}</div>
        <div style={{ fontSize: size * 0.13, color: "var(--text-muted)", fontWeight: 600, marginTop: 2 }}>/ 100</div>
      </div>
      <div style={{ fontSize: 11, color: "var(--text-muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.07em" }}>{label}</div>
    </div>
  );
}

function SeverityBadge({ severity }) {
  const map = {
    critical: { color: "#ff2d55", label: "Critical" },
    warning:  { color: "#e6b800", label: "Warning" },
    info:     { color: "#00d4ff", label: "Info" },
  };
  const { color, label } = map[severity] || map.info;
  return (
    <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 4,
      background: `${color}18`, border: `1px solid ${color}40`, color, whiteSpace: "nowrap" }}>
      {label}
    </span>
  );
}

function DomainSelector({ domains, selected, onChange }) {
  if (domains.length <= 1) return null;
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 20 }}>
      {domains.map(d => (
        <button className="btn btn-secondary btn-sm" aria-pressed={selected === d} key={d} onClick={() => onChange(d)}>{d}</button>
      ))}
    </div>
  );
}

function SeoSection({ slug }) {
  const { data, loading } = useTool(slug, "seo");
  const [domain, setDomain] = useState(null);
  const history = useSeoHistory(slug);

  const domains = data?.domains || [];
  const activeDomain = domain || domains[0] || null;
  const r = activeDomain ? data?.results?.[activeDomain] : null;
  const seo = r?.seo || {};

  if (loading) return <div style={{ padding: 40, textAlign: "center" }}><span className="spinner" /></div>;
  if (!data?.results || domains.length === 0) return <NoData tool="SEO" />;

  const checks = seo.checks || {};
  const meta   = seo.meta   || {};
  const issues = seo.issues || [];

  return (
    <div>
      <ScannedAt ts={data.scanned_at} />
      <SeoTrendCard history={history} metrics={[
        { label: "SEO Score", color: "#0a84ff", extract: h => h.seo_avg },
      ]} />
      {/* Summary scores */}
      <div style={{ display: "flex", gap: 24, flexWrap: "wrap", marginBottom: 24, justifyContent: "center" }}>
        <ScoreRing score={data.summary?.seo_score_avg || 0} label="SEO Score" />
      </div>
      <DomainSelector domains={domains} selected={activeDomain} onChange={setDomain} />
      {/* Checks grid */}
      <SectionCard>
        <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>Technical Checks</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 8 }}>
          {[
            { key: "has_title",       label: "Page Title" },
            { key: "has_description", label: "Meta Description" },
            { key: "has_canonical",   label: "Canonical Tag" },
            { key: "has_h1",          label: "H1 Heading" },
            { key: "one_h1",          label: "Single H1" },
            { key: "has_og_tags",     label: "Open Graph Tags" },
            { key: "has_viewport",    label: "Viewport Meta" },
            { key: "not_noindex",     label: "Not Noindex" },
            { key: "has_sitemap",     label: "Sitemap.xml" },
            { key: "has_robots_txt",  label: "Robots.txt" },
            { key: "https_redirect",  label: "HTTPS Redirect" },
            { key: "images_have_alt", label: "Image Alt Text" },
            { key: "has_schema_org",  label: "Schema.org Data" },
          ].map(({ key, label }) => (
            <div key={key} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0",
              borderBottom: "1px solid var(--border)" }}>
              <span style={{ fontSize: 14, color: checks[key] ? "#30d158" : "#ff2d55" }}>
                {checks[key] ? "✓" : "✗"}
              </span>
              <span style={{ fontSize: 12, flex: 1 }}>{label}</span>
            </div>
          ))}
        </div>
      </SectionCard>
      {/* Meta info */}
      {(meta.title || meta.description) && (
        <SectionCard>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>Page Meta</div>
          {meta.title && (
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontSize: 10, fontWeight: 600, color: "var(--text-muted)", marginBottom: 3 }}>TITLE ({meta.title_length} chars)</div>
              <div style={{ fontSize: 13, color: "var(--text)" }}>{meta.title}</div>
            </div>
          )}
          {meta.description && (
            <div>
              <div style={{ fontSize: 10, fontWeight: 600, color: "var(--text-muted)", marginBottom: 3 }}>DESCRIPTION ({meta.description_length} chars)</div>
              <div style={{ fontSize: 13, color: "var(--text)" }}>{meta.description}</div>
            </div>
          )}
          {meta.schema_types?.length > 0 && (
            <div style={{ marginTop: 10 }}>
              <div style={{ fontSize: 10, fontWeight: 600, color: "var(--text-muted)", marginBottom: 3 }}>SCHEMA.ORG TYPES</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {meta.schema_types.map(t => (
                  <span key={t} style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4,
                    background: "var(--surface2)", border: "1px solid var(--border)", fontFamily: "var(--font-mono)" }}>{t}</span>
                ))}
              </div>
            </div>
          )}
        </SectionCard>
      )}
      {/* Issues */}
      {issues.length > 0 && (
        <SectionCard>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>
            Issues ({issues.length})
          </div>
          {issues.map((issue, i) => (
            <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "8px 0",
              borderBottom: i < issues.length - 1 ? "1px solid var(--border)" : "none" }}>
              <SeverityBadge severity={issue.severity} />
              <div style={{ fontSize: 12, flex: 1, paddingTop: 1 }}>{issue.message}</div>
            </div>
          ))}
        </SectionCard>
      )}
    </div>
  );
}

// ── GEO Section ───────────────────────────────────────────────────────────────

function GeoSection({ slug }) {
  const { data, loading } = useTool(slug, "seo");
  const [domain, setDomain] = useState(null);
  const history = useSeoHistory(slug);

  const domains = data?.domains || [];
  const activeDomain = domain || domains[0] || null;
  const r   = activeDomain ? data?.results?.[activeDomain] : null;
  const geo = r?.geo || {};

  if (loading) return <div style={{ padding: 40, textAlign: "center" }}><span className="spinner" /></div>;
  if (!data?.results || domains.length === 0) return <NoData tool="GEO" />;

  const checks   = geo.checks          || {};
  const crawlers = geo.ai_crawlers     || {};
  const llms     = geo.llms_txt        || {};
  const recs     = geo.recommendations || [];
  const issues   = geo.issues          || [];

  return (
    <div>
      <ScannedAt ts={data.scanned_at} />
      <SeoTrendCard history={history} metrics={[
        { label: "GEO Score", color: "#bf5af2", extract: h => h.geo_avg },
      ]} />
      <div style={{ display: "flex", gap: 24, flexWrap: "wrap", marginBottom: 24, justifyContent: "center" }}>
        <ScoreRing score={data.summary?.geo_score_avg || 0} label="GEO Score" />
      </div>
      <DomainSelector domains={domains} selected={activeDomain} onChange={setDomain} />

      {/* AI Crawler access */}
      <SectionCard>
        <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>
          AI Crawler Access
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {Object.entries(crawlers).map(([bot, info], i, arr) => (
            <div key={bot} style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 0",
              borderBottom: i < arr.length - 1 ? "1px solid var(--border)" : "none" }}>
              <span style={{ fontSize: 13, color: info.blocked ? "#ff2d55" : "#30d158", flexShrink: 0 }}>
                {info.blocked ? "✗" : "✓"}
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 600 }}>{info.name}</div>
                <div style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>{bot}</div>
              </div>
              <span style={{ fontSize: 10, fontWeight: 600, color: info.mentioned ? "var(--accent)" : "var(--text-muted)",
                background: info.mentioned ? "var(--accent)18" : "var(--surface2)",
                border: `1px solid ${info.mentioned ? "var(--accent)40" : "var(--border)"}`,
                padding: "2px 7px", borderRadius: 4, whiteSpace: "nowrap" }}>
                {info.blocked ? "Blocked" : info.mentioned ? "Explicit Allow" : "Default Allow"}
              </span>
            </div>
          ))}
        </div>
      </SectionCard>

      {/* llms.txt */}
      <SectionCard>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em" }}>llms.txt</div>
          <span style={{ fontSize: 11, fontWeight: 700,
            color: llms.present ? "#30d158" : "#e6b800",
            background: llms.present ? "#30d15818" : "#e6b80018",
            border: `1px solid ${llms.present ? "#30d15840" : "#e6b80040"}`,
            padding: "2px 8px", borderRadius: 4 }}>
            {llms.present ? "Present" : "Not found"}
          </span>
        </div>
        <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
          {llms.present
            ? "An llms.txt file is present — AI models can discover structured information about this site."
            : "No llms.txt file found. This emerging standard helps AI models understand and reference your site."}
        </div>
        {llms.present && llms.content && (
          <pre style={{ marginTop: 10, fontSize: 11, color: "var(--text-muted)", background: "var(--surface2)",
            padding: "8px 12px", borderRadius: 6, overflow: "auto", maxHeight: 120,
            fontFamily: "var(--font-mono)", whiteSpace: "pre-wrap" }}>{llms.content}</pre>
        )}
      </SectionCard>

      {/* Schema AI types */}
      {geo.schema_ai?.length > 0 && (
        <SectionCard>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>AI-Relevant Schema Types</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {geo.schema_ai.map(t => (
              <span key={t} style={{ fontSize: 11, padding: "3px 10px", borderRadius: 4, fontWeight: 600,
                background: "#30d15818", border: "1px solid #30d15840", color: "#30d158",
                fontFamily: "var(--font-mono)" }}>{t}</span>
            ))}
          </div>
        </SectionCard>
      )}

      {/* Issues */}
      {issues.length > 0 && (
        <SectionCard>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>Issues</div>
          {issues.map((issue, i) => (
            <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "8px 0",
              borderBottom: i < issues.length - 1 ? "1px solid var(--border)" : "none" }}>
              <SeverityBadge severity={issue.severity} />
              <div style={{ fontSize: 12, flex: 1, paddingTop: 1 }}>{issue.message}</div>
            </div>
          ))}
        </SectionCard>
      )}

      {/* Recommendations */}
      {recs.length > 0 && (
        <SectionCard>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>
            Recommendations ({recs.length})
          </div>
          {recs.map((rec, i) => (
            <div key={i} style={{ padding: "10px 0", borderBottom: i < recs.length - 1 ? "1px solid var(--border)" : "none" }}>
              <div style={{ display: "flex", gap: 8, alignItems: "flex-start", marginBottom: rec.example ? 6 : 0 }}>
                <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 4, flexShrink: 0,
                  color: rec.priority === "high" ? "#ff9f0a" : "#00d4ff",
                  background: rec.priority === "high" ? "#ff9f0a18" : "#00d4ff18",
                  border: `1px solid ${rec.priority === "high" ? "#ff9f0a40" : "#00d4ff40"}` }}>
                  {rec.priority === "high" ? "High" : "Medium"}
                </span>
                <div style={{ fontSize: 12, flex: 1 }}>{rec.message}</div>
              </div>
              {rec.example && (
                <pre style={{ fontSize: 11, color: "var(--text-muted)", background: "var(--surface2)",
                  padding: "6px 10px", borderRadius: 6, overflow: "auto", marginTop: 4,
                  fontFamily: "var(--font-mono)", whiteSpace: "pre-wrap" }}>{rec.example}</pre>
              )}
            </div>
          ))}
        </SectionCard>
      )}
    </div>
  );
}

// ── Performance Section ───────────────────────────────────────────────────────

function PerformanceSection({ slug }) {
  const { data, loading } = useTool(slug, "seo");
  const [domain, setDomain]     = useState(null);
  const [strategy, setStrategy] = useState("mobile");
  const history = useSeoHistory(slug);

  const domains      = data?.domains || [];
  const activeDomain = domain || domains[0] || null;
  const r            = activeDomain ? data?.results?.[activeDomain] : null;
  const perf         = r?.performance?.[strategy] || {};
  const scores       = perf.scores        || {};
  const cwv          = perf.core_web_vitals || {};
  const audits       = perf.audits        || {};
  const opps         = perf.opportunities || [];

  if (loading) return <div style={{ padding: 40, textAlign: "center" }}><span className="spinner" /></div>;
  if (!data?.results || domains.length === 0) return <NoData tool="performance" />;

  const perfError = perf.error || null;

  const cwvColor = (val, thresholds) => {
    if (!val) return "var(--text-muted)";
    return val <= thresholds[0] ? "#30d158" : val <= thresholds[1] ? "#e6b800" : "#ff2d55";
  };

  return (
    <div>
      <ScannedAt ts={data.scanned_at} />
      <SeoTrendCard history={history} metrics={[
        { label: "Performance",    color: "#30d158", extract: h => {
          const vals = Object.values(h.scores || {}).map(s => s.performance || 0).filter(Boolean);
          return vals.length ? Math.round(vals.reduce((a, b) => a + b) / vals.length) : 0;
        }},
        { label: "Accessibility",  color: "#ff9f0a", extract: h => {
          const vals = Object.values(h.scores || {}).map(s => s.accessibility || 0).filter(Boolean);
          return vals.length ? Math.round(vals.reduce((a, b) => a + b) / vals.length) : 0;
        }},
        { label: "Best Practices", color: "#e6b800", extract: h => {
          const vals = Object.values(h.scores || {}).map(s => s.best_practices || 0).filter(Boolean);
          return vals.length ? Math.round(vals.reduce((a, b) => a + b) / vals.length) : 0;
        }},
      ]} />

      {/* Domain selector + strategy toggle */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <DomainSelector domains={domains} selected={activeDomain} onChange={setDomain} />
        <div className="segmented">
          {["mobile", "desktop"].map(s => (
            <button className="btn" aria-pressed={strategy === s} style={{ textTransform: "capitalize" }} key={s} onClick={() => setStrategy(s)}>{s}</button>
          ))}
        </div>
      </div>

      {/* Score rings or error */}
      {perfError ? (
        <SectionCard>
          <div style={{ textAlign: "center", padding: "20px 0", color: "var(--text-muted)" }}>
            <div style={{ fontSize: 13, marginBottom: 6 }}>Performance data unavailable for this domain</div>
            <div style={{ fontSize: 12, color: "var(--text-muted)" }}>This domain could not be measured on the last scan — it will be retried automatically.</div>
          </div>
        </SectionCard>
      ) : (
        <div style={{ display: "flex", gap: 40, flexWrap: "wrap", justifyContent: "space-evenly", marginBottom: 28 }}>
          <ScoreRing score={scores.performance    || 0} label="Performance" />
          <ScoreRing score={scores.best_practices || 0} label="Best Practices" />
          <ScoreRing score={scores.accessibility  || 0} label="Accessibility" />
        </div>
      )}

      {/* Core Web Vitals */}
      <SectionCard>
        <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>
          Core Web Vitals
          {cwv.overall && (
            <span style={{ marginLeft: 10, fontWeight: 700,
              color: cwv.overall === "FAST" ? "#30d158" : cwv.overall === "AVERAGE" ? "#e6b800" : "#ff2d55",
              fontSize: 10, padding: "2px 8px", borderRadius: 4,
              background: cwv.overall === "FAST" ? "#30d15818" : cwv.overall === "AVERAGE" ? "#e6b80018" : "#ff2d5518" }}>
              {cwv.overall}
            </span>
          )}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12 }}>
          {[
            { key: "lcp",  label: "LCP",  unit: "ms", desc: "Largest Contentful Paint", thresholds: [2500, 4000] },
            { key: "fid",  label: "FID",  unit: "ms", desc: "First Input Delay",         thresholds: [100,  300] },
            { key: "cls",  label: "CLS",  unit: "",   desc: "Cumulative Layout Shift",   thresholds: [0.1,  0.25] },
            { key: "fcp",  label: "FCP",  unit: "ms", desc: "First Contentful Paint",    thresholds: [1800, 3000] },
            { key: "ttfb", label: "TTFB", unit: "ms", desc: "Time to First Byte",        thresholds: [800,  1800] },
            { key: "inp",  label: "INP",  unit: "ms", desc: "Interaction to Next Paint", thresholds: [200,  500] },
          ].map(({ key, label, unit, desc, thresholds }) => {
            const val = cwv[key];
            const col = cwvColor(val, thresholds);
            return (
              <div key={key} style={{ padding: "10px 14px", background: "var(--surface2)", borderRadius: 8, border: "1px solid var(--border)" }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: col, fontFamily: "var(--font-mono)", lineHeight: 1 }}>
                  {val != null ? `${val}${unit}` : "—"}
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text)", marginTop: 3 }}>{label}</div>
                <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 1 }}>{desc}</div>
              </div>
            );
          })}
        </div>
      </SectionCard>

      {/* Audit timings */}
      {Object.values(audits).some(Boolean) && (
        <SectionCard>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>Timing Metrics</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 8 }}>
            {Object.entries(audits).filter(([,v]) => v).map(([key, val]) => (
              <div key={key} style={{ padding: "6px 0", borderBottom: "1px solid var(--border)" }}>
                <div style={{ fontSize: 10, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  {key.replace(/_/g, " ")}
                </div>
                <div style={{ fontSize: 13, fontWeight: 600, fontFamily: "var(--font-mono)", marginTop: 2 }}>{val}</div>
              </div>
            ))}
          </div>
        </SectionCard>
      )}

      {/* Opportunities */}
      {opps.length > 0 && (
        <SectionCard>
          <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>
            Improvement Opportunities
          </div>
          {opps.map((opp, i) => (
            <div key={opp.id} style={{ padding: "8px 0", borderBottom: i < opps.length - 1 ? "1px solid var(--border)" : "none" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                <div style={{ fontSize: 12, fontWeight: 600 }}>{opp.title}</div>
                {opp.savings_ms > 0 && (
                  <span style={{ fontSize: 11, fontWeight: 700, color: "#e6b800", whiteSpace: "nowrap",
                    background: "#e6b80018", border: "1px solid #e6b80040", padding: "2px 7px", borderRadius: 4 }}>
                    Save ~{Math.round(opp.savings_ms)}ms
                  </span>
                )}
              </div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 3 }}>{opp.description}</div>
            </div>
          ))}
        </SectionCard>
      )}
    </div>
  );
}


// ── Access Map ────────────────────────────────────────────────────────────────
// Shows visitor locations from website analytics tracker data

function AccessMapSection({ slug }) {
  const [data,       setData]       = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [days,       setDays]       = useState(30);
  const [domain,     setDomain]     = useState("");
  const [domains,    setDomains]    = useState([]);
  const [refreshMin, setRefreshMin] = useState(() => {
    const s = localStorage.getItem(`access_map_refresh_${slug}`);
    return s ? parseInt(s) : 15;
  });

  const load = useCallback(() => {
    setLoading(true);
    const domParam = domain ? `&domain=${encodeURIComponent(domain)}` : "";
    fetch(`/api/clients/${slug}/analytics?days=${days}${domParam}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("stg_token") || ""}` },
    })
      .then(r => r.json())
      .then(d => { setData(d); if (d.domains) setDomains(cleanDomains(d.domains)); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug, days, domain]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    localStorage.setItem(`access_map_refresh_${slug}`, refreshMin);
    if (!refreshMin) return;
    const iv = setInterval(load, refreshMin * 60 * 1000);
    return () => clearInterval(iv);
  }, [refreshMin, load, slug]);

  const locations = data?.summary?.locations || [];
  const hasData   = data?.available && data?.total > 0 && locations.length > 0;

  return (
    <div>
      {/* Controls */}
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center", marginBottom: 20 }}>
        <div className="segmented">
          {[{ v: 1, l: "24h" }, { v: 7, l: "7 days" }, { v: 30, l: "30 days" }, { v: 90, l: "90 days" }].map(({ v, l }) => (
            <button className="btn" aria-pressed={days === v} key={v} onClick={() => setDays(v)}>{l}</button>
          ))}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: "auto", fontSize: 12, color: "var(--text-muted)" }}>
          <span>Auto-refresh:</span>
          <select className="input-sm" value={refreshMin} onChange={e => setRefreshMin(parseInt(e.target.value))}>
            {[{ value: 0, label: "Off" }, { value: 5, label: "5 min" }, { value: 15, label: "15 min" }, { value: 30, label: "30 min" }].map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          <button className="btn btn-secondary btn-sm" onClick={load}>↻</button>
        </div>
      </div>

      {/* Domain filter */}
      {domains.length > 1 && (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
          <button className="btn btn-secondary btn-sm" aria-pressed={!domain} onClick={() => setDomain("")}>All Domains</button>
          {domains.map(d => (
            <button className="btn btn-secondary btn-sm" aria-pressed={domain === d} key={d} onClick={() => setDomain(d)}>{d}</button>
          ))}
        </div>
      )}

      {/* Summary stats */}
      {data?.available && (
        <div className="stat-tiles">{[
            { label: "Page views",   value: data.summary?.total_pageviews || 0, tone:'accent' },
            { label: "Sessions",     value: data.summary?.unique_sessions  || 0, tone:'green' },
            { label: "Locations",    value: locations.length,                    tone:'' },
          ].map(({label,value,tone})=>(
          <div key={label} className="stat-card">
            <div className={`stat-value ${tone}`}>{value}</div>
            <div className="stat-label">{label}</div>
          </div>
        ))}
        </div>
      )}

      {loading ? (
        <div style={{ padding: 48, textAlign: "center" }}><span className="spinner" /></div>
      ) : !hasData ? (
        <SectionCard>
          <EmptyState message={data?.available ? "No visitor location data for the selected period — install the tracking snippet to start collecting data." : "No analytics data yet — install the tracking snippet on the client website first."} />
        </SectionCard>
      ) : (
        <VisitorMap locations={locations} />
      )}
    </div>
  );
}


// ── Analytics Section ─────────────────────────────────────────────────────────

const ANALYTICS_REFRESH = [
  { value: 0,  label: "Off" },
  { value: 5,  label: "5 min" },
  { value: 15, label: "15 min" },
  { value: 30, label: "30 min" },
];

function VisitorMap({ locations }) {
  const mapRef     = useRef(null);
  const leafletRef = useRef(null);
  const circlesRef = useRef([]);
  const maxCount   = Math.max(1, ...locations.map(l => l.count));

  useEffect(() => {
    if (!mapRef.current || !window.L) return;
    const L = window.L;
    if (!leafletRef.current) {
      leafletRef.current = L.map(mapRef.current, {
        center: [30, 10], zoom: 2, minZoom: 2, maxZoom: 18,
        scrollWheelZoom: true, worldCopyJump: true,
      });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap contributors", maxZoom: 18,
      }).addTo(leafletRef.current);
      // Invert OSM tiles to maintain dark map appearance — no API key required
      const tilePane = leafletRef.current.getPane("tilePane");
      if (tilePane) tilePane.style.filter = "invert(1) hue-rotate(180deg) brightness(0.75) contrast(1.1)";
    }
    circlesRef.current.forEach(c => c.remove());
    circlesRef.current = [];
    locations.forEach(loc => {
      if (!loc.lat && !loc.lon) return;
      const radius = Math.max(8, Math.min(35, 8 + (loc.count / maxCount) * 27));
      const circle = L.circleMarker([loc.lat, loc.lon], {
        radius, color: "rgba(255,255,255,0.4)", weight: 1.5,
        fillColor: "var(--accent)", fillOpacity: 0.8,
      }).addTo(leafletRef.current);
      circle.bindPopup("<div style='font-family:sans-serif;font-size:13px'><strong>" +
        (loc.city || "") + (loc.city && loc.country ? ", " : "") + (loc.country || "Unknown") +
        "</strong><br/>" + loc.count + " visit" + (loc.count !== 1 ? "s" : "") + "</div>");
      circlesRef.current.push(circle);
    });
    setTimeout(() => leafletRef.current?.invalidateSize(), 100);
  }, [locations, maxCount]);

  useEffect(() => {
    return () => { if (leafletRef.current) { leafletRef.current.remove(); leafletRef.current = null; } };
  }, []);

  return <div ref={mapRef} style={{ height: 340, borderRadius: 10, border: "1px solid var(--border)", overflow: "hidden" }} />;
}

// ── Session feed ──────────────────────────────────────────────────────────────

function fmtDuration(s) {
  if (!s || s < 5) return null;
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60), sec = s % 60;
  return `${m}m ${sec > 0 ? sec + "s" : ""}`.trim();
}

function fmtRelTime(ts) {
  if (!ts) return "";
  try {
    const diff = Date.now() - new Date(ts).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1)   return "Just now";
    if (mins < 60)  return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24)   return `${hrs}h ago`;
    const days = Math.floor(hrs / 24);
    if (days === 1) return "Yesterday";
    if (days < 7)   return `${days} days ago`;
    return new Date(ts).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
  } catch { return ""; }
}

const EVENT_ICONS = {
  page:         { icon: "📄", label: "Page",           color: "var(--text-muted)" },
  click_phone:  { icon: "📞", label: "Phone click",    color: "#30d158" },
  click_email:  { icon: "✉️", label: "Email click",    color: "#30d158" },
  form_submit:  { icon: "✅", label: "Form submit",    color: "#30d158" },
  form_start:   { icon: "📝", label: "Form start",     color: "#e6b800" },
  download:     { icon: "⬇️", label: "Download",       color: "#00d4ff" },
  outbound:     { icon: "↗️", label: "Outbound",       color: "var(--text-muted)" },
  video_play:   { icon: "▶️", label: "Video play",     color: "#00d4ff" },
  content_copy: { icon: "📋", label: "Copied",         color: "var(--text-muted)" },
  rage_click:   { icon: "😤", label: "Rage click",     color: "#ff2d55" },
  dead_click:   { icon: "👻", label: "Dead click",     color: "#ff9f0a" },
  js_error:     { icon: "⚠️", label: "JS Error",       color: "#ff2d55" },
  page_404:     { icon: "🚫", label: "404",            color: "#ff2d55" },
  custom:           { icon: "⭐",  label: "Custom event",  color: "#bf5af2" },
  scroll_milestone:  { icon: "↕️",  label: "Scroll depth", color: "var(--accent)" },
  section_view:      { icon: "👁️",  label: "Section seen", color: "#00d4ff" },
};

// Event types that count as a conversion/goal (used to flag converting sessions
// in the Source Performance drill-down).
// Mirrors ANALYTICS_CONVERSION_TYPES in app.py so the drill-down matches the
// per-source conversion counts the backend reports.
const CONVERSION_EVENT_TYPES = new Set([
  "click_phone", "click_email", "form_submit", "form_start",
  "download", "outbound", "video_play", "content_copy", "custom",
]);

// ── Plain English insight summary ─────────────────────────────────────────────

const DAY_LABELS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

function generateInsights(s, days) {
  if (!s || !s.total_pageviews) return [];
  const lines = [];
  const period = days === 1 ? "today" : days === 7 ? "this week" : days === 30 ? "this month" : `the last ${days} days`;

  // Traffic volume
  const pv = s.total_pageviews, sess = s.unique_sessions;
  const ppp = sess > 0 ? (pv / sess).toFixed(1) : 0;
  lines.push(`Your site had ${pv.toLocaleString()} page view${pv !== 1 ? "s" : ""} across ${sess.toLocaleString()} session${sess !== 1 ? "s" : ""} ${period}, averaging ${ppp} pages per visit.`);

  // Top source
  const topSrc = s.traffic_sources?.[0];
  const src2   = s.traffic_sources?.[1];
  if (topSrc) {
    const lbl  = SOURCE_META[topSrc.source]?.label || topSrc.source;
    const lbl2 = src2 ? (SOURCE_META[src2.source]?.label || src2.source) : null;
    let sent = topSrc.source === "direct"
      ? `Most visitors found you directly — they already know your website address`
      : `Most visitors arrived from ${lbl} (${topSrc.count})`;
    if (lbl2) sent += `, with ${src2.count} coming from ${lbl2}`;
    lines.push(sent + ".");
  }

  // AI chatbot referrals — worth calling out specifically
  const aiTotal = (s.ai_sources || []).reduce((a, b) => a + b.count, 0);
  if (aiTotal > 0) {
    const aiNames = (s.ai_sources || []).slice(0, 2).map(a => a.source).join(" and ");
    lines.push(`${aiTotal} visitor${aiTotal !== 1 ? "s" : ""} arrived via AI chatbot referral (${aiNames}) — people are finding you through AI tools.`);
  }

  // Conversions
  const conv = s.conversions;
  if (conv?.total > 0) {
    const parts = [];
    if (conv.phone_clicks > 0) parts.push(`${conv.phone_clicks} phone call${conv.phone_clicks !== 1 ? "s" : ""}`);
    if (conv.form_submits  > 0) parts.push(`${conv.form_submits} form submission${conv.form_submits !== 1 ? "s" : ""}`);
    if (conv.downloads     > 0) parts.push(`${conv.downloads} download${conv.downloads !== 1 ? "s" : ""}`);
    if (parts.length > 0) {
      const rate = sess > 0 ? Math.round(conv.total / sess * 100) : 0;
      lines.push(`Visitors generated ${parts.join(" and ")} — a ${rate}% conversion rate.`);
    }
  }

  // Form abandonment
  if (conv?.form_starts > 0 && conv?.form_submits > 0) {
    const abandon = Math.round((1 - conv.form_submits / conv.form_starts) * 100);
    if (abandon > 50) {
      lines.push(`⚠ ${abandon}% of people who started a form didn't finish it — the form may be too long or have a technical issue worth investigating.`);
    }
  }

  // Return visitors
  const nvr = s.new_vs_returning;
  if (nvr && nvr.new + nvr.returning > 0) {
    const total = nvr.new + nvr.returning;
    const retPct = Math.round(nvr.returning / total * 100);
    if (retPct >= 30) {
      lines.push(`${retPct}% of visitors have been before — your site is bringing people back.`);
    } else if (retPct > 0) {
      lines.push(`${retPct}% of visitors are returning — there may be room to increase repeat engagement.`);
    }
  }

  // Peak day from heatmap
  if (s.heatmap?.length > 0) {
    const dayTotals = Array(7).fill(0);
    s.heatmap.forEach(h => { dayTotals[h.day] += h.count; });
    const peakDay = dayTotals.indexOf(Math.max(...dayTotals));
    lines.push(`Your busiest day is typically ${DAY_LABELS[peakDay]}.`);
  }

  // Scroll engagement (snippet v2.92+)
  if (s.scroll_funnel?.length) {
    const half = s.scroll_funnel.find(f => f.pct === 50);
    const full = s.scroll_funnel.find(f => f.pct === 100);
    if (half && sess > 0) {
      const halfPct = Math.round(half.sessions / sess * 100);
      if (halfPct < 40) {
        lines.push(`⚠ Only ${halfPct}% of visitors scroll past halfway — content below the fold may not be seen. Consider moving key messages higher on the page.`);
      } else if (full) {
        const fullPct = Math.round(full.sessions / sess * 100);
        if (fullPct > 50) lines.push(`${fullPct}% of visitors read to the bottom of the page — your content is holding attention well.`);
      }
    }
  }

  // Rage clicks / 404s
  if (conv?.rage_clicks > 0 || conv?.page_404s > 0) {
    const issues = [];
    if (conv.rage_clicks > 0) issues.push(`${conv.rage_clicks} rage click${conv.rage_clicks !== 1 ? "s" : ""} suggest something isn't responding as visitors expect`);
    if (conv.page_404s   > 0) issues.push(`${conv.page_404s} broken page${conv.page_404s !== 1 ? "s" : ""} may be affecting the experience`);
    lines.push(`⚠ ${issues.join(" and ")}.`);
  }

  return lines;
}

function InsightSummary({ s, days }) {
  const [expanded, setExpanded] = useState(false);
  const lines = generateInsights(s, days);
  if (!lines.length) return null;
  const shown = expanded ? lines : lines.slice(0, 3);
  return (
    <SectionCard style={{ borderLeft: "3px solid var(--accent)", marginBottom: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
        <div style={{ flex: 1 }}>
          <CardLabel>Summary</CardLabel>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {shown.map((line, i) => (
              <div key={i} style={{ fontSize: 13, color: line.startsWith("⚠") ? "#e6b800" : "var(--text)", lineHeight: 1.6 }}>
                {line}
              </div>
            ))}
          </div>
          {lines.length > 3 && (
            <button className="btn btn-quiet btn-sm" style={{ marginTop: 10 }} onClick={() => setExpanded(e => !e)}>
              {expanded ? "Show less ▲" : `Show ${lines.length - 3} more insight${lines.length - 3 !== 1 ? "s" : ""} ▼`}
            </button>
          )}
        </div>
      </div>
    </SectionCard>
  );
}

// ── Time-of-day heatmap ───────────────────────────────────────────────────────

const HOUR_LABELS = ["0000","0100","0200","0300","0400","0500","0600","0700","0800","0900","1000","1100","1200","1300","1400","1500","1600","1700","1800","1900","2000","2100","2200","2300"];
const DAY_SHORT   = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];

// Four equal 6-hour periods spanning the day — used for the heatmap header band
const HEATMAP_PERIODS = [
  { label: "Night",   range: "0000–0600", icon: "ti-moon-stars", bg: "rgba(70,90,210,0.09)",  fg: "#5060bb" },
  { label: "Morning", range: "0600–1200", icon: "ti-sunrise",     bg: "rgba(255,155,0,0.11)",  fg: "#b07000" },
  { label: "Day",     range: "1200–1800", icon: "ti-sun",         bg: "rgba(240,195,0,0.10)",  fg: "#907000" },
  { label: "Evening", range: "1800–0000", icon: "ti-sunset",      bg: "rgba(255,80,30,0.09)",  fg: "#b83a10" },
];

function HeatmapChart({ heatmap }) {
  if (!heatmap?.length) return null;
  // Build 7×24 grid, account for browser local timezone offset
  const tzOffset = new Date().getTimezoneOffset(); // minutes behind UTC
  const grid = Array.from({ length: 7 }, () => Array(24).fill(0));
  heatmap.forEach(({ day, hour, count }) => {
    let localHour = hour - Math.round(tzOffset / 60);
    let localDay  = day;
    if (localHour < 0)  { localHour += 24; localDay = (localDay + 6) % 7; }
    if (localHour >= 24){ localHour -= 24; localDay = (localDay + 1) % 7; }
    grid[localDay][localHour] += count;
  });
  const maxVal = Math.max(1, ...grid.flat());

  return (
    <SectionCard>
      <CardLabel>When people visit</CardLabel>
      <div style={{ overflowX: "auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "44px repeat(24, 1fr)", gap: 3, minWidth: 620 }}>

          {/* Row 1: Period band — four coloured segments, each spanning 6 hours */}
          <div /> {/* spacer for day-label column */}
          {HEATMAP_PERIODS.map((p, pi) => (
            <div key={pi} style={{
              gridColumn: "span 6",
              background: p.bg,
              borderRadius: 7,
              padding: "7px 4px 6px",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 1,
              marginBottom: 3,
            }}>
              <i className={`ti ${p.icon}`} style={{ fontSize: 16, color: p.fg }} />
              <span style={{ fontSize: 10, fontWeight: 700, color: p.fg, letterSpacing: "0.02em" }}>
                {p.label}
              </span>
              <span style={{ fontSize: 8, color: p.fg, opacity: 0.65, fontFamily: "var(--font-mono)" }}>
                {p.range}
              </span>
            </div>
          ))}

          {/* Rows 2–8: Day label + 24 cells per row */}
          {grid.map((row, di) => (
            <>{/* eslint-disable-next-line react/jsx-key */}
              <div style={{
                fontSize: 11, fontWeight: 700, fontFamily: "var(--font-mono)",
                color: "var(--text-muted)", display: "flex", alignItems: "center",
                justifyContent: "flex-end", paddingRight: 8, userSelect: "none",
              }}>
                {DAY_SHORT[di]}
              </div>
              {row.map((count, hi) => {
                const intensity = count / maxVal;
                const bg = count === 0
                  ? "var(--surface2)"
                  : `rgba(0,212,255,${0.12 + intensity * 0.88})`;
                return (
                  <div key={hi}
                    title={`${DAY_LABELS[di]} ${HOUR_LABELS[hi]} — ${count} visit${count !== 1 ? "s" : ""}`}
                    style={{ height: 20, borderRadius: 3, background: bg }} />
                );
              })}
            </>
          ))}
        </div>

        {/* Legend */}
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 12, justifyContent: "flex-end" }}>
          <span style={{ fontSize: 10, color: "var(--text-muted)" }}>Fewer visits</span>
          {[0.12, 0.34, 0.56, 0.78, 1.0].map((o, i) => (
            <div key={i} style={{ width: 16, height: 16, borderRadius: 3, background: `rgba(0,212,255,${o})` }} />
          ))}
          <span style={{ fontSize: 10, color: "var(--text-muted)" }}>More visits</span>
        </div>
      </div>
    </SectionCard>
  );
}

// ── New vs returning trend chart ──────────────────────────────────────────────

function ReturnTrendChart({ returnTrend }) {
  if (!returnTrend?.length) return null;
  const W = 600, H = 80;
  const maxVal = Math.max(1, ...returnTrend.map(d => d.new + d.returning));
  const pts = (key) => returnTrend.map((d, i) => {
    const x = (i / Math.max(returnTrend.length - 1, 1)) * W;
    const y = H - (d[key] / maxVal) * (H - 8);
    return [x.toFixed(1), y.toFixed(1)];
  });
  const newPts = pts("new"), retPts = pts("returning");
  const newLine = newPts.map(p => p.join(",")).join(" ");
  const retLine = retPts.map(p => p.join(",")).join(" ");
  const newArea = `M${newPts[0][0]},${H} ${newPts.map(p => `L${p[0]},${p[1]}`).join(" ")} L${newPts[newPts.length-1][0]},${H} Z`;
  const retArea = `M${retPts[0][0]},${H} ${retPts.map(p => `L${p[0]},${p[1]}`).join(" ")} L${retPts[retPts.length-1][0]},${H} Z`;

  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <CardLabel style={{ marginBottom: 0 }}>New vs Returning Visitors</CardLabel>
        <div style={{ display: "flex", gap: 14 }}>
          <span style={{ fontSize: 10, display: "flex", alignItems: "center", gap: 5 }}>
            <span style={{ width: 10, height: 3, background: "var(--accent)", display: "inline-block", borderRadius: 2 }} />
            New
          </span>
          <span style={{ fontSize: 10, display: "flex", alignItems: "center", gap: 5 }}>
            <span style={{ width: 10, height: 3, background: "#bf5af2", display: "inline-block", borderRadius: 2 }} />
            Returning
          </span>
        </div>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} preserveAspectRatio="none">
        <defs>
          <linearGradient id="newGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--accent)" stopOpacity="0.2" />
            <stop offset="100%" stopColor="var(--accent)" stopOpacity="0.02" />
          </linearGradient>
          <linearGradient id="retGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#bf5af2" stopOpacity="0.2" />
            <stop offset="100%" stopColor="#bf5af2" stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <path d={newArea} fill="url(#newGrad)" />
        <path d={retArea} fill="url(#retGrad)" />
        <polyline points={newLine} fill="none" stroke="var(--accent)" strokeWidth={2} strokeLinejoin="round" />
        <polyline points={retLine} fill="none" stroke="#bf5af2" strokeWidth={2} strokeLinejoin="round" strokeDasharray="4 3" />
      </svg>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4, fontSize: 9, color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>
        <span>{returnTrend[0]?.date}</span>
        <span>{returnTrend[returnTrend.length - 1]?.date}</span>
      </div>
    </SectionCard>
  );
}

// ── Page insights: low-engagement and hidden-gem pages ────────────────────────

function PageInsights({ insights }) {
  if (!insights?.length) return null;
  const lowEng = insights.filter(p => p.type === "low_engagement");
  const hidden  = insights.filter(p => p.type === "hidden_gem");
  return (
    <SectionCard>
      <CardLabel>Page Insights</CardLabel>
      {lowEng.length > 0 && (
        <div style={{ marginBottom: hidden.length > 0 ? 16 : 0 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#e6b800", marginBottom: 8 }}>
            ⚠ Low engagement — people aren't reading these pages
          </div>
          <ShowMore>{lowEng.map((p, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: i < lowEng.length - 1 ? "1px solid var(--border)" : "none" }}>
              <div style={{ fontSize: 12, flex: 1, minWidth: 0, color: "var(--text)" }}><PageName path={p.path} /></div>
              <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{p.views} views</div>
              <div style={{ width: 60, height: 5, background: "var(--surface2)", borderRadius: 3, overflow: "hidden" }}>
                <div style={{ width: `${p.avg_scroll}%`, height: "100%", background: "#e6b800", borderRadius: 3 }} />
              </div>
              <div style={{ fontSize: 10, color: "#e6b800", fontFamily: "var(--font-mono)", width: 38, textAlign: "right" }}>{p.avg_scroll}% scroll</div>
            </div>
          ))}</ShowMore>
        </div>
      )}
      {hidden.length > 0 && (
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#30d158", marginBottom: 8 }}>
            💎 Hidden gems — great content, not enough traffic
          </div>
          <ShowMore>{hidden.map((p, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: i < hidden.length - 1 ? "1px solid var(--border)" : "none" }}>
              <div style={{ fontSize: 12, flex: 1, minWidth: 0, color: "var(--text)" }}><PageName path={p.path} /></div>
              <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{p.views} views</div>
              <div style={{ width: 60, height: 5, background: "var(--surface2)", borderRadius: 3, overflow: "hidden" }}>
                <div style={{ width: `${p.avg_scroll}%`, height: "100%", background: "#30d158", borderRadius: 3 }} />
              </div>
              <div style={{ fontSize: 10, color: "#30d158", fontFamily: "var(--font-mono)", width: 38, textAlign: "right" }}>{p.avg_scroll}% scroll</div>
            </div>
          ))}</ShowMore>
        </div>
      )}
    </SectionCard>
  );
}

// ── Goal tracking ─────────────────────────────────────────────────────────────

const GOAL_OPTIONS = [
  { value: "click_phone",  label: "Phone click" },
  { value: "form_submit",  label: "Form submit" },
  { value: "click_email",  label: "Email click" },
  { value: "download",     label: "File download" },
  { value: "outbound",     label: "Outbound link click" },
];

function GoalTracker({ slug, conversions }) {
  const [goals,    setGoals]   = useState([]);
  const [editing,  setEditing] = useState(false);
  const [saving,   setSaving]  = useState(false);
  const [draft,    setDraft]   = useState([]);

  useEffect(() => {
    authFetch(`/api/clients/${slug}/dashboard-config`)
      .then(r => r.json())
      .then(d => { if (d?.goals) setGoals(d.goals); })
      .catch(() => {});
  }, [slug]);

  const openEdit = () => { setDraft(goals.length ? [...goals] : [{ name: "", event_type: "click_phone", target: 0 }]); setEditing(true); };

  const save = async () => {
    setSaving(true);
    try {
      const cfg = await authFetch(`/api/clients/${slug}/dashboard-config`).then(r => r.json());
      await authFetch(`/api/clients/${slug}/dashboard-config`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...cfg, goals: draft }),
      });
      setGoals(draft);
      setEditing(false);
    } catch (e) {}
    setSaving(false);
  };

  const convCount = (eventType) => {
    const card = CONVERSION_CARDS.find(c => c.eventType === eventType);
    return card ? (conversions?.[card.key] || 0) : 0;
  };

  if (!goals.length && !editing) return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <CardLabel style={{ marginBottom: 0 }}>Goals</CardLabel>
        <button className="btn btn-secondary btn-sm" onClick={openEdit}>+ Set goals</button>
      </div>
      <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 8 }}>
        Define conversion goals to track progress at a glance.
      </div>
    </SectionCard>
  );

  if (editing) return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <CardLabel style={{ marginBottom: 0 }}>Edit Goals</CardLabel>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => setEditing(false)}>Cancel</button>
          <button className="btn btn-primary btn-sm" onClick={save} disabled={saving}>{saving ? "Saving…" : "Save"}</button>
        </div>
      </div>
      {draft.map((g, i) => (
        <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
          <input className="input-sm" value={g.name} onChange={e => { const d=[...draft]; d[i]={...d[i],name:e.target.value}; setDraft(d); }}
            placeholder="Goal name" style={{ flex: 2 }} />
          <select className="input-sm" value={g.event_type} onChange={e => { const d=[...draft]; d[i]={...d[i],event_type:e.target.value}; setDraft(d); }}
            style={{ flex: 2 }}>
            {GOAL_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <input className="input-sm" type="number" value={g.target || ""} onChange={e => { const d=[...draft]; d[i]={...d[i],target:parseInt(e.target.value)||0}; setDraft(d); }}
            placeholder="Target" min="0" style={{ width: 70 }} />
          <button className="btn btn-quiet btn-icon" onClick={() => setDraft(d => d.filter((_,j) => j !== i))}>×</button>
        </div>
      ))}
      <button className="btn btn-secondary btn-sm" style={{ marginTop: 4 }}
        onClick={() => setDraft(d => [...d, { name: "", event_type: "click_phone", target: 0 }])}>
        + Add goal
      </button>
    </SectionCard>
  );

  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <CardLabel style={{ marginBottom: 0 }}>Goals</CardLabel>
        <button className="btn btn-secondary btn-sm" onClick={openEdit}>Edit</button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12 }}>
        {goals.map((g, i) => {
          const count   = convCount(g.event_type);
          const pct     = g.target > 0 ? Math.min(100, Math.round(count / g.target * 100)) : null;
          const onTrack = pct !== null && pct >= 80;
          const color   = pct === null ? "var(--accent)" : pct >= 100 ? "#30d158" : pct >= 60 ? "#e6b800" : "#ff2d55";
          return (
            <div key={i} style={{ background: "var(--surface2)", border: `1px solid ${color}30`, borderRadius: 8, padding: "12px 14px" }}>
              <div style={{ fontSize: 10, color: "var(--text-muted)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 6 }}>{g.name || g.event_type}</div>
              <div style={{ fontSize: 28, fontWeight: 800, color, fontFamily: "var(--font-mono)", lineHeight: 1 }}>{count}</div>
              {g.target > 0 && (
                <>
                  <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 4 }}>of {g.target} target</div>
                  <div style={{ height: 4, background: "var(--surface)", borderRadius: 2, marginTop: 8, overflow: "hidden" }}>
                    <div style={{ width: `${pct}%`, height: "100%", background: color, borderRadius: 2, transition: "width 0.4s ease" }} />
                  </div>
                  <div style={{ fontSize: 10, fontWeight: 700, color, marginTop: 4 }}>
                    {pct >= 100 ? "✓ Target met" : `${pct}% ${onTrack ? "— on track" : "— behind"}`}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </SectionCard>
  );
}

// ── Core Web Vitals panel ─────────────────────────────────────────────────────

const CWV_METRICS = [
  {
    key: "lcp", label: "LCP", name: "Largest Contentful Paint",
    unit: "ms", decimals: 0,
    good: 2500, poor: 4000,
    desc: "How quickly the main content loads. Google's most important ranking signal.",
    fmt: v => v >= 1000 ? (v/1000).toFixed(2) + "s" : v + "ms",
  },
  {
    key: "fcp", label: "FCP", name: "First Contentful Paint",
    unit: "ms", decimals: 0,
    good: 1800, poor: 3000,
    desc: "When the first content appears on screen.",
    fmt: v => v >= 1000 ? (v/1000).toFixed(2) + "s" : v + "ms",
  },
  {
    key: "inp", label: "INP", name: "Interaction to Next Paint",
    unit: "ms", decimals: 0,
    good: 200, poor: 500,
    desc: "How quickly the page responds to clicks and taps.",
    fmt: v => v + "ms",
  },
  {
    key: "cls", label: "CLS", name: "Cumulative Layout Shift",
    unit: "", decimals: 3,
    good: 0.1, poor: 0.25,
    desc: "How much the page jumps around while loading. Affects usability and ranking.",
    fmt: v => v.toFixed(3),
  },
  {
    key: "ttfb", label: "TTFB", name: "Time to First Byte",
    unit: "ms", decimals: 0,
    good: 800, poor: 1800,
    desc: "Server response time. Affected by hosting quality and server location.",
    fmt: v => v >= 1000 ? (v/1000).toFixed(2) + "s" : v + "ms",
  },
];

function cwvRating(metric, value) {
  if (value === null || value === undefined) return "no-data";
  return value <= metric.good ? "good" : value <= metric.poor ? "needs-improvement" : "poor";
}

const CWV_COLORS = {
  "good":             "#30d158",
  "needs-improvement": "#e6b800",
  "poor":             "#ff2d55",
  "no-data":          "var(--text-muted)",
};

function CoreWebVitalsPanel({ cwv }) {
  if (!cwv || cwv.sample_n === 0) return (
    <SectionCard>
      <CardLabel>Core Web Vitals</CardLabel>
      <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
        No data yet — Core Web Vitals will appear here once the updated snippet has collected enough engagement events.
      </div>
    </SectionCard>
  );

  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
        <CardLabel style={{ marginBottom: 0 }}>Core Web Vitals</CardLabel>
        <div style={{ fontSize: 11, color: "var(--text-muted)" }}>
          p75 real-user measurements · {cwv.sample_n} sample{cwv.sample_n !== 1 ? "s" : ""} · not lab scores
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12, marginBottom: 16 }}>
        {CWV_METRICS.map(m => {
          const val    = cwv[m.key];
          const rating = cwvRating(m, val);
          const color  = CWV_COLORS[rating];
          return (
            <div key={m.key} style={{ background: "var(--surface2)", border: `1px solid ${color}30`, borderRadius: 8, padding: "12px 14px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                <span style={{ fontSize: 10, fontWeight: 700, fontFamily: "var(--font-mono)", color: "var(--text-muted)" }}>{m.label}</span>
                <span style={{ fontSize: 9, fontWeight: 700, color, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                  {rating === "good" ? "Good" : rating === "needs-improvement" ? "OK" : rating === "poor" ? "Poor" : "—"}
                </span>
              </div>
              <div style={{ fontSize: 26, fontWeight: 800, color, fontFamily: "var(--font-mono)", lineHeight: 1, marginBottom: 4 }}>
                {val !== null && val !== undefined ? m.fmt(val) : "—"}
              </div>
              <div style={{ fontSize: 10, color: "var(--text-muted)", lineHeight: 1.4 }}>{m.name}</div>
              {val !== null && val !== undefined && (
                <div style={{ marginTop: 8, height: 4, background: "var(--surface)", borderRadius: 2, overflow: "hidden" }}>
                  <div style={{ width: `${Math.min(100, (val / m.poor) * 100)}%`, height: "100%", background: color, borderRadius: 2 }} />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* Threshold reference */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: 10, color: "var(--text-muted)", paddingTop: 10, borderTop: "1px solid var(--border)" }}>
        <span>Thresholds:</span>
        {["good", "needs-improvement", "poor"].map(r => (
          <span key={r} style={{ color: CWV_COLORS[r], fontWeight: 600 }}>
            {r === "good" ? "✓ Good" : r === "needs-improvement" ? "⚠ Needs work" : "✗ Poor"}
          </span>
        ))}
        <span style={{ marginLeft: "auto" }}>LCP &lt;2.5s · CLS &lt;0.1 · INP &lt;200ms</span>
      </div>
    </SectionCard>
  );
}

// ── First-touch attribution panel ─────────────────────────────────────────────

function FirstTouchPanel({ firstTouchSources }) {
  if (!firstTouchSources?.length) return null;
  const total = firstTouchSources.reduce((a, s) => a + s.count, 0);
  return (
    <SectionCard>
      <CardLabel>First-Touch Attribution</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        Which channel originally brought visitors who went on to convert — not where they came from on the day they converted.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <ShowMore>{firstTouchSources.map((src, i) => {
          const meta = SOURCE_META[src.source] || { label: src.source, color: "#86868b" };
          const pct  = Math.round(src.count / total * 100);
          return (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <SourcePill source={src.source} />
              <div style={{ flex: 1, height: 8, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                <div style={{ width: `${pct}%`, height: "100%", background: meta.color, borderRadius: 4 }} />
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color: meta.color, minWidth: 28, textAlign: "right" }}>{src.count}</div>
              <div style={{ fontSize: 10, color: "var(--text-muted)", minWidth: 32, textAlign: "right" }}>{pct}%</div>
            </div>
          );
        })}</ShowMore>
      </div>
      <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 10 }}>
        Based on {total} converting session{total !== 1 ? "s" : ""}
      </div>
    </SectionCard>
  );
}


// ── Scroll depth funnel ────────────────────────────────────────────────────────
// Renders when the backend supplies s.scroll_funnel (requires app.py to process
// scroll_milestone events from snippet v2.92+).
// Expected shape: [{pct: 25, sessions: N}, {pct: 50, sessions: N}, ...]

function ScrollFunnelPanel({ funnel }) {
  if (!funnel?.length) return null;
  const maxSessions = funnel[0]?.sessions;
  if (!maxSessions) return null;
  const STAGE_LABEL = { 25: "¼ page", 50: "½ page", 75: "¾ page", 100: "Full page" };
  const stageColor  = (n) => {
    const r = n / maxSessions;
    return r > 0.6 ? "#30d158" : r > 0.35 ? "#e6b800" : "#ff2d55";
  };
  return (
    <SectionCard>
      <CardLabel>Scroll Depth Funnel</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 16 }}>
        How far visitors scroll through your pages — each bar shows sessions that reached that depth milestone.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {funnel.map((f, i) => {
          const barPct  = Math.round((f.sessions / maxSessions) * 100);
          const color   = stageColor(f.sessions);
          const prev    = funnel[i - 1];
          const dropPct = prev ? Math.round((1 - f.sessions / prev.sessions) * 100) : 0;
          return (
            <div key={f.pct}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 62, flexShrink: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color }}>{f.pct}%</div>
                  <div style={{ fontSize: 9, color: "var(--text-muted)", marginTop: 1 }}>{STAGE_LABEL[f.pct] || ""}</div>
                </div>
                <div style={{ flex: 1, height: 12, background: "var(--surface2)", borderRadius: 6, overflow: "hidden" }}>
                  <div style={{ width: `${barPct}%`, height: "100%", background: color, borderRadius: 6, transition: "width 0.4s ease" }} />
                </div>
                <div style={{ width: 50, textAlign: "right", fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color }}>{f.sessions.toLocaleString()}</div>
                <div style={{ width: 36, textAlign: "right", fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>{barPct}%</div>
              </div>
              {dropPct > 0 && (
                <div style={{ display: "flex", alignItems: "center", gap: 5, marginLeft: 72, marginTop: 2, marginBottom: 2 }}>
                  <div style={{ width: 1, height: 10, background: "var(--border)" }} />
                  <div style={{ fontSize: 10, color: dropPct > 25 ? "#ff2d55" : "var(--text-muted)" }}>
                    {dropPct}% left before reaching this depth
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </SectionCard>
  );
}

// ── Named section visibility ──────────────────────────────────────────────────
// Renders when the backend supplies s.section_views (requires app.py to process
// section_view events from snippet v2.92+ and data-cv-section attributes on the
// client site).
// Expected shape: [{section: "hero", count: N}, ...]

function SectionViewsPanel({ sectionViews }) {
  if (!sectionViews?.length) return null;
  const maxCount = sectionViews[0]?.count || 1;
  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 8 }}>
        <CardLabel style={{ marginBottom: 0 }}>Section Visibility</CardLabel>
        <div style={{ fontSize: 10, color: "var(--text-muted)" }}>
          Track sections with{" "}
          <code style={{ fontFamily: "var(--font-mono)", background: "var(--surface2)", padding: "1px 5px", borderRadius: 3, fontSize: 10 }}>
            data-cv-section="name"
          </code>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <ShowMore>{sectionViews.map((sv, i) => {
          const barPct  = Math.round((sv.count / maxCount) * 100);
          const opacity = 0.3 + (barPct / 100) * 0.7;
          return (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--accent)", flexShrink: 0, opacity }} />
              <div style={{ width: 110, fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--text)", flexShrink: 0,
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={sv.section}>
                {sv.section}
              </div>
              <div style={{ flex: 1, height: 8, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                <div style={{ width: `${barPct}%`, height: "100%", background: "var(--accent)", borderRadius: 4, transition: "width 0.4s ease" }} />
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color: "var(--accent)", width: 40, textAlign: "right" }}>
                {sv.count.toLocaleString()}
              </div>
            </div>
          );
        })}</ShowMore>
      </div>
    </SectionCard>
  );
}

// ── Last-touch attribution ────────────────────────────────────────────────────
// Mirrors FirstTouchPanel for the most recent session channel before conversion.
// Requires app.py to extract last_touch from the payload (snippet v2.92+).
// Expected shape: [{source: "google_organic", count: N}, ...]

function LastTouchPanel({ lastTouchSources }) {
  if (!lastTouchSources?.length) return null;
  const total = lastTouchSources.reduce((a, s) => a + s.count, 0);
  return (
    <SectionCard>
      <CardLabel>Last-Touch Attribution</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        Which channel visitors came from on the day they converted — not where they originally discovered you.
        Compare with First-Touch above to see whether the channel that drives discovery is also the one that closes.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <ShowMore>{lastTouchSources.map((src, i) => {
          const meta = SOURCE_META[src.source] || { label: src.source, color: "#86868b" };
          const pct  = Math.round(src.count / total * 100);
          return (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <SourcePill source={src.source} />
              <div style={{ flex: 1, height: 8, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                <div style={{ width: `${pct}%`, height: "100%", background: meta.color, borderRadius: 4 }} />
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color: meta.color, minWidth: 28, textAlign: "right" }}>{src.count}</div>
              <div style={{ fontSize: 10, color: "var(--text-muted)", minWidth: 32, textAlign: "right" }}>{pct}%</div>
            </div>
          );
        })}</ShowMore>
      </div>
      <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 10 }}>
        Based on {total} converting session{total !== 1 ? "s" : ""}
      </div>
    </SectionCard>
  );
}

// ── JS errors panel with expandable stack traces ──────────────────────────────
// Replaces the inline JS errors block. Snippet v2.92+ adds error_stack (first
// 500 chars of the stack trace). Click an error row to expand it.

function JsErrorsPanel({ errors }) {
  const [expandedIdx, setExpandedIdx] = useState(null);
  if (!errors?.length) return null;
  return (
    <SectionCard>
      <CardLabel>JavaScript Errors</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 12 }}>
        These errors are occurring in visitors' browsers — each one may be costing conversions.
        {errors.some(e => e.stack) && " Click an error to see its stack trace."}
      </div>
      <ShowMore>{errors.map((err, i) => {
        const isOpen   = expandedIdx === i;
        const hasStack = !!err.stack;
        return (
          <div key={i}
            onClick={() => hasStack && setExpandedIdx(isOpen ? null : i)}
            style={{
              marginBottom: 6, padding: "8px 10px",
              background: "rgba(255,45,85,0.05)",
              border: `1px solid ${isOpen ? "rgba(255,45,85,0.4)" : "rgba(255,45,85,0.2)"}`,
              borderRadius: 7,
              cursor: hasStack ? "pointer" : "default",
              transition: "border-color 0.15s",
            }}
          >
            <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
              <span style={{ fontSize: 12, flexShrink: 0 }}>⚠️</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--text)", wordBreak: "break-all" }}>{err.msg}</div>
                {(err.src || err.line) && (
                  <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 3, fontFamily: "var(--font-mono)" }}>
                    {err.src}{err.line ? `:${err.line}` : ""}
                  </div>
                )}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#ff2d55", fontFamily: "var(--font-mono)" }}>{err.count}×</div>
                {hasStack && (
                  <span style={{ fontSize: 10, color: "var(--text-muted)", transform: `rotate(${isOpen ? "180deg" : "0"})`, transition: "transform 0.2s", display: "inline-block" }}>▾</span>
                )}
              </div>
            </div>
            {isOpen && err.stack && (
              <pre style={{
                marginTop: 10, padding: "8px 10px", fontSize: 10, fontFamily: "var(--font-mono)",
                background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 6,
                color: "var(--text-muted)", overflow: "auto", whiteSpace: "pre-wrap", wordBreak: "break-all",
                lineHeight: 1.6, maxHeight: 200,
              }}>{err.stack}</pre>
            )}
          </div>
        );
      })}</ShowMore>
    </SectionCard>
  );
}

const SESSION_PAGE = 25;
const SESSION_FIRST = 5;

// ── Conversion session list ───────────────────────────────────────────────────
// Compact session list filtered to sessions containing a specific event type.
// Shows visitor, the matching event details, journey, source, and time.

function ConversionSessionList({ sessions, eventType }) {
  const [expanded, setExpanded] = useState(null);
  const meta = EVENT_ICONS[eventType] || EVENT_ICONS.page;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <ShowMore>{sessions.map((sess, i) => {
        const isOpen   = expanded === i;
        const matchEvt = (sess.events || []).filter(e => e.type === eventType);
        const who      = sess.company_hint || (sess.city ? `${sess.city}${sess.country ? ", " + sess.country : ""}` : sess.country || "Unknown visitor");
        const dur      = fmtDuration(sess.duration_s);

        return (
          <div key={sess.session_id || i}
            onClick={() => setExpanded(isOpen ? null : i)}
            style={{
              padding: "10px 12px", borderRadius: 8, cursor: "pointer",
              background: isOpen ? "var(--surface2)" : "var(--surface)",
              border: `1px solid ${isOpen ? meta.color + "40" : "var(--border)"}`,
              transition: "all 0.15s",
            }}
          >
            {/* Row */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              {/* Identity */}
              <div style={{ flex: "1 1 160px", minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {sess.company_hint ? "🏢 " : "👤 "}{who}
                </div>
                <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>{fmtRelTime(sess.ts)}</div>
              </div>

              {/* Conversion event detail — the specific action this visitor took */}
              <div style={{ flex: "2 1 200px", minWidth: 0 }}>
                {matchEvt.map((ev, ei) => (
                  <div key={ei} style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: ei < matchEvt.length - 1 ? 3 : 0 }}>
                    <span style={{ fontSize: 12 }}>{meta.icon}</span>
                    <span style={{
                      fontSize: 11, fontFamily: "var(--font-mono)",
                      color: meta.color, fontWeight: 600,
                      overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                    }}>
                      {ev.path || eventType}
                    </span>
                  </div>
                ))}
              </div>

              {/* Metadata */}
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                <SourcePill source={sess.source} />
                {dur && <span style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>{dur}</span>}
                <span style={{ fontSize: 10, color: "var(--text-muted)" }}>{sess.page_count}p</span>
                <span style={{ fontSize: 10, color: "var(--text-muted)", transform: `rotate(${isOpen ? "180deg" : "0"})`, transition: "transform 0.2s" }}>▾</span>
              </div>
            </div>

            {/* Expanded: full journey with conversion highlighted */}
            {isOpen && (
              <div style={{ marginTop: 12, paddingTop: 12, borderTop: `1px solid ${meta.color}30` }}>
                <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 12 }}>
                  {sess.company_hint && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Organisation</span><strong>{sess.company_hint}</strong></div>}
                  {sess.city && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Location</span><strong>{sess.city}{sess.country ? `, ${sess.country}` : ""}</strong></div>}
                  <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Device</span><strong style={{ textTransform: "capitalize" }}>{sess.device || "—"} · {sess.browser || "—"}</strong></div>
                  {sess.timezone && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Timezone</span><strong>{sess.timezone}</strong></div>}
                  {dur && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Time on site</span><strong>{dur}</strong></div>}
                </div>
                {/* Journey with conversion events highlighted */}
                {sess.events?.length > 0 && (
                  <div>
                    <div style={{ fontSize: 10, color: "var(--text-muted)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 8 }}>Journey</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                      {sess.events.map((ev, ei) => {
                        const evMeta    = EVENT_ICONS[ev.type] || EVENT_ICONS.page;
                        const isMatch   = ev.type === eventType;
                        return (
                          <div key={ei} style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                            <span style={{ fontSize: 12, flexShrink: 0, marginTop: 1 }}>{evMeta.icon}</span>
                            <div style={{
                              fontSize: 11, padding: "3px 10px", borderRadius: 5, flex: 1,
                              background: isMatch ? `${meta.color}15` : "var(--surface)",
                              border: `1px solid ${isMatch ? meta.color + "50" : "var(--border)"}`,
                              color: isMatch ? meta.color : evMeta.color,
                              fontFamily: ev.type === "page" ? "var(--font-mono)" : "inherit",
                              fontWeight: isMatch ? 700 : 400,
                            }}>
                              {ev.type !== "page" && <span style={{ marginRight: 6 }}>{evMeta.label}</span>}
                              {ev.path && <span style={{ opacity: ev.type === "page" ? 1 : 0.8 }}>{ev.path}</span>}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}</ShowMore>
    </div>
  );
}


// ── Source performance ──────────────────────────────────────────────────────────
// Ties traffic volume to outcomes: for each source, how many sessions, how many
// converted, and the conversion rate. Click a source to drill into the actual
// converting sessions it produced.

function SourcePerformancePanel({ sourcePerformance, sessions }) {
  const [openSrc, setOpenSrc] = useState(null);
  if (!sourcePerformance?.length) return null;

  const withConv = sourcePerformance.filter(x => x.conversions > 0);
  const maxSessions = Math.max(1, ...sourcePerformance.map(x => x.sessions));
  const bestRate    = Math.max(0, ...sourcePerformance.map(x => x.rate));

  return (
    <SectionCard>
      <CardLabel>Source Performance</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        Not just how much traffic each channel sends, but how much of it converts. Click a source to see the sessions that converted.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <ShowMore>{sourcePerformance.map((row, i) => {
          const meta    = SOURCE_META[row.source] || { label: row.source, color: "#86868b" };
          const pct     = (row.sessions / maxSessions) * 100;
          const isOpen  = openSrc === row.source;
          const canOpen = row.conversions > 0;
          const isBest  = row.rate > 0 && row.rate === bestRate;
          const filtered = (sessions || []).filter(se =>
            (se.source || "direct") === row.source &&
            (se.events || []).some(e => CONVERSION_EVENT_TYPES.has(e.type))
          );
          return (
            <div key={row.source || i}>
              <div
                onClick={() => canOpen && setOpenSrc(isOpen ? null : row.source)}
                style={{
                  display: "flex", alignItems: "center", gap: 10, padding: "8px 6px",
                  borderRadius: 7, cursor: canOpen ? "pointer" : "default",
                  background: isOpen ? "var(--surface2)" : "transparent",
                  transition: "background 0.15s",
                }}
              >
                <div style={{ width: 96, flexShrink: 0 }}><SourcePill source={row.source} /></div>
                <div style={{ flex: 1, height: 7, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                  <div style={{ width: `${pct}%`, height: "100%", background: meta.color, borderRadius: 4 }} />
                </div>
                <div style={{ width: 52, textAlign: "right", fontSize: 11, color: "var(--text-muted)", fontFamily: "var(--font-mono)" }} title="Sessions">
                  {row.sessions}
                </div>
                <div style={{ width: 44, textAlign: "right", fontSize: 12, fontWeight: 700, color: row.conversions > 0 ? "#30d158" : "var(--text-muted)", fontFamily: "var(--font-mono)" }} title="Conversions">
                  {row.conversions}
                </div>
                <div style={{
                  width: 58, textAlign: "right", fontSize: 11, fontWeight: 700, fontFamily: "var(--font-mono)",
                  color: row.rate >= 5 ? "#30d158" : row.rate > 0 ? "#e6b800" : "var(--text-muted)",
                }} title="Conversion rate">
                  {row.rate}%{isBest ? " ★" : ""}
                </div>
                <span style={{ width: 14, textAlign: "center", fontSize: 10, color: "var(--text-muted)", opacity: canOpen ? 1 : 0, transform: `rotate(${isOpen ? "180deg" : "0"})`, transition: "transform 0.2s" }}>▾</span>
              </div>
              {isOpen && (
                <div style={{ margin: "4px 0 10px", padding: "10px", background: "var(--surface)", border: `1px solid ${meta.color}30`, borderRadius: 8 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: meta.color, marginBottom: 10 }}>
                    {filtered.length} converting session{filtered.length !== 1 ? "s" : ""} from {meta.label}
                  </div>
                  {filtered.length ? <SourceConvSessions sessions={filtered} />
                    : <div style={{ fontSize: 11, color: "var(--text-muted)" }}>Session detail not available — data may predate the latest snippet.</div>}
                </div>
              )}
            </div>
          );
        })}</ShowMore>
      </div>
      <div style={{ display: "flex", gap: 16, marginTop: 12, paddingTop: 10, borderTop: "1px solid var(--border)", fontSize: 10, color: "var(--text-muted)" }}>
        <span>Columns: sessions · conversions · rate</span>
        {withConv.length === 0 && <span>No conversions attributed to a source yet.</span>}
      </div>
    </SectionCard>
  );
}

// Compact converting-session list used inside the Source Performance drill-down.
function SourceConvSessions({ sessions }) {
  const [open, setOpen] = useState(null);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <ShowMore>{sessions.map((sess, i) => {
        const isOpen = open === i;
        const who    = sess.company_hint || (sess.city ? `${sess.city}${sess.country ? ", " + sess.country : ""}` : sess.country || "Unknown visitor");
        const convs  = (sess.events || []).filter(e => CONVERSION_EVENT_TYPES.has(e.type));
        return (
          <div key={sess.session_id || i}
            onClick={() => setOpen(isOpen ? null : i)}
            style={{ padding: "8px 10px", borderRadius: 7, cursor: "pointer",
              background: isOpen ? "var(--surface2)" : "var(--surface)", border: "1px solid var(--border)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <div style={{ flex: "1 1 150px", minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {sess.company_hint ? "🏢 " : "👤 "}{who}
                </div>
                <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 1 }}>{fmtRelTime(sess.ts)}</div>
              </div>
              <div style={{ display: "flex", gap: 5, flexWrap: "wrap", flex: "2 1 160px" }}>
                {convs.map((ev, ei) => {
                  const m = EVENT_ICONS[ev.type] || EVENT_ICONS.page;
                  return <span key={ei} style={{ fontSize: 10, fontWeight: 600, color: m.color, background: `${m.color}15`, border: `1px solid ${m.color}40`, borderRadius: 5, padding: "2px 7px" }}>{m.icon} {m.label || ev.type}</span>;
                })}
              </div>
              <span style={{ fontSize: 10, color: "var(--text-muted)" }}>{sess.page_count}p</span>
            </div>
            {isOpen && sess.events?.length > 0 && (
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid var(--border)", display: "flex", flexDirection: "column", gap: 3 }}>
                {sess.events.map((ev, ei) => {
                  const m = EVENT_ICONS[ev.type] || EVENT_ICONS.page;
                  const isConv = CONVERSION_EVENT_TYPES.has(ev.type);
                  return (
                    <div key={ei} style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 11 }}>
                      <span style={{ fontSize: 11 }}>{m.icon}</span>
                      <span style={{ color: isConv ? m.color : "var(--text-muted)", fontFamily: ev.type === "page" ? "var(--font-mono)" : "inherit", fontWeight: isConv ? 700 : 400 }}>
                        {ev.type !== "page" && <span style={{ marginRight: 5 }}>{m.label}</span>}{ev.path || ""}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}</ShowMore>
    </div>
  );
}

// ── Ask box (v2.41) ───────────────────────────────────────────────────────────
// Plain-English questions about this tab's data. The API matches the question to
// a known type and answers from the same summary this page renders, so the
// figures always agree with the panels below. Uses the page's date range and
// domain filter unless the question names its own period ("last week").

const ASK_EXAMPLES = [
  "How many visitors this month?",
  "Where does my traffic come from?",
  "Which pages are most popular?",
  "Which companies visited this week?",
  "Is my site fast?",
];

function AskChip({ label, onClick }) {
  return (
    <button className="btn btn-secondary btn-sm" style={{ textAlign: "left" }} type="button" onClick={onClick}>{label}</button>
  );
}

function AskCard({ card }) {
  if (!card) return null;
  const stats = card.stats || [];
  const rows  = card.rows  || [];
  if (!stats.length && !rows.length) return null;
  return (
    <div style={{ marginTop: 12, padding: "12px 14px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8 }}>
      {card.title && (
        <div style={{ fontSize: 10, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>
          {card.title}
        </div>
      )}
      {stats.length > 0 && (
        <div style={{ display: "flex", gap: 18, flexWrap: "wrap", marginBottom: rows.length ? 10 : 0 }}>
          {stats.map((st, i) => (
            <div key={i} style={{ minWidth: 72 }}>
              <div style={{ fontSize: 20, fontWeight: 800, fontFamily: "var(--font-mono)", color: "var(--accent)", lineHeight: 1 }}>{st.value}</div>
              <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 4 }}>{st.label}</div>
            </div>
          ))}
        </div>
      )}
      {rows.map((r, i) => (
        <div key={i} style={{ display: "flex", alignItems: "baseline", gap: 10, padding: "5px 0", borderTop: i > 0 ? "1px solid var(--border)" : "none" }}>
          <div style={{ flex: 1, minWidth: 0, fontSize: 12, color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={r.label}>{r.label}</div>
          {r.note && (
            <div style={{ fontSize: 10, color: "var(--text-muted)", flexShrink: 1, maxWidth: "40%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={r.note}>{r.note}</div>
          )}
          <div style={{ fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color: "var(--text)", flexShrink: 0 }}>{r.value}</div>
        </div>
      ))}
    </div>
  );
}

function AskBox({ slug, days, domain }) {
  const [q, setQ]         = useState("");
  const [asked, setAsked] = useState("");
  const [busy, setBusy]   = useState(false);
  const [res, setRes]     = useState(null);
  const [err, setErr]     = useState("");

  // A new date range or domain makes the previous answer out of date
  useEffect(() => { setRes(null); setErr(""); }, [days, domain]);

  // Question chips built from this client's own data (app.py v3.69)
  const [examples, setExamples] = useState(ASK_EXAMPLES);
  useEffect(() => {
    const domParam = domain ? `&domain=${encodeURIComponent(domain)}` : "";
    authFetch(`/api/clients/${slug}/analytics/ask/suggestions?days=${days}${domParam}`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.questions?.length) setExamples(d.questions.map(q => q.question)); })
      .catch(() => {});
  }, [slug, days, domain]);

  const ask = async (question) => {
    const text = (question ?? q).trim();
    if (text.length < 3 || busy) return;
    setQ(text); setAsked(text); setBusy(true); setErr(""); setRes(null);
    try {
      const r = await authFetch(`/api/clients/${slug}/analytics/ask`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: text, days, domain }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) setErr(d.error || "Something went wrong. Please try again.");
      else setRes(d);
    } catch (e) {
      setErr("Couldn't reach the server. Please try again.");
    }
    setBusy(false);
  };

  const clear = () => { setQ(""); setAsked(""); setRes(null); setErr(""); };

  const showPanel = (panel) => {
    const marker = document.getElementById(`an-${panel}`);
    if (!marker) return;
    marker.scrollIntoView({ behavior: "smooth", block: "start" });
    let target = marker.nextElementSibling;
    while (target && target.id && target.id.startsWith("an-")) target = target.nextElementSibling;
    if (target && target.style) {
      const prev = target.style.boxShadow;
      target.style.transition = "box-shadow 0.3s ease";
      target.style.boxShadow = "0 0 0 2px var(--accent)";
      setTimeout(() => { target.style.boxShadow = prev; }, 1800);
    }
  };

  return (
    <SectionCard style={{ borderLeft: "3px solid var(--accent)", marginBottom: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
        <CardLabel style={{ marginBottom: 10 }}>Ask about your website</CardLabel>
        {(res || err) && (
          <button className="btn btn-quiet btn-sm" style={{ marginBottom: 10 }} type="button" onClick={clear}>Clear</button>
        )}
      </div>
      <form onSubmit={e => { e.preventDefault(); ask(); }} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input className="input-sm"
          value={q}
          onChange={e => setQ(e.target.value)}
          maxLength={300}
          placeholder="e.g. Where do most of my visitors come from?"
          aria-label="Ask a question about your website analytics"
          style={{ flex: "1 1 220px", minWidth: 0 }}
        />
        <button className="btn btn-primary" type="submit" disabled={busy || q.trim().length < 3}>
          {busy ? "Working…" : "Ask"}
        </button>
      </form>

      {!res && !err && !busy && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 10 }}>
          {examples.map(ex => <AskChip key={ex} label={ex} onClick={() => ask(ex)} />)}
        </div>
      )}

      {busy && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 14, fontSize: 12, color: "var(--text-muted)" }}>
          <span className="spinner" /> Looking at your data…
        </div>
      )}

      {err && (
        <div style={{ marginTop: 12, fontSize: 12, color: "#e6b800", padding: "8px 10px", background: "rgba(230,184,0,0.08)", border: "1px solid rgba(230,184,0,0.3)", borderRadius: 6 }}>
          {err}
        </div>
      )}

      {res && (
        <div style={{ marginTop: 14 }}>
          <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 6 }}>
            “{asked}”
            {res.period?.from_question && <span style={{ marginLeft: 6 }}>· using {res.period.label.replace(/^in /, "")}</span>}
          </div>
          <div style={{ fontSize: 14, color: "var(--text)", lineHeight: 1.6 }}>{res.answer}</div>

          {res.matched && <AskCard card={res.card} />}

          {res.matched && res.panel && (
            <button className="btn btn-quiet btn-sm" style={{ marginTop: 10 }} type="button" onClick={() => showPanel(res.panel)}>
              View details ↓
            </button>
          )}

          {!res.matched && res.suggestions?.length > 0 && (
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 10 }}>
              {res.suggestions.map(sg => <AskChip key={sg.intent} label={sg.question} onClick={() => ask(sg.question)} />)}
            </div>
          )}

          {res.matched && res.related?.length > 0 && (
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginTop: 12 }}>
              <span style={{ fontSize: 10, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 700 }}>Related</span>
              {res.related.map(sg => <AskChip key={sg.intent} label={sg.question} onClick={() => ask(sg.question)} />)}
            </div>
          )}
        </div>
      )}
    </SectionCard>
  );
}

// ── Company visitors → pipeline (A2) ────────────────────────────────────────────
// Named organisations seen on the site (from visitor-IP company resolution), with
// an intent signal. Admin can push one straight into the sales pipeline as a lead.

// ── Enquiries by choice and by page (app.py v3.67) ──────────────────────────

function EnquiryBarRow({ label, value, max, note, color = "var(--accent)" }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
      <div style={{ width: 170, fontSize: 12, color: "var(--text)", flexShrink: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={label}>{label}</div>
      <div style={{ flex: 1, height: 8, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
        <div style={{ width: `${max ? (value / max) * 100 : 0}%`, height: "100%", background: color, borderRadius: 4 }} />
      </div>
      <div style={{ fontSize: 12, fontWeight: 700, color, fontFamily: "var(--font-mono)", width: 36, textAlign: "right" }}>{value}</div>
      {note !== undefined && <div style={{ fontSize: 11, color: "var(--text-muted)", width: 90, textAlign: "right" }}>{note}</div>}
    </div>
  );
}

function EnquiryChoicesPanel({ choices }) {
  if (!choices?.length) return null;
  return (
    <SectionCard>
      <CardLabel>Enquiries by Choice</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        The option visitors picked on your form when they submitted it, such as location or service.
      </div>
      {choices.slice(0, 3).map((f, fi) => {
        const max = f.values[0]?.count || 0;
        return (
          <div key={f.field} style={{ marginTop: fi ? 18 : 0 }}>
            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 10 }}>
              {f.label} <span style={{ fontWeight: 400, color: "var(--text-muted)" }}>· {f.total} submission{f.total !== 1 ? "s" : ""}</span>
            </div>
            <ShowMore>{f.values.map(v => (
              <EnquiryBarRow key={v.value} label={v.value} value={v.count} max={max}
                note={`${Math.round((100 * v.count) / (f.total || 1))}%`} color="#30d158" />
            ))}</ShowMore>
          </div>
        );
      })}
    </SectionCard>
  );
}

function enquiryPagePath(url, showHost) {
  try {
    const u = new URL(url);
    return showHost ? `${u.hostname}${u.pathname}` : u.pathname || "/";
  } catch (e) {
    return url || "/";
  }
}

function EnquiryPagesPanel({ pages, hasChoices, hasForms, isAdmin }) {
  const rows = (pages || []).filter(p => p.conversions > 0).slice(0, 10);
  if (!rows.length) return null;
  const hosts = new Set(rows.map(p => { try { return new URL(p.url).hostname; } catch (e) { return ""; } }));
  const max = rows[0].conversions;
  return (
    <SectionCard>
      <CardLabel>Enquiries by Page</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        Where phone clicks, email clicks, form submissions and downloads happened, with each page's views.
      </div>
      <ShowMore>{rows.map(p => (
        <EnquiryBarRow key={p.url} label={pageName(p.url) + (hosts.size > 1 ? ` · ${enquiryPagePath(p.url, true).split("/")[0]}` : "")} value={p.conversions} max={max}
          note={p.views ? `${p.views} views · ${Math.round((100 * p.conversions) / p.views)}%` : ""} />
      ))}</ShowMore>
      {isAdmin && hasForms && !hasChoices && (
        <div style={{ marginTop: 14, padding: "10px 12px", background: "var(--surface2)", borderRadius: 8, fontSize: 11, color: "var(--text-muted)", lineHeight: 1.5 }}>
          To split form enquiries by location or service, add the class <code>cv-capture</code> (or <code>data-cv-capture="location"</code>) to
          the dropdown or its wrapper and re-paste snippet v2.93 or later. Only dropdowns, radio buttons and tick boxes are read.
        </div>
      )}
    </SectionCard>
  );
}

function CompanyVisitorsPanel({ visitors, isAdmin }) {
  const [added, setAdded] = useState({});   // company -> "busy" | "done" | "exists"
  // v2.58: "Not a business" hides an organisation (an ISP, say) for every client
  const [hidden, setHidden]     = useState({});   // company -> "busy" | "done"
  const [showList, setShowList] = useState(false);
  const [excl, setExcl]         = useState(null);
  const loadExcl = () => authFetch("/api/analytics/org-exclusions").then(r => r.ok ? r.json() : []).then(d => setExcl(Array.isArray(d) ? d : [])).catch(() => setExcl([]));
  const hide = async (v) => {
    if (!window.confirm(`Hide "${v.company}" from company visitors?\n\nUse this for internet providers and other networks that aren't real visitor companies. It applies to every client's dashboard and analytics report, and can be undone.`)) return;
    setHidden(h => ({ ...h, [v.company]: "busy" }));
    try {
      const res = await authFetch("/api/analytics/org-exclusions", { method: "POST", body: JSON.stringify({ name: v.company }) });
      if (!res.ok) { const d = await res.json().catch(() => ({})); alert(d.error || "Could not hide it"); setHidden(h => { const n = { ...h }; delete n[v.company]; return n; }); return; }
      setHidden(h => ({ ...h, [v.company]: "done" }));
      if (showList) loadExcl();
    } catch (e) { alert(e.message); setHidden(h => { const n = { ...h }; delete n[v.company]; return n; }); }
  };
  const unhide = async (name) => {
    const res = await authFetch(`/api/analytics/org-exclusions?name=${encodeURIComponent(name)}`, { method: "DELETE" });
    if (res.ok) { setHidden(h => { const n = { ...h }; delete n[name]; return n; }); loadExcl(); }
  };
  const shown = (visitors || []).filter(v => hidden[v.company] !== "done");
  if (!shown.length && !isAdmin) return null;
  if (!visitors?.length && isAdmin) return null;

  const addToPipeline = async (v) => {
    setAdded(a => ({ ...a, [v.company]: "busy" }));
    try {
      const res = await authFetch("/api/sales/leads", {
        method: "POST",
        body: JSON.stringify({ company_name: v.company, source: "website" }),
      });
      const d = await res.json().catch(() => ({}));
      setAdded(a => ({ ...a, [v.company]: res.ok ? (d.created ? "done" : "exists") : "err" }));
    } catch (e) {
      setAdded(a => ({ ...a, [v.company]: "err" }));
    }
  };

  const intentColor = (n) => n >= 60 ? "#ff453a" : n >= 35 ? "#ff9f0a" : n >= 15 ? "#64d2ff" : "#86868b";
  const fmtWhen = (ts) => { try { return new Date(ts).toLocaleDateString("en-GB", { day: "numeric", month: "short" }); } catch (e) { return ""; } };

  return (
    <SectionCard>
      <CardLabel>Companies Visiting Your Site</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        Named organisations resolved from visitor networks — warm leads for your business. Intent rises with pricing or contact views, return visits and conversions. Internet providers, hosting and mobile networks are filtered out.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {shown.length === 0 && <div style={{ fontSize: 12, color: "var(--text-muted)" }}>No named organisations left to show.</div>}
        <ShowMore>{shown.map((v, i) => {
          const state = added[v.company];
          return (
            <div key={i} style={{ padding: "10px 12px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                <div style={{ width: 42, textAlign: "center", flexShrink: 0 }}>
                  <div style={{ fontSize: 15, fontWeight: 800, fontFamily: "var(--font-mono)", color: intentColor(v.intent), lineHeight: 1 }}>{v.intent}</div>
                  <div style={{ fontSize: 8, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 2 }}>intent</div>
                </div>
                <div style={{ flex: "1 1 180px", minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>🏢 {v.company}</div>
                  <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>
                    {v.sessions} visit{v.sessions !== 1 ? "s" : ""} · {v.pageviews} page{v.pageviews !== 1 ? "s" : ""}
                    {v.city ? ` · ${v.city}` : ""}{v.last_seen ? ` · last ${fmtWhen(v.last_seen)}` : ""}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
                  {v.converted && <span style={{ fontSize: 10, fontWeight: 700, color: "#30d158", background: "rgba(48,209,88,0.12)", border: "1px solid #30d15840", borderRadius: 5, padding: "2px 7px" }}>Converted</span>}
                  {v.pricing && <span style={{ fontSize: 10, fontWeight: 700, color: "#e6b800", background: "rgba(230,184,0,0.12)", border: "1px solid #e6b80040", borderRadius: 5, padding: "2px 7px" }}>Pricing / contact</span>}
                  {v.returned && <span style={{ fontSize: 10, fontWeight: 700, color: "#bf5af2", background: "rgba(191,90,242,0.12)", border: "1px solid #bf5af240", borderRadius: 5, padding: "2px 7px" }}>Returning</span>}
                </div>
                {isAdmin && <button className="btn btn-secondary btn-sm"
                  onClick={() => !state && addToPipeline(v)}
                  disabled={state === "busy" || state === "done" || state === "exists"}
                  style={{ flexShrink: 0, color: state === "done" ? "var(--green-ink)" : state === "err" ? "var(--red-ink)" : undefined }}>
                  {state === "busy" ? "Adding…" : state === "done" ? "✓ Added" : state === "exists" ? "In pipeline" : state === "err" ? "Failed" : "Add to pipeline"}
                </button>}
                {isAdmin && <button className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }}
                  onClick={() => hide(v)} disabled={hidden[v.company] === "busy"}
                  title="An internet provider or other network, not a visitor company"
                 >
                  {hidden[v.company] === "busy" ? "Hiding…" : "Not a business"}
                </button>}
              </div>
              {v.top_pages?.length > 0 && (
                <div style={{ marginTop: 6, fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={v.top_pages.join("  ")}>
                  {v.top_pages.join("  ·  ")}
                </div>
              )}
            </div>
          );
        })}</ShowMore>
      </div>
      {isAdmin && (
        <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 10 }}>
          Added leads appear in the Pipeline. Enrich them there to find a domain, contacts and a prospect score.
          {" "}<span style={{ color: "var(--accent)", cursor: "pointer" }} onClick={() => { const n = !showList; setShowList(n); if (n) loadExcl(); }}>
            {showList ? "Hide the hidden organisations list" : "Organisations hidden as not a business"}
          </span>
        </div>
      )}
      {isAdmin && showList && (
        <div style={{ marginTop: 8, padding: "8px 10px", border: "1px solid var(--border)", borderRadius: 8, background: "var(--surface2)" }}>
          {excl === null ? <span className="spinner" /> : excl.length === 0 ? (
            <div style={{ fontSize: 11, color: "var(--text-muted)" }}>None yet. Internet providers, hosting and mobile networks are also filtered out automatically.</div>
          ) : excl.map(e => (
            <div key={e.name} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 11, padding: "3px 0" }}>
              <span style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{e.name}</span>
              <span style={{ color: "var(--text-muted)" }}>{e.added_by}</span>
              <button className="btn btn-secondary btn-sm" onClick={() => unhide(e.name)}>Show again</button>
            </div>
          ))}
        </div>
      )}
    </SectionCard>
  );
}

// ── Combined attribution (first touch vs last touch, tied per source) ───────────
// One view answering: which channel discovers you vs which channel closes. A
// source that is bigger on first-touch drives discovery; bigger on last-touch
// closes. Requires snippet v2.92+ for last-touch data.

function AttributionPanel({ attribution }) {
  if (!attribution?.length) return null;
  const rows = attribution.filter(a => a.first_touch > 0 || a.last_touch > 0);
  if (!rows.length) return null;
  const maxV = Math.max(1, ...rows.map(a => Math.max(a.first_touch, a.last_touch)));
  const hasLast = rows.some(a => a.last_touch > 0);
  return (
    <SectionCard>
      <CardLabel>Attribution — Discovery vs Closing</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        First touch is where a converting visitor originally found you. Last touch is the channel they returned through to convert. A longer blue bar means that channel drives discovery; a longer green bar means it closes.
      </div>
      <div style={{ display: "flex", gap: 14, marginBottom: 10, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>
        <span style={{ color: "#00d4ff" }}>● First touch</span>
        {hasLast && <span style={{ color: "#30d158" }}>● Last touch</span>}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <ShowMore>{rows.map((a, i) => (
          <div key={a.source || i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 96, flexShrink: 0 }}><SourcePill source={a.source} /></div>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ flex: 1, height: 7, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                  <div style={{ width: `${(a.first_touch / maxV) * 100}%`, height: "100%", background: "#00d4ff", borderRadius: 4 }} />
                </div>
                <div style={{ width: 28, textAlign: "right", fontSize: 11, fontWeight: 700, fontFamily: "var(--font-mono)", color: "#00d4ff" }}>{a.first_touch}</div>
              </div>
              {hasLast && (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ flex: 1, height: 7, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                    <div style={{ width: `${(a.last_touch / maxV) * 100}%`, height: "100%", background: "#30d158", borderRadius: 4 }} />
                  </div>
                  <div style={{ width: 28, textAlign: "right", fontSize: 11, fontWeight: 700, fontFamily: "var(--font-mono)", color: "#30d158" }}>{a.last_touch}</div>
                </div>
              )}
            </div>
          </div>
        ))}</ShowMore>
      </div>
      {!hasLast && (
        <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 12 }}>
          Last-touch data appears once visitors arrive through snippet v2.92 or later.
        </div>
      )}
    </SectionCard>
  );
}

// Build a clickable URL from an analytics path plus whatever domain context we have.
function _resolveUrl(path, domain, domains) {
  const host = domain || (domains && domains.length === 1 ? domains[0] : null);
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  if (!host) return null;
  return "https://" + host.replace(/\/+$/, "") + (path.startsWith("/") ? path : "/" + path);
}

// ── Rage clicks, made actionable ────────────────────────────────────────────────
// Groups rage clicks by page and the element clicked, so you can see exactly
// where visitors are getting frustrated and jump straight to that page.

// v2.60: a rage click group marked on the page screenshot the heatmap takes
function RageSpotShot({ slug, spot }) {
  const [img, setImg]   = useState(null);   // object URL | "none"
  const [busy, setBusy] = useState(false);
  const [msg, setMsg]   = useState("");
  const boxRef = useRef(null);
  const load = useCallback(() => {
    authFetch(`/api/clients/${slug}/analytics/heatmap/image?path=${encodeURIComponent(spot.path)}&device=${spot.device}&t=${Date.now()}`)
      .then(r => r.ok ? r.blob() : null)
      .then(b => setImg(old => { if (old && old !== "none") URL.revokeObjectURL(old); return b ? URL.createObjectURL(b) : "none"; }))
      .catch(() => setImg("none"));
  }, [slug, spot.path, spot.device]);
  useEffect(() => { load(); }, [load]);
  const capture = async () => {
    setBusy(true); setMsg("");
    try {
      const r = await authFetch(`/api/clients/${slug}/analytics/heatmap/screenshot`, { method: "POST", body: JSON.stringify({ path: spot.path, device: spot.device }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) setMsg(d.error || "Couldn't take a screenshot"); else load();
    } catch (e) { setMsg(e.message); } finally { setBusy(false); }
  };
  const onLoad = (e) => {
    const box = boxRef.current; if (!box) return;
    const h = e.target.clientHeight;
    box.scrollTop = Math.max(0, (spot.yp / 1000) * h - box.clientHeight / 2);
  };
  if (img === null) return <div style={{ padding: 10 }}><span className="spinner" /></div>;
  if (img === "none") return (
    <div style={{ marginTop: 8, fontSize: 11, color: "var(--text-muted)" }}>
      No {spot.device === "m" ? "mobile" : "desktop"} screenshot of this page yet.{" "}
      <button className="btn btn-secondary btn-sm" onClick={capture} disabled={busy}>{busy ? <span className="spinner" /> : "Take one"}</button>
      {msg && <span style={{ color: "#ff453a", marginLeft: 6 }}>{msg}</span>}
    </div>
  );
  return (
    <div style={{ marginTop: 8 }}>
      <div ref={boxRef} style={{ position: "relative", maxHeight: 340, overflowY: "auto", border: "1px solid var(--border)", borderRadius: 6, background: "#fff", maxWidth: spot.device === "m" ? 300 : "100%" }}>
        <div style={{ position: "relative" }}>
          <img src={img} alt="Page screenshot" onLoad={onLoad} style={{ width: "100%", display: "block" }} />
          <div title="Where visitors rage-clicked" style={{
            position: "absolute", left: `${spot.x / 10}%`, top: `${spot.yp / 10}%`, width: 34, height: 34, marginLeft: -17, marginTop: -17,
            borderRadius: "50%", border: "3px solid #ff2d55", background: "rgba(255,45,85,0.18)", boxShadow: "0 0 0 4px rgba(255,45,85,0.25)", pointerEvents: "none" }} />
        </div>
      </div>
      <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 4 }}>
        Marked from {spot.samples} rage click{spot.samples !== 1 ? "s" : ""} on {spot.device === "m" ? "mobile" : "desktop"}. The screenshot shows the page as it looks now, so if it has changed since, the mark may be slightly off.
      </div>
    </div>
  );
}

function RageClickPanel({ detail, domain, domains, slug }) {
  const [openSpot, setOpenSpot] = useState(() => {
    try { return new URLSearchParams(window.location.search).get("panel") === "rage" ? 0 : null; } catch (e) { return null; }
  });
  useEffect(() => {
    if (openSpot !== 0) return;
    const t = setTimeout(() => { const el = document.getElementById("an-rage"); if (el) el.scrollIntoView({ behavior: "smooth", block: "start" }); }, 400);
    return () => clearTimeout(t);
  }, []);
  if (!detail?.length) return null;
  const max = Math.max(1, ...detail.map(d => d.count));
  return (
    <SectionCard>
      <CardLabel>Rage Clicks — Where Visitors Get Stuck</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        Repeated rapid clicks on the same spot — usually a broken button, an unresponsive control, or something that looks clickable but is not. Fix the element, not the page.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <ShowMore>{detail.map((d, i) => {
          const url = _resolveUrl(d.path, domain, domains);
          return (
            <div key={i} style={{ padding: "9px 11px", background: "rgba(255,45,85,0.05)", border: "1px solid rgba(255,45,85,0.2)", borderRadius: 7 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 13, flexShrink: 0 }}>😤</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={d.path}>
                    {url ? <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: "#ff6482", textDecoration: "none" }}>{d.path} ↗</a> : d.path}
                  </div>
                  <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 3 }}>
                    Clicked: <span style={{ color: "var(--text)" }}>{d.element}</span>
                    {!d.labelled && d.y != null && <span> · about {d.y}px down{d.x != null ? `, ${d.x}px across` : ""}{d.device ? ` on ${String(d.device).toLowerCase()}` : ""}{d.viewport ? ` (${d.viewport}px wide)` : ""}</span>}
                    {d.selector && <span style={{ fontFamily: "var(--font-mono)", marginLeft: 6, opacity: 0.7 }}>{d.selector}</span>}
                  </div>
                </div>
                {d.spot && slug && <button className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }}
                  onClick={() => setOpenSpot(openSpot === i ? null : i)}>{openSpot === i ? "Hide" : "Show on page"}</button>}
                <div style={{ fontSize: 12, fontWeight: 700, color: "#ff2d55", fontFamily: "var(--font-mono)", flexShrink: 0 }}>{d.count}×</div>
              </div>
              {openSpot === i && d.spot && slug && <RageSpotShot slug={slug} spot={{ ...d.spot, path: d.path }} />}
              <div style={{ marginTop: 6, height: 3, background: "var(--surface2)", borderRadius: 2, overflow: "hidden" }}>
                <div style={{ width: `${(d.count / max) * 100}%`, height: "100%", background: "#ff2d55", borderRadius: 2 }} />
              </div>
            </div>
          );
        })}</ShowMore>
      </div>
    </SectionCard>
  );
}

// ── 404s, made actionable ───────────────────────────────────────────────────────
// Groups broken-page hits by the missing path and the referrer that linked to it,
// so you know both what to redirect and where the bad link lives.

function Page404Panel({ detail, domain, domains }) {
  if (!detail?.length) return null;
  const max = Math.max(1, ...detail.map(d => d.count));
  return (
    <SectionCard>
      <CardLabel>Broken Pages (404s) — What to Redirect</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        Pages visitors reached that do not exist. "Referrer" shows where the broken link lives — an internal link is yours to fix, an external one is a redirect you should add.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <ShowMore>{detail.map((d, i) => {
          const url = _resolveUrl(d.path, domain, domains);
          const refUrl = /^https?:\/\//i.test(d.referrer || "") ? d.referrer : null;
          const internal = d.referrer === "(internal link)";
          return (
            <div key={i} style={{ padding: "9px 11px", background: "rgba(255,45,85,0.05)", border: "1px solid rgba(255,45,85,0.2)", borderRadius: 7 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 13, flexShrink: 0 }}>🚫</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={d.path}>
                    {url ? <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: "#ff6482", textDecoration: "none" }}>{d.path} ↗</a> : d.path}
                  </div>
                  <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={d.referrer}>
                    From: {internal
                      ? <span style={{ color: "#e6b800", fontWeight: 700 }}>internal link (your site)</span>
                      : refUrl
                        ? <a href={refUrl} target="_blank" rel="noopener noreferrer" style={{ fontFamily: "var(--font-mono)", color: "var(--text)" }}>{d.referrer} ↗</a>
                        : <span style={{ fontFamily: "var(--font-mono)" }}>{d.referrer}</span>}
                  </div>
                </div>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#ff2d55", fontFamily: "var(--font-mono)", flexShrink: 0 }}>{d.count}×</div>
              </div>
              <div style={{ marginTop: 6, height: 3, background: "var(--surface2)", borderRadius: 2, overflow: "hidden" }}>
                <div style={{ width: `${(d.count / max) * 100}%`, height: "100%", background: "#ff2d55", borderRadius: 2 }} />
              </div>
            </div>
          );
        })}</ShowMore>
      </div>
    </SectionCard>
  );
}


function SessionFeed({ sessions }) {
  const [expanded,  setExpanded]  = useState(null);
  const [visibleN,  setVisibleN]  = useState(SESSION_FIRST);
  // Reset to first page whenever the source data changes (day/domain filter)
  useEffect(() => { setVisibleN(SESSION_FIRST); setExpanded(null); }, [sessions]);

  if (!sessions?.length) return (
    <SectionCard>
      <CardLabel>Recent Visitors</CardLabel>
      <EmptyState message="No session data yet — visitor journeys will appear here once the updated snippet is installed." />
    </SectionCard>
  );

  const visible   = sessions.slice(0, visibleN);
  const remaining = sessions.length - visibleN;

  return (
    <SectionCard>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
        <CardLabel style={{ marginBottom: 0 }}>Recent Visitors</CardLabel>
        <span style={{ fontSize: 11, color: "var(--text-muted)" }}>
          {visibleN >= sessions.length ? sessions.length : `${visibleN} of ${sessions.length}`} sessions
        </span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {visible.map((sess, i) => {
          const isOpen = expanded === i;
          const dur    = fmtDuration(sess.duration_s);
          const who    = sess.company_hint || (sess.city ? `${sess.city}${sess.country ? ", " + sess.country : ""}` : sess.country || "Unknown visitor");
          const deviceIcon = sess.device === "mobile" ? "📱" : sess.device === "tablet" ? "⬜" : "🖥";
          // Count conversion events in this session
          const convCount = (sess.events || []).filter(e => ["click_phone","click_email","form_submit","download"].includes(e.type)).length;
          return (
            <div key={sess.session_id || i}
              onClick={() => setExpanded(isOpen ? null : i)}
              style={{
                padding: "10px 12px", borderRadius: 8, cursor: "pointer",
                background: isOpen ? "var(--surface2)" : "transparent",
                border: `1px solid ${isOpen ? "var(--border)" : "transparent"}`,
                transition: "background 0.15s",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                <div style={{ flex: "1 1 140px", minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={who}>
                    {sess.company_hint ? "🏢 " : "👤 "}{who}
                  </div>
                  <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>
                    {fmtRelTime(sess.ts)}
                    {sess.is_return && <span style={{ marginLeft: 6, color: "#bf5af2", fontWeight: 700 }}>↩ returning</span>}
                  </div>
                </div>
                <div style={{ flex: "2 1 200px", minWidth: 0, overflow: "hidden" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 4, overflow: "hidden" }}>
                    {(sess.pages || []).slice(0, 4).map((p, pi) => (
                      <span key={pi} style={{ display: "flex", alignItems: "center", gap: 4, minWidth: 0 }}>
                        {pi > 0 && <span style={{ color: "var(--text-muted)", flexShrink: 0 }}>›</span>}
                        <span style={{ fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--text-muted)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: pi === 0 ? 100 : 80 }} title={p}>{p}</span>
                      </span>
                    ))}
                    {sess.pages?.length > 4 && <span style={{ fontSize: 10, color: "var(--text-muted)", flexShrink: 0 }}>+{sess.pages.length - 4}</span>}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                  {convCount > 0 && (
                    <span style={{ fontSize: 10, fontWeight: 700, color: "#30d158", background: "rgba(48,209,88,0.12)", border: "1px solid rgba(48,209,88,0.3)", borderRadius: 4, padding: "1px 6px" }}>
                      {convCount} conv
                    </span>
                  )}
                  <SourcePill source={sess.source} />
                  <span style={{ fontSize: 10, color: "var(--text-muted)" }}>{deviceIcon}</span>
                  {sess.scroll_depth != null && <span style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>{sess.scroll_depth}%↕</span>}
                  {dur && <span style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>{dur}</span>}
                  <span style={{ fontSize: 10, color: "var(--text-muted)" }}>{sess.page_count}p</span>
                  <span style={{ fontSize: 10, color: "var(--text-muted)", transform: `rotate(${isOpen ? "180deg" : "0"})`, transition: "transform 0.2s" }}>▾</span>
                </div>
              </div>
              {isOpen && (
                <div style={{ marginTop: 12, paddingTop: 12, borderTop: "1px solid var(--border)" }}>
                  <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 12 }}>
                    {sess.company_hint && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Organisation</span><strong>{sess.company_hint}</strong></div>}
                    {sess.city && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Location</span><strong>{sess.city}{sess.country ? `, ${sess.country}` : ""}</strong></div>}
                    <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Source</span><SourcePill source={sess.source} size="lg" />{sess.ai_source && <span style={{ marginLeft: 6, fontSize: 11, color: "#7c3aed" }}>via {sess.ai_source}</span>}</div>
                    <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Device</span><strong style={{ textTransform: "capitalize" }}>{sess.device || "—"} · {sess.browser || "—"}</strong></div>
                    {sess.timezone && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Timezone</span><strong>{sess.timezone}</strong></div>}
                    {dur && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Time on site</span><strong>{dur}</strong></div>}
                    {sess.scroll_depth != null && <div style={{ fontSize: 11 }}><span style={{ color: "var(--text-muted)", display: "block", marginBottom: 2 }}>Scroll depth</span><strong>{sess.scroll_depth}%</strong></div>}
                  </div>
                  {/* Full journey timeline */}
                  {sess.events?.length > 0 && (
                    <div>
                      <div style={{ fontSize: 10, color: "var(--text-muted)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 8 }}>Journey</div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        {sess.events.map((ev, ei) => {
                          const meta = EVENT_ICONS[ev.type] || EVENT_ICONS.page;
                          const isConversion = ["click_phone","click_email","form_submit","download"].includes(ev.type);
                          return (
                            <div key={ei} style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                              <span style={{ fontSize: 12, flexShrink: 0, marginTop: 1 }}>{meta.icon}</span>
                              <div style={{
                                fontSize: 11, padding: "3px 10px", borderRadius: 5, flex: 1,
                                background: isConversion ? "rgba(48,209,88,0.08)" : "var(--surface)",
                                border: `1px solid ${isConversion ? "rgba(48,209,88,0.2)" : "var(--border)"}`,
                                color: meta.color, fontFamily: ev.type === "page" ? "var(--font-mono)" : "inherit",
                              }}>
                                {ev.type !== "page" && <span style={{ fontWeight: 700, marginRight: 6 }}>{meta.label}</span>}
                                {ev.path && <span style={{ color: ev.type === "page" ? "var(--text)" : "var(--text-muted)" }}>{ev.path}</span>}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* v2.53: first 5, then 25 more at a time, matching the other lists */}
      {(remaining > 0 || visibleN > SESSION_FIRST) && (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
          {remaining > 0 && (
            <button className="btn btn-secondary btn-sm" style={{ alignSelf: "flex-start", marginTop: 6 }} type="button" onClick={() => setVisibleN(v => v + SESSION_PAGE)}>
              {visibleN === SESSION_FIRST && remaining <= SESSION_PAGE ? `Show all ${sessions.length}` : `Show ${Math.min(remaining, SESSION_PAGE)} more`} ▾
            </button>
          )}
          {visibleN > SESSION_FIRST && (
            <button className="btn btn-secondary btn-sm" style={{ alignSelf: "flex-start", marginTop: 6 }} type="button" onClick={() => { setVisibleN(SESSION_FIRST); setExpanded(null); }}>
              Show fewer ▴
            </button>
          )}
        </div>
      )}
    </SectionCard>
  );
}

// ── Ask insights (admin, v2.45) ─────────────────────────────────────────────
// What this client has typed into the Ask box, read from their own private log
// (app.py v3.69). Unmatched questions, grouped by wording and most-asked first,
// show which intents or phrasings to add next.

// One not-understood question with an "Add to topic" control (v2.47)
function AskTeachRow({ slug, u, topics, threshold, fmtWhen, onAdded }) {
  const [open, setOpen]     = useState(false);
  const [text, setText]     = useState(u.question);
  const [intent, setIntent] = useState(u.nearest_intent || "");
  const [teachAll, setTeachAll] = useState(false);
  const [state, setState]   = useState("");

  const add = async () => {
    if (!intent || text.trim().length < 3) return;
    if (teachAll && !window.confirm(
      "Teach ALL clients?\n\n" +
      "“" + text.trim() + "”\n\n" +
      "This question will be used to understand questions from every client, not just this one. " +
      "Make sure it contains nothing specific to this client — no names, branches, products or anything confidential.\n\n" +
      "If in doubt, press Cancel and untick “Also teach all clients”."
    )) return;
    setState("busy");
    try {
      const r = await authFetch("/api/admin/ask/intents/examples", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ intent, question: text.trim(), scope: teachAll ? "global" : "client", slug }),
      });
      const d = await r.json().catch(() => ({}));
      setState(r.ok ? "done" : (d.error || "Failed"));
      if (r.ok) onAdded && onAdded();
    } catch (e) { setState("Failed"); }
  };

  return (
    <div style={{ padding: "6px 0", borderBottom: "1px solid var(--border)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12, color: "var(--text)" }}>“{u.question}”</div>
          <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>
            Closest: {u.nearest_intent || "none"}{u.best_score ? ` (${u.best_score.toFixed(2)} — needs ${threshold})` : ""} · last {fmtWhen(u.last_asked)}
          </div>
        </div>
        <div style={{ fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color: "#ff9f0a", flexShrink: 0 }}>{u.count}×</div>
        {state === "done"
          ? <span style={{ fontSize: 11, fontWeight: 700, color: "#30d158", flexShrink: 0 }}>✓ Taught{teachAll ? " (all clients)" : ""}</span>
          : <button className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }} onClick={() => setOpen(o => !o)}>{open ? "Cancel" : "Teach"}</button>}
      </div>
      {open && state !== "done" && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
          <input className="input-sm" value={text} onChange={e => setText(e.target.value)} maxLength={200}
            title="Edit out anything client-specific — added questions help every client"
            style={{ flex: "2 1 220px" }} />
          <select className="input-sm" value={intent} onChange={e => setIntent(e.target.value)}
            style={{ flex: "1 1 200px" }}>
            <option value="">Choose the answer it should give…</option>
            {topics.map(t => <option key={t.intent} value={t.intent}>{t.question}</option>)}
          </select>
          <button className="btn btn-primary btn-sm" onClick={add}
            disabled={state === "busy" || !intent || text.trim().length < 3}>
            {state === "busy" ? "Adding…" : "Add"}
          </button>
          <label style={{ flexBasis: "100%", display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: teachAll ? "#ff9f0a" : "var(--text-muted)", cursor: "pointer" }}>
            <input type="checkbox" checked={teachAll} onChange={e => setTeachAll(e.target.checked)} />
            Also teach all clients {teachAll ? "— only for generic wording, nothing about this client" : "(off: this client only)"}
          </label>
          {state && state !== "busy" && <span style={{ fontSize: 11, color: "#ff453a", alignSelf: "center" }}>{state}</span>}
        </div>
      )}
    </div>
  );
}

function AskInsightsPanel({ slug }) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [months, setMonths]   = useState(3);
  const [showRecent, setShowRecent] = useState(false);
  const [topics, setTopics]   = useState([]);
  const [showTaught, setShowTaught] = useState(false);

  const loadTopics = useCallback(() => {
    authFetch(`/api/admin/ask/intents?slug=${encodeURIComponent(slug)}`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.intents) setTopics(d.intents); })
      .catch(() => {});
  }, [slug]);
  useEffect(() => { loadTopics(); }, [loadTopics]);

  const removeTaught = async (intent, question, scope) => {
    if (scope === "global" && !window.confirm("Remove this question for ALL clients?\n\n“" + question + "”")) return;
    await authFetch("/api/admin/ask/intents/examples", {
      method: "DELETE", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ intent, question, scope, slug }),
    }).catch(() => {});
    loadTopics();
  };
  const taught = topics.flatMap(t => [
    ...(t.client_custom || []).map(q => ({ intent: t.intent, topic: t.question, q, scope: "client" })),
    ...(t.custom || []).map(q => ({ intent: t.intent, topic: t.question, q, scope: "global" })),
  ]);
  const taughtClient = taught.filter(t => t.scope === "client").length;

  useEffect(() => {
    setLoading(true);
    authFetch(`/api/clients/${slug}/analytics/ask/log?months=${months}`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug, months]);

  const fmtWhen = (ts) => { try { return new Date(ts).toLocaleDateString("en-GB", { day: "numeric", month: "short" }); } catch (e) { return ""; } };
  const rate = data?.total ? Math.round((100 * data.matched) / data.total) : 0;

  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, marginBottom: 6 }}>
        <CardLabel style={{ marginBottom: 0 }}>Ask Box — What This Client Asks</CardLabel>
        <select className="input-sm" value={months} onChange={e => setMonths(parseInt(e.target.value))}>
          {[1, 3, 6, 12].map(m => <option key={m} value={m}>Last {m} month{m !== 1 ? "s" : ""}</option>)}
        </select>
      </div>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 14 }}>
        Admin only. Questions are kept in this client's own log and never shared with other clients. Unanswered ones show which questions to teach the Ask box next.
      </div>

      {loading ? (
        <div style={{ padding: 20, textAlign: "center" }}><span className="spinner" /></div>
      ) : !data || !data.total ? (
        <div style={{ fontSize: 12, color: "var(--text-muted)" }}>No questions asked yet in this period.</div>
      ) : (
        <div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
            <StatBadge value={data.total} label="Questions" color="var(--accent)" />
            <StatBadge value={`${rate}%`} label="Answered" color={rate >= 80 ? "#30d158" : rate >= 60 ? "#e6b800" : "#ff2d55"} />
            <StatBadge value={data.unmatched_count} label="Not understood" color={data.unmatched_count ? "#ff9f0a" : "#30d158"} />
          </div>

          {data.unmatched?.length > 0 && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#ff9f0a", marginBottom: 8 }}>Not understood — most asked first</div>
              <div style={{ fontSize: 10, color: "var(--text-muted)", marginBottom: 6 }}>
                Teach adds the question as an example for the answer you pick, for this client only. It goes live straight away. Tick “Also teach all clients” only for generic wording.
              </div>
              {data.unmatched.slice(0, 15).map((u, i) => (
                <AskTeachRow key={u.question + i} slug={slug} u={u} topics={topics} threshold={data.threshold}
                  fmtWhen={fmtWhen} onAdded={loadTopics} />
              ))}
            </div>
          )}

          {data.top_intents?.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#30d158", marginBottom: 8 }}>Answered — most popular topics</div>
              {data.top_intents.map(t => (
                <div key={t.intent} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0", fontSize: 11 }}>
                  <span style={{ color: "var(--text)" }}>{t.question}</span>
                  <span style={{ fontWeight: 700, fontFamily: "var(--font-mono)", color: "#30d158" }}>{t.count}</span>
                </div>
              ))}
            </div>
          )}

          {taught.length > 0 && (
            <div style={{ marginBottom: 10 }}>
              <button className="btn btn-secondary btn-sm" onClick={() => setShowTaught(v => !v)}>
                {showTaught ? "Hide taught questions" : `Taught questions (${taughtClient} this client, ${taught.length - taughtClient} all clients)`}
              </button>
              {showTaught && (
                <div style={{ marginTop: 8 }}>
                  {taught.map((t, i) => (
                    <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", padding: "4px 0", fontSize: 11, borderBottom: "1px solid var(--border)" }}>
                      <span style={{ fontSize: 9, fontWeight: 700, padding: "1px 6px", borderRadius: 4, flexShrink: 0,
                        color: t.scope === "global" ? "#ff9f0a" : "var(--accent)",
                        border: `1px solid ${t.scope === "global" ? "#ff9f0a60" : "var(--border)"}` }}>
                        {t.scope === "global" ? "ALL CLIENTS" : "THIS CLIENT"}
                      </span>
                      <span style={{ flex: 1, color: "var(--text)" }}>“{t.q}”</span>
                      <span style={{ color: "var(--text-muted)", flexShrink: 0, maxWidth: "45%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={t.topic}>→ {t.topic}</span>
                      <button className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }} onClick={() => removeTaught(t.intent, t.q, t.scope)}>Remove</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          <button className="btn btn-secondary btn-sm" onClick={() => setShowRecent(v => !v)}>
            {showRecent ? "Hide recent questions" : "Show recent questions"}
          </button>
          {showRecent && (
            <div style={{ marginTop: 10 }}>
              {data.recent.map((r, i) => (
                <div key={i} style={{ display: "flex", gap: 8, padding: "4px 0", fontSize: 11, borderBottom: "1px solid var(--border)" }}>
                  <span style={{ color: r.matched ? "#30d158" : "#ff9f0a", flexShrink: 0 }}>{r.matched ? "✓" : "?"}</span>
                  <span style={{ flex: 1, color: "var(--text)" }}>{r.question}</span>
                  <span style={{ color: "var(--text-muted)", fontFamily: "var(--font-mono)", flexShrink: 0 }}>{r.intent || "—"} {r.score != null ? r.score.toFixed(2) : ""}</span>
                  <span style={{ color: "var(--text-muted)", flexShrink: 0 }}>{fmtWhen(r.ts)}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </SectionCard>
  );
}

// ── Snippet v2.94 panels ────────────────────────────────────────────────────

const pctOf = (a, b) => (b ? Math.round((100 * a) / b) : 0);

// Click heatmap: clicks drawn over a full-page screenshot of the page.
function drawHeat(canvas, points, w, h) {
  if (!canvas || !w || !h) return;
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, w, h);
  if (!points.length) return;
  const r = Math.max(14, Math.round(w / 40));
  const shadow = document.createElement("canvas");
  shadow.width = w; shadow.height = h;
  const sc = shadow.getContext("2d");
  const a = Math.min(0.35, Math.max(0.06, 6 / Math.sqrt(points.length)));
  points.forEach(p => {
    const x = (p.x / 1000) * w, y = (p.yp / 1000) * h;
    const g = sc.createRadialGradient(x, y, 0, x, y, r);
    g.addColorStop(0, `rgba(0,0,0,${a})`);
    g.addColorStop(1, "rgba(0,0,0,0)");
    sc.fillStyle = g;
    sc.fillRect(x - r, y - r, r * 2, r * 2);
  });
  const img = sc.getImageData(0, 0, w, h);
  const d = img.data;
  for (let i = 0; i < d.length; i += 4) {
    const v = d[i + 3] / 255;
    if (v < 0.02) { d[i + 3] = 0; continue; }
    // blue → green → yellow → red
    const t = Math.min(1, v * 1.4);
    d[i]     = Math.round(255 * Math.min(1, Math.max(0, (t - 0.35) * 3)));
    d[i + 1] = Math.round(255 * (t < 0.66 ? Math.min(1, t * 2) : Math.max(0, (1 - t) * 3)));
    d[i + 2] = Math.round(255 * Math.max(0, 1 - t * 2.5));
    d[i + 3] = Math.round(255 * Math.min(0.85, 0.25 + t * 0.7));
  }
  ctx.putImageData(img, 0, 0);
}

// Device with the most clicks for a heatmap page (desktop on a tie)
const heatBestDevice = (p) => (p && (p.mobile || 0) > (p.desktop || 0) ? "m" : "d");

function ClickHeatmapPanel({ slug, pages, days, isAdmin }) {
  const [path, setPath]     = useState(pages?.[0]?.path || "/");
  const [device, setDevice] = useState(heatBestDevice(pages?.[0]));
  const [data, setData]     = useState(null);
  const [imgUrl, setImgUrl] = useState(null);
  const [busy, setBusy]     = useState(false);
  const [msg, setMsg]       = useState("");
  const [size, setSize]     = useState({ w: 0, h: 0 });
  const canvasRef = useRef(null);

  useEffect(() => {
    if (pages?.length && !pages.find(p => p.path === path)) { setPath(pages[0].path); setDevice(heatBestDevice(pages[0])); }
  }, [pages]); // eslint-disable-line

  const choosePage = (newPath) => {
    setPath(newPath);
    setDevice(heatBestDevice(pages.find(p => p.path === newPath)));
  };

  const loadImage = useCallback((shot) => {
    if (!shot) { setImgUrl(null); return; }
    authFetch(`/api/clients/${slug}/analytics/heatmap/image?path=${encodeURIComponent(path)}&device=${device}&t=${shot.taken}`)
      .then(r => r.ok ? r.blob() : null)
      .then(b => setImgUrl(old => { if (old) URL.revokeObjectURL(old); return b ? URL.createObjectURL(b) : null; }))
      .catch(() => setImgUrl(null));
  }, [slug, path, device]);

  useEffect(() => {
    setData(null); setMsg("");
    authFetch(`/api/clients/${slug}/analytics/heatmap?path=${encodeURIComponent(path)}&device=${device}&days=${days}`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { setData(d); loadImage(d?.screenshot); })
      .catch(() => {});
  }, [slug, path, device, days, loadImage]);

  useEffect(() => {
    const pts = data?.points || [];
    const w = size.w || (device === "m" ? 390 : 1366);
    const h = size.h || (imgUrl ? 0 : Math.max(900, Math.round(w * 2.2)));
    if (h) drawHeat(canvasRef.current, pts, w, h);
  }, [data, size, imgUrl, device]);

  const capture = async () => {
    setBusy(true); setMsg("Taking a screenshot of the page — this can take up to a minute…");
    try {
      const r = await authFetch(`/api/clients/${slug}/analytics/heatmap/screenshot`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path, device, force: isAdmin }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) setMsg(d.error || "Couldn't capture the page.");
      else { setMsg(""); setData(x => ({ ...(x || {}), screenshot: d.screenshot })); loadImage(d.screenshot); }
    } catch (e) { setMsg("Couldn't reach the server."); }
    setBusy(false);
  };

  if (!pages?.length) return null;
  const shot = data?.screenshot;
  const page = pages.find(p => p.path === path);
  const otherDevice = device === "m" ? "d" : "m";
  const otherCount = (otherDevice === "m" ? page?.mobile : page?.desktop) || 0;
  const maxW = device === "m" ? 390 : "100%";

  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, marginBottom: 6 }}>
        <CardLabel style={{ marginBottom: 0 }}>Click Heatmap — Where People Click</CardLabel>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          <select className="input-sm" value={path} onChange={e => choosePage(e.target.value)}
            style={{ maxWidth: 320 }}>
            {pages.map(p => <option key={p.path} value={p.path}>{pageName(p.path)} ({(p.desktop || 0).toLocaleString()} desktop, {(p.mobile || 0).toLocaleString()} mobile)</option>)}
          </select>
          <div className="segmented">
            {[["d", "Desktop", page?.desktop], ["m", "Mobile", page?.mobile]].map(([k, l, n]) => (
              <button className="btn" aria-pressed={device === k} key={k} onClick={() => setDevice(k)}>
                {l} ({(n || 0).toLocaleString()})
              </button>
            ))}
          </div>
        </div>
      </div>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 12 }}>
        Every click on this page {device === "m" ? "from phones" : "from computers"}, drawn on a screenshot of the page. Red is where most people click. Nothing visitors type is recorded.
      </div>
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12, fontSize: 12 }}>
        <span><strong>{(data?.count || 0).toLocaleString()}</strong> clicks {device === "m" ? "from phones" : "from computers"}</span>
        {data && !data.count && otherCount > 0 && (
          <span style={{ color: "#ff9f0a", fontSize: 11 }}>
            {otherCount.toLocaleString()} {otherDevice === "m" ? "from phones" : "from computers"} ·{" "}
            <button className="btn btn-secondary btn-sm" onClick={() => setDevice(otherDevice)}>
              Show {otherDevice === "m" ? "mobile" : "desktop"}
            </button>
          </span>
        )}
        {shot && <span style={{ color: "var(--text-muted)" }}>Screenshot {new Date(shot.taken * 1000).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}{shot.auto ? " (taken automatically)" : ""}</span>}
        {data?.can_capture
          ? <button className="btn btn-secondary btn-sm" onClick={capture} disabled={busy}>{busy ? "Capturing…" : shot ? "Refresh screenshot" : "Take screenshot"}</button>
          : data?.capture_note && <span style={{ color: "var(--text-muted)", fontSize: 11 }}>{data.capture_note}</span>}
        {msg && <span style={{ fontSize: 11, color: busy ? "var(--text-muted)" : "#ff9f0a" }}>{msg}</span>}
      </div>
      <div style={{ maxHeight: 720, overflowY: "auto", border: "1px solid var(--border)", borderRadius: 8, background: "var(--surface2)" }}>
        <div style={{ position: "relative", width: maxW, margin: "0 auto" }}>
          {imgUrl
            ? <img src={imgUrl} alt="Page screenshot" style={{ display: "block", width: "100%" }}
                onLoad={e => setSize({ w: e.target.naturalWidth, h: e.target.naturalHeight })} />
            : <div style={{ height: 420, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-muted)", fontSize: 12, padding: 20, textAlign: "center" }}>
                {data?.count ? "Clicks are shown without the page behind them until a screenshot is taken. Screenshots are taken automatically once a page has 10 clicks, or take one now." : "No clicks recorded on this page yet — clicks appear once visitors arrive through snippet v2.94."}
              </div>}
          <canvas ref={canvasRef} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none", display: data?.count ? "block" : "none" }} />
        </div>
      </div>
      {data?.top_elements?.length > 0 && (
        <div style={{ marginTop: 10, fontSize: 11, color: "var(--text-muted)" }}>
          Most clicked elements: {data.top_elements.slice(0, 5).map(t => `${t.el} (${t.count})`).join(" · ")}
        </div>
      )}
    </SectionCard>
  );
}

function InvisibleVisitorsPanel({ blockers }) {
  // v2.63: nothing to say when no visits used a blocker
  if (!blockers?.checked || !blockers?.blocked) return null;
  const pct = pctOf(blockers.blocked, blockers.checked);
  return (
    <SectionCard style={{ borderLeft: "3px solid #bf5af2" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 18, flexWrap: "wrap" }}>
        <div style={{ fontSize: 34, fontWeight: 800, fontFamily: "var(--font-mono)", color: "#bf5af2", lineHeight: 1 }}>{pct}%</div>
        <div style={{ flex: 1, minWidth: 220 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>of visitors are invisible to Google Analytics</div>
          <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 4 }}>
            {blockers.blocked.toLocaleString()} of {blockers.checked.toLocaleString()} visits used an ad or tracker blocker. Those visitors don't show up in Google Analytics — Clearview still counts them, without cookies.
          </div>
        </div>
      </div>
    </SectionCard>
  );
}

function PathToEnquiryPanel({ path }) {
  if (!path?.enquirers) return null;
  const n = path.enquirers;
  const bars = [["On their first visit", path.first_visit], ["After 2–3 visits", path.two_three], ["After 4+ visits", path.four_plus]];
  return (
    <SectionCard>
      <CardLabel>The Road to an Enquiry</CardLabel>
      <div style={{ fontSize: 13, color: "var(--text)", marginBottom: 14, lineHeight: 1.6 }}>
        People who enquired typically visited <strong>{path.median_visits}</strong> time{path.median_visits === 1 ? "" : "s"} over <strong>{path.median_days}</strong> day{path.median_days === 1 ? "" : "s"} before getting in touch.
      </div>
      {bars.map(([l, v]) => <EnquiryBarRow key={l} label={l} value={v} max={n} note={`${pctOf(v, n)}%`} color="#00d4ff" />)}
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 10 }}>
        {pctOf(path.same_day, n)}% enquired the same day, {pctOf(path.within_week, n)}% within a week and {pctOf(path.over_week, n)}% took longer. Based on {n} enquirer{n === 1 ? "" : "s"} in this period.
      </div>
    </SectionCard>
  );
}

function OutOfHoursPanel({ ooh }) {
  if (!ooh?.total) return null;
  const out = ooh.evening + ooh.night + ooh.weekend;
  const max = Math.max(1, ...ooh.by_hour);
  return (
    <SectionCard>
      <CardLabel>When Enquiries Arrive</CardLabel>
      <div style={{ fontSize: 13, color: "var(--text)", marginBottom: 14 }}>
        <strong>{pctOf(out, ooh.total)}%</strong> of enquiries arrive outside working hours (Mon–Fri 9:00–17:30) — {ooh.evening} in the evening, {ooh.night} overnight and {ooh.weekend} at weekends.
      </div>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height: 70 }}>
        {ooh.by_hour.map((v, h) => (
          <div key={h} title={`${String(h).padStart(2, "0")}:00 — ${v}`} style={{ flex: 1, height: `${(v / max) * 100}%`, minHeight: v ? 3 : 1,
            background: h >= 9 && h < 17 ? "var(--accent)" : "#ff9f0a", borderRadius: 2, opacity: v ? 1 : 0.25 }} />
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 9, color: "var(--text-muted)", fontFamily: "var(--font-mono)", marginTop: 4 }}>
        <span>00:00</span><span>06:00</span><span>12:00</span><span>18:00</span><span>23:00</span>
      </div>
    </SectionCard>
  );
}

function CtaPanel({ ctas }) {
  if (!ctas?.length) return null;
  const best = [...ctas].filter(c => c.seen >= 10).sort((a, b) => b.rate - a.rate)[0];
  return (
    <SectionCard>
      <CardLabel>Calls to Action — Seen vs Clicked</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 12 }}>
        Buttons and links like "Book", "Contact" or "Get a quote", found automatically. "Seen" counts page views where the button was on screen.
        {best && <> Best performer: <strong style={{ color: "var(--text)" }}>{best.cta}</strong> ({best.rate}%).</>}
      </div>
      <ShowMore>{ctas.map(c => (
        <div key={c.cta} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: "1px solid var(--border)", fontSize: 12 }}>
          <div style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.cta}</div>
          <div style={{ width: 70, textAlign: "right", color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>{c.seen} seen</div>
          <div style={{ width: 80, textAlign: "right", fontFamily: "var(--font-mono)" }}>{c.clicked} clicked</div>
          <div style={{ width: 52, textAlign: "right", fontWeight: 700, fontFamily: "var(--font-mono)",
            color: c.rate >= 5 ? "#30d158" : c.rate >= 1.5 ? "#e6b800" : "#ff453a" }}>{c.rate}%</div>
        </div>
      ))}</ShowMore>
    </SectionCard>
  );
}

function FormFieldsPanel({ fields }) {
  if (!fields?.length) return null;
  const worst = [...fields].sort((a, b) => b.abandoned - a.abandoned)[0];
  return (
    <SectionCard>
      <CardLabel>Form Friction — Field by Field</CardLabel>
      <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 12 }}>
        Time spent on each form field, how often people clear what they've typed, and where they give up. Only field names and timings are recorded — never what's typed.
        {worst?.abandoned > 0 && <> Most people give up at <strong style={{ color: "#ff9f0a" }}>{worst.field}</strong>.</>}
      </div>
      <ShowMore>{fields.map(f => (
        <div key={f.field} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: "1px solid var(--border)", fontSize: 12 }}>
          <div style={{ flex: 1, minWidth: 0, fontFamily: "var(--font-mono)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.field}</div>
          <div style={{ width: 70, textAlign: "right", fontWeight: 700, fontFamily: "var(--font-mono)", color: f.avg_s >= 15 ? "#ff9f0a" : "var(--text)" }}>{f.avg_s}s</div>
          <div style={{ width: 80, textAlign: "right", color: "var(--text-muted)" }}>{f.clears} clears</div>
          <div style={{ width: 90, textAlign: "right", color: f.abandoned ? "#ff453a" : "var(--text-muted)" }}>{f.abandoned} gave up</div>
        </div>
      ))}</ShowMore>
    </SectionCard>
  );
}

function SpeedConversionPanel({ speed }) {
  if (!speed || !(speed.slow_sessions + speed.fast_sessions)) return null;
  const diff = speed.fast_rate && speed.slow_sessions ? Math.round((1 - speed.slow_rate / speed.fast_rate) * 100) : null;
  return (
    <SectionCard>
      <CardLabel>Does Speed Cost You Enquiries?</CardLabel>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
        <StatBadge value={`${speed.fast_rate}%`} label={`Enquired — fast pages (${speed.fast_sessions})`} color="#30d158" />
        <StatBadge value={`${speed.slow_rate}%`} label={`Enquired — slow pages (${speed.slow_sessions})`} color="#ff9f0a" />
      </div>
      <div style={{ fontSize: 12, color: "var(--text)", marginBottom: 10 }}>
        {speed.slow_sessions === 0 ? "No visitors waited more than 3 seconds for the main content — nice."
          : diff !== null && diff > 0 ? `Visitors who waited more than 3 seconds for the main content enquired ${diff}% less often.`
          : "Slow-loading visits haven't held back enquiries in this period."}
      </div>
      {speed.pages?.length > 0 && (
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 6 }}>Slowest pages (main content, 75th percentile)</div>
          <ShowMore>{speed.pages.map(p => (
            <div key={p.path} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: 12, borderBottom: "1px solid var(--border)" }}>
              <PageName path={p.path} />
              <span style={{ fontFamily: "var(--font-mono)", fontWeight: 700, color: p.lcp_p75 > 4000 ? "#ff453a" : p.lcp_p75 > 2500 ? "#e6b800" : "#30d158" }}>{(p.lcp_p75 / 1000).toFixed(1)}s</span>
            </div>
          ))}</ShowMore>
        </div>
      )}
    </SectionCard>
  );
}

function ConfirmationsPanel({ conf }) {
  if (!conf?.total) return null;
  return (
    <SectionCard>
      <CardLabel>Completed Bookings and Orders</CardLabel>
      <div style={{ fontSize: 13, color: "var(--text)", marginBottom: 12 }}>
        <strong>{conf.total}</strong> visitor{conf.total === 1 ? "" : "s"} reached a thank-you or confirmation page — these are finished bookings, orders or enquiries, not just started ones.
      </div>
      <ShowMore>{conf.pages.map(p => <EnquiryBarRow key={p.path} label={pageName(p.path)} value={p.count} max={conf.pages[0].count} color="#30d158" />)}</ShowMore>
      {conf.via?.length > 0 && (
        <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 8 }}>
          Returned from booking tools: {conf.via.map(v => `${v.tool} (${v.count})`).join(", ")}
        </div>
      )}
    </SectionCard>
  );
}

const CURRENT_SV_FALLBACK = "2.95";   // fallback; the analytics summary sends snippet_current (app.py v4.04)

function SnippetVersionBanner({ versions, current }) {
  const CURRENT_SV = current || CURRENT_SV_FALLBACK;
  const currentHits = versions.find(v => v.version === CURRENT_SV)?.count || 0;
  const legacyHits  = versions.filter(v => v.version !== CURRENT_SV).reduce((a, v) => a + v.count, 0);
  const isLatest    = currentHits > 0 && legacyHits === 0;
  const total       = currentHits + legacyHits;
  return (
    <div style={{ marginBottom: 16, padding: "10px 14px", borderRadius: 8,
      background: isLatest ? "rgba(48,209,88,0.06)" : "rgba(230,184,0,0.08)",
      border: "1px solid " + (isLatest ? "rgba(48,209,88,0.25)" : "rgba(230,184,0,0.3)") }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: isLatest ? "#30d158" : "#e6b800" }}>
          {isLatest ? "✓ Snippet up to date" : "⚠ Snippet needs updating"}
        </span>
        <span style={{ fontSize: 11, color: isLatest ? "#30d158" : "#e6b800" }}>
          {isLatest
            ? `v${CURRENT_SV} — all ${total} sessions on latest version`
            : `v${CURRENT_SV} is current — ${legacyHits} of ${total} sessions still on an older snippet`}
        </span>
      </div>
    </div>
  );
}

// ── Referral domains panel (expandable) ───────────────────────────────────────

function ReferralDomainsPanel({ referralDomains }) {
  const [openDomains, setOpenDomains] = useState(new Set());

  const toggle = (domain) => {
    setOpenDomains(prev => {
      const next = new Set(prev);
      next.has(domain) ? next.delete(domain) : next.add(domain);
      return next;
    });
  };

  return (
    <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid var(--border)" }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--accent)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>
        Referral Sites
      </div>
      <ShowMore>{referralDomains.map((r, i) => {
        const isOpen   = openDomains.has(r.domain);
        const hasUrls  = r.top_urls && r.top_urls.length > 0;
        const maxCount = hasUrls ? r.top_urls[0].count : 1;
        return (
          <div key={i}>
            {/* Domain row */}
            <div
              onClick={() => hasUrls && toggle(r.domain)}
              style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "4px 0", fontSize: 11,
                cursor: hasUrls ? "pointer" : "default",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 5, minWidth: 0 }}>
                {hasUrls && (
                  <span style={{ fontSize: 9, color: "var(--text-muted)", flexShrink: 0, transform: `rotate(${isOpen ? "90deg" : "0"})`, transition: "transform 0.15s", display: "inline-block" }}>▶</span>
                )}
                <span style={{ color: "var(--text)", fontFamily: "var(--font-mono)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.domain}</span>
              </div>
              <span style={{ fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font-mono)", flexShrink: 0, marginLeft: 8 }}>{r.count}</span>
            </div>
            {/* Expanded URL list */}
            {isOpen && hasUrls && (
              <div style={{ marginBottom: 6, marginLeft: 14, padding: "6px 10px", background: "var(--surface2)", borderRadius: 6, borderLeft: "2px solid var(--accent)" }}>
                {r.top_urls.map((u, ui) => {
                  const barPct = Math.round((u.count / maxCount) * 100);
                  // Strip the scheme+host to show just the path for readability
                  let displayPath = u.url;
                  try { displayPath = new URL(u.url).pathname || "/"; } catch (_) {}
                  return (
                    <div key={ui} style={{ padding: "4px 0", borderBottom: ui < r.top_urls.length - 1 ? "1px solid var(--border)" : "none" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <div style={{ flex: 1, fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={u.url}>
                          {displayPath}
                        </div>
                        <span style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", fontFamily: "var(--font-mono)", flexShrink: 0 }}>{u.count}</span>
                        <a href={u.url} target="_blank" rel="noopener noreferrer"
                          onClick={e => e.stopPropagation()}
                          style={{ fontSize: 10, color: "var(--accent)", flexShrink: 0, textDecoration: "none" }}
                          title="Open referring page"
                        >↗</a>
                      </div>
                      <div style={{ marginTop: 3, height: 3, background: "var(--border)", borderRadius: 2, overflow: "hidden" }}>
                        <div style={{ width: `${barPct}%`, height: "100%", background: "var(--accent)", borderRadius: 2 }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}</ShowMore>
    </div>
  );
}

// ── Analytics Section ─────────────────────────────────────────────────────────

function AnalyticsSection({ slug, isAdmin }) {
  const [data,        setData]        = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [days,        setDays]        = useState(30);
  const [refreshMin,  setRefreshMin]  = useState(() => {
    const s = localStorage.getItem("analytics_refresh_" + slug);
    return s ? parseInt(s) : 15;
  });
  const [snippet,     setSnippet]     = useState(null);
  const [showSnippet, setShowSnippet] = useState(false);
  const [retention,   setRetention]   = useState(90);
  const [retSaving,   setRetSaving]   = useState(false);
  const [copied,      setCopied]      = useState(false);
  const [domain,      setDomain]      = useState("");
  const [domains,     setDomains]     = useState([]);
  const [selectedConversion, setSelectedConversion] = useState(null);
  const [exporting, setExporting] = useState("");
  const [shareUrl, setShareUrl] = useState("");
  const [shareBusy, setShareBusy] = useState(false);
  const [shareCopied, setShareCopied] = useState(false);

  const createShare = async () => {
    setShareBusy(true);
    try {
      const res = await authFetch(`/api/clients/${slug}/analytics/share`, { method: "POST", body: JSON.stringify({}) });
      const d = await res.json();
      if (d.url) {
        setShareUrl(d.url);
        if (navigator.clipboard) navigator.clipboard.writeText(d.url).then(() => { setShareCopied(true); setTimeout(() => setShareCopied(false), 2500); }).catch(() => {});
      }
    } catch (e) { /* ignore */ }
    finally { setShareBusy(false); }
  };

  const revokeShare = async () => {
    setShareBusy(true);
    try {
      await authFetch(`/api/clients/${slug}/analytics/share`, { method: "POST", body: JSON.stringify({ revoke: true }) });
      setShareUrl("");
    } catch (e) { /* ignore */ }
    finally { setShareBusy(false); }
  };

  const exportData = async (fmt) => {
    setExporting(fmt);
    try {
      const domParam = domain ? "&domain=" + encodeURIComponent(domain) : "";
      const res = await authFetch(`/api/clients/${slug}/analytics/export?days=${days}&format=${fmt}${domParam}`);
      if (!res.ok) throw new Error("export failed");
      const blob = await res.blob();
      const cd   = res.headers.get("Content-Disposition") || "";
      const m    = cd.match(/filename="?([^"]+)"?/);
      const name = (m && m[1]) || `analytics_${slug}.${fmt}`;
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href = url; a.download = name; document.body.appendChild(a); a.click();
      a.remove(); URL.revokeObjectURL(url);
    } catch (e) {
      alert("Export failed. Please try again.");
    } finally {
      setExporting("");
    }
  };

  const load = useCallback(() => {
    setLoading(true);
    const domParam = domain ? "&domain=" + encodeURIComponent(domain) : "";
    fetch("/api/clients/" + slug + "/analytics?days=" + days + domParam, {
      headers: { Authorization: "Bearer " + (localStorage.getItem("stg_token") || "") },
    })
      .then(r => r.json())
      .then(d => { setData(d); if (d.domains) setDomains(cleanDomains(d.domains)); setLoading(false); setSelectedConversion(null); })
      .catch(() => setLoading(false));
  }, [slug, days, domain]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    localStorage.setItem("analytics_refresh_" + slug, refreshMin);
    if (!refreshMin) return;
    const iv = setInterval(load, refreshMin * 60 * 1000);
    return () => clearInterval(iv);
  }, [refreshMin, load, slug]);

  useEffect(() => {
    authFetch("/api/clients/" + slug + "/analytics/retention")
      .then(r => r.json())
      .then(d => setRetention(d.retention_days || 90))
      .catch(() => {});
  }, [slug]);

  // v2.61: the dashboard's "Tracking snippets to update" links here with ?panel=snippet
  const _snipOpened = useRef(false);
  useEffect(() => {
    if (_snipOpened.current) return;
    let want = false;
    try { want = new URLSearchParams(window.location.search).get("panel") === "snippet"; } catch (e) { /* ignore */ }
    if (!want) return;
    _snipOpened.current = true;
    authFetch("/api/clients/" + slug + "/analytics/snippet").then(r => r.json())
      .then(d => { setSnippet(d.snippet); setShowSnippet(true); })
      .catch(() => {});
    setTimeout(() => { const el = document.getElementById("an-snippet"); if (el) el.scrollIntoView({ behavior: "smooth", block: "start" }); }, 1200);
  }, [slug]);

  const loadSnippet = () => {
    authFetch("/api/clients/" + slug + "/analytics/snippet")
      .then(r => r.json())
      .then(d => { setSnippet(d.snippet); setShowSnippet(!showSnippet); })
      .catch(() => {});
  };

  const copySnippet = () => {
    if (!snippet) return;
    navigator.clipboard.writeText(snippet).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const saveRetention = async () => {
    setRetSaving(true);
    await authFetch("/api/clients/" + slug + "/analytics/retention", {
      method: "POST", body: JSON.stringify({ retention_days: retention }),
    }).catch(() => {});
    setRetSaving(false);
  };

  const s       = data?.summary || {};
  PAGE_NAMES = s.page_names || {};
  const hasData = data?.available && data?.total > 0;

  // Use active foreground time (new snippet) — falls back to wall-clock duration
  // for sessions recorded before the snippet upgrade
  const avgDur    = fmtDuration(s.avg_active_s || s.avg_duration_s);
  const topSource = s.traffic_sources?.[0]?.source || null;


  return (
    <div>
      {/* Controls */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 20 }}>
        <div className="segmented">
          {[{ v: 1, l: "24h" }, { v: 7, l: "7d" }, { v: 30, l: "30d" }, { v: 90, l: "90d" }].map(({ v, l }) => (
            <button className="btn" aria-pressed={days === v} key={v} onClick={() => setDays(v)}>{l}</button>
          ))}
        </div>
        {domains.length > 1 && (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            <button className="btn btn-secondary btn-sm" aria-pressed={!domain} onClick={() => setDomain("")}>All</button>
            {domains.map(d => (
              <button className="btn btn-secondary btn-sm" aria-pressed={domain === d} key={d} onClick={() => setDomain(d)}>{d}</button>
            ))}
          </div>
        )}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: "auto", fontSize: 11, color: "var(--text-muted)" }}>
          <select className="input-sm" value={refreshMin} onChange={e => setRefreshMin(parseInt(e.target.value))}>
            {ANALYTICS_REFRESH.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <button className="btn btn-secondary btn-sm" onClick={load}>↻</button>
          {isAdmin && hasData && (
            <div style={{ display: "flex", gap: 0, border: "1px solid var(--border)", borderRadius: 6, overflow: "hidden", marginLeft: 4 }}>
              <button className="btn btn-secondary btn-sm" style={{ borderRight: "1px solid var(--border)" }} onClick={() => exportData("csv")} disabled={!!exporting} title="Export raw snippet events as CSV"
               >
                {exporting === "csv" ? "…" : "⬇ CSV"}
              </button>
              <button className="btn btn-secondary btn-sm" onClick={() => exportData("xlsx")} disabled={!!exporting} title="Export events plus a summary sheet as Excel"
               >
                {exporting === "xlsx" ? "…" : "⬇ Excel"}
              </button>
            </div>
          )}
        </div>
      </div>

      {loading ? (
        <div style={{ padding: 48, textAlign: "center" }}><span className="spinner" /></div>
      ) : !hasData ? (
        <div>
          <SectionCard>
            <div style={{ textAlign: "center", padding: "40px 0" }}>
              <div style={{ fontSize: 36, marginBottom: 14 }}>📊</div>
              <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 10 }}>No analytics data yet</div>
              <div style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 24, maxWidth: 440, margin: "0 auto 24px" }}>
                Add the tracking snippet to this client's website to start collecting visitor analytics, session journeys, and company attribution.
              </div>
              <button className="btn btn-primary" onClick={loadSnippet}>Get Tracking Snippet</button>
            </div>
          </SectionCard>
          {showSnippet && snippet && (
            <SectionCard style={{ marginTop: 16 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 700 }}>Tracking Snippet</div>
                <button className="btn btn-secondary btn-sm" onClick={copySnippet}>{copied ? "Copied!" : "Copy"}</button>
              </div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 12 }}>
                Paste into the {"<head>"} of every page. Tracks visits, session journeys, and traffic sources (including AI chatbot referrals) without cookies.
              </div>
              <pre style={{ fontSize: 11, background: "var(--surface2)", padding: "12px 14px", borderRadius: 8,
                overflow: "auto", fontFamily: "var(--font-mono)", whiteSpace: "pre-wrap",
                border: "1px solid var(--border)", color: "var(--text)", lineHeight: 1.6 }}>{snippet}</pre>
              <div style={{ marginTop: 10, display: "flex", gap: 16, flexWrap: "wrap" }}>
                <div style={{ fontSize: 11, color: "var(--text-muted)" }}><strong>WordPress:</strong> Use "Insert Headers and Footers" plugin.</div>
                <div style={{ fontSize: 11, color: "var(--text-muted)" }}><strong>Google Tag Manager:</strong> Custom HTML tag, trigger on All Pages.</div>
              </div>
            </SectionCard>
          )}
        </div>
      ) : (
        <div>
          {/* Ask box — plain-English questions about this tab's data */}
          <AskBox slug={slug} days={days} domain={domain} />

          {/* Plain English insight summary */}
          <InsightSummary s={s} days={days} />

          {/* Hero metrics */}
          <div id="an-hero" style={{ scrollMarginTop: 80 }} />
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 20 }}>
            <HeroMetric label="Page Views"    value={s.total_pageviews || 0}  accent="var(--accent)" />
            <HeroMetric label="Sessions"      value={s.unique_sessions || 0}  accent="#30d158" />
            <HeroMetric label="Avg Time"      value={avgDur || "—"}           accent="#e6b800" />
            <HeroMetric
              label="Top Source"
              value={topSource ? (SOURCE_META[topSource]?.label || topSource) : "—"}
              accent={topSource ? (SOURCE_META[topSource]?.color || "var(--accent)") : "var(--text-muted)"}
            />
            {(s.conversions?.total > 0) && (
              <HeroMetric
                label="Conversions"
                value={s.conversions.total}
                accent="#ff9f0a"
                sub={[
                  s.conversions.phone_clicks  > 0 && `${s.conversions.phone_clicks} call${s.conversions.phone_clicks !== 1 ? "s" : ""}`,
                  s.conversions.email_clicks  > 0 && `${s.conversions.email_clicks} email${s.conversions.email_clicks !== 1 ? "s" : ""}`,
                  s.conversions.form_submits  > 0 && `${s.conversions.form_submits} form${s.conversions.form_submits !== 1 ? "s" : ""}`,
                  s.conversions.downloads     > 0 && `${s.conversions.downloads} download${s.conversions.downloads !== 1 ? "s" : ""}`,
                ].filter(Boolean).join(" · ")}
              />
            )}
            {s.new_vs_returning && (s.new_vs_returning.new + s.new_vs_returning.returning) > 0 && (
              <HeroMetric
                label="New vs Returning"
                value={`${s.new_vs_returning.new}/${s.new_vs_returning.returning}`}
                accent="#bf5af2"
                sub="new / returning sessions"
              />
            )}
          </div>

          {/* What to fix this month (v2.54) */}
          <div id="an-fix" style={{ scrollMarginTop: 80 }} />
          <FixListPanel recs={s.recommendations} />

          {/* Visitors invisible to Google Analytics (snippet v2.94) */}
          <div id="an-blockers" style={{ scrollMarginTop: 80 }} />
          <InvisibleVisitorsPanel blockers={s.blockers} />

          {/* Core Web Vitals */}
          <div id="an-cwv" style={{ scrollMarginTop: 80 }} />
          <CoreWebVitalsPanel cwv={s.core_web_vitals} />

          {/* Trend chart */}
          <div id="an-trend" style={{ scrollMarginTop: 80 }} />
          {s.daily && s.daily.length > 0 && (
            <SectionCard>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <CardLabel>Page Views Trend</CardLabel>
                <div style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "var(--font-mono)" }}>
                  {s.daily[0]?.date} → {s.daily[s.daily.length - 1]?.date}
                </div>
              </div>
              <TrendWithNotes slug={slug} daily={s.daily} />
            </SectionCard>
          )}

          {/* Traffic sources + Top pages side by side */}
          <div id="an-sources" style={{ scrollMarginTop: 80 }} />
          <div id="an-pages" style={{ scrollMarginTop: 80 }} />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16, marginBottom: 16 }}>
            {s.traffic_sources && s.traffic_sources.length > 0 && (
              <SectionCard style={{ margin: 0 }}>
                <CardLabel>Traffic Sources</CardLabel>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <ShowMore>{s.traffic_sources.map((src, i) => {
                    const meta = SOURCE_META[src.source] || { label: src.source, color: "#86868b" };
                    const max  = s.traffic_sources[0].count;
                    const pct  = (src.count / max) * 100;
                    return (
                      <div key={src.source || i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <SourcePill source={src.source} />
                        <div style={{ flex: 1, height: 7, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                          <div style={{ width: `${pct}%`, height: "100%", background: meta.color, borderRadius: 4 }} />
                        </div>
                        <div style={{ width: 28, textAlign: "right", fontSize: 12, fontWeight: 700, fontFamily: "var(--font-mono)", color: meta.color }}>{src.count}</div>
                      </div>
                    );
                  })}</ShowMore>
                </div>
                {/* AI chatbot sub-breakdown */}
                {s.ai_sources && s.ai_sources.length > 0 && (
                  <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid var(--border)" }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "#7c3aed", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>
                      AI Chatbot Detail
                    </div>
                    <ShowMore>{s.ai_sources.map((a, i) => (
                      <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0", fontSize: 11 }}>
                        <span style={{ color: "var(--text)" }}>{a.source}</span>
                        <span style={{ fontWeight: 700, color: "#7c3aed", fontFamily: "var(--font-mono)" }}>{a.count}</span>
                      </div>
                    ))}</ShowMore>
                  </div>
                )}
                {/* Referral domain breakdown */}
                {s.referral_domains && s.referral_domains.length > 0 && (
                  <ReferralDomainsPanel referralDomains={s.referral_domains} />
                )}
              </SectionCard>
            )}
            {s.top_pages && s.top_pages.length > 0 && (
              <SectionCard style={{ margin: 0 }}>
                <CardLabel>Top Pages</CardLabel>
                <ShowMore>{s.top_pages.map((p, i) => {
                  const hasScroll = p.avg_scroll != null;
                  return (
                    <div key={i} style={{ padding: "6px 0", borderBottom: i < s.top_pages.length - 1 ? "1px solid var(--border)" : "none" }}>
                      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: "var(--text-muted)", width: 18, flexShrink: 0 }}>{i + 1}</div>
                        <div style={{ fontSize: 12, flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={p.url}>
                          <PageName path={p.url} />
                        </div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)", flexShrink: 0 }}>{p.views}</div>
                      </div>
                      {hasScroll && (
                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 3, marginLeft: 26 }}>
                          <div style={{ flex: 1, height: 3, background: "var(--surface2)", borderRadius: 2, overflow: "hidden" }}>
                            <div style={{ width: `${p.avg_scroll}%`, height: "100%", background: p.avg_scroll > 60 ? "#30d158" : p.avg_scroll > 30 ? "#e6b800" : "#ff2d55", borderRadius: 2 }} />
                          </div>
                          <span style={{ fontSize: 9, color: "var(--text-muted)", fontFamily: "var(--font-mono)", flexShrink: 0 }}>{p.avg_scroll}% scroll</span>
                        </div>
                      )}
                    </div>
                  );
                })}</ShowMore>
              </SectionCard>
            )}
          </div>

          {/* Source performance — which channels actually convert (click to drill in) */}
          <div id="an-source-perf" style={{ scrollMarginTop: 80 }} />
          <SourcePerformancePanel sourcePerformance={s.source_performance} sessions={s.sessions} />

          {/* Company visitors — named orgs on the site; pipeline button is admin-only */}
          <div id="an-companies" style={{ scrollMarginTop: 80 }} />
          <CompanyVisitorsPanel visitors={s.company_visitors} isAdmin={isAdmin} />

          {/* Session feed */}
          <div id="an-visitors" style={{ scrollMarginTop: 80 }} />
          <SessionFeed sessions={s.sessions} />

          {/* Time of day heatmap */}
          <div id="an-heatmap" style={{ scrollMarginTop: 80 }} />
          <HeatmapChart heatmap={s.heatmap} />

          {/* New vs returning trend */}
          <div id="an-returning" style={{ scrollMarginTop: 80 }} />
          <ReturnTrendChart returnTrend={s.return_trend} />

          {/* Page insights */}
          <div id="an-page-insights" style={{ scrollMarginTop: 80 }} />
          <PageInsights insights={s.page_insights} />

          {/* Page map from the website's sitemap (v2.54) */}
          <div id="an-pagemap" style={{ scrollMarginTop: 80 }} />
          <PageMapPanel pm={s.page_map} slug={slug} isAdmin={isAdmin} onRefreshed={load} />

          {/* Click heatmap over a page screenshot (snippet v2.94) */}
          <div id="an-clickmap" style={{ scrollMarginTop: 80 }} />
          <ClickHeatmapPanel slug={slug} pages={s.heatmap_pages} days={days} isAdmin={isAdmin} />

          {/* Scroll depth funnel (snippet v2.92+ — scroll_milestone events) */}
          <div id="an-scroll" style={{ scrollMarginTop: 80 }} />
          <ScrollFunnelPanel funnel={s.scroll_funnel} />

          {/* Named section visibility (snippet v2.92+ + data-cv-section attributes) */}
          <div id="an-sections" style={{ scrollMarginTop: 80 }} />
          <SectionViewsPanel sectionViews={s.section_views} />

          {/* Goals */}
          <div id="an-goals" style={{ scrollMarginTop: 80 }} />
          <GoalTracker slug={slug} conversions={s.conversions} />

          {/* Devices + Countries + Cities */}
          <div id="an-audience" style={{ scrollMarginTop: 80 }} />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16, marginBottom: 16 }}>
            {s.devices && Object.keys(s.devices).length > 0 && (
              <SectionCard style={{ margin: 0 }}>
                <CardLabel>Devices</CardLabel>
                {Object.entries(s.devices).map(([device, count], i, arr) => (
                  <div key={device} style={{ display: "flex", gap: 8, padding: "5px 0", borderBottom: i < arr.length - 1 ? "1px solid var(--border)" : "none", alignItems: "center" }}>
                    <div style={{ fontSize: 11, flex: 1, textTransform: "capitalize" }}>
                      {device === "mobile" ? "📱 " : device === "tablet" ? "⬜ " : "🖥 "}{device}
                    </div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)" }}>{count}</div>
                  </div>
                ))}
              </SectionCard>
            )}
            {s.top_countries && s.top_countries.length > 0 && (
              <SectionCard style={{ margin: 0 }}>
                <CardLabel>Countries</CardLabel>
                <ShowMore>{s.top_countries.map((c, i) => (
                  <div key={i} style={{ display: "flex", gap: 8, padding: "5px 0", borderBottom: i < s.top_countries.length - 1 ? "1px solid var(--border)" : "none" }}>
                    <div style={{ fontSize: 11, flex: 1 }}>{c.country || "Unknown"}</div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)" }}>{c.count}</div>
                  </div>
                ))}</ShowMore>
              </SectionCard>
            )}
            {s.browsers && Object.keys(s.browsers).length > 0 && (
              <SectionCard style={{ margin: 0 }}>
                <CardLabel>Browsers</CardLabel>
                <ShowMore>{Object.entries(s.browsers).map(([browser, count], i, arr) => (
                  <div key={browser} style={{ display: "flex", gap: 8, padding: "5px 0", borderBottom: i < arr.length - 1 ? "1px solid var(--border)" : "none" }}>
                    <div style={{ fontSize: 11, flex: 1 }}>{browser}</div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)" }}>{count}</div>
                  </div>
                ))}</ShowMore>
              </SectionCard>
            )}
            {s.campaigns && s.campaigns.length > 0 && (
              <SectionCard style={{ margin: 0 }}>
                <CardLabel>Campaigns</CardLabel>
                <ShowMore>{s.campaigns.map((c, i) => (
                  <div key={i} style={{ display: "flex", gap: 8, padding: "5px 0", borderBottom: i < s.campaigns.length - 1 ? "1px solid var(--border)" : "none" }}>
                    <div style={{ fontSize: 11, flex: 1, fontFamily: "var(--font-mono)" }}>{c.campaign}</div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)" }}>{c.count}</div>
                  </div>
                ))}</ShowMore>
              </SectionCard>
            )}
          </div>
          {/* Conversions breakdown — clickable, drills into filtered sessions */}
          <div id="an-conversions" style={{ scrollMarginTop: 80 }} />
          {s.conversions && s.conversions.total > 0 && (
            <SectionCard>
              <CardLabel>Conversion Events</CardLabel>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 10 }}>
                {CONVERSION_CARDS.filter(({ key }) => (s.conversions[key] || 0) > 0).map(({ key, eventType, label, icon, color }) => {
                  const isSelected = selectedConversion === eventType;
                  return (
                    <div
                      key={key}
                      onClick={() => setSelectedConversion(isSelected ? null : eventType)}
                      style={{
                        background: isSelected ? `${color}18` : "var(--surface2)",
                        border: `1px solid ${isSelected ? color : "var(--border)"}`,
                        borderRadius: 8, padding: "10px 14px",
                        cursor: "pointer", transition: "all 0.15s",
                      }}
                    >
                      <div style={{ fontSize: 18, marginBottom: 4 }}>{icon}</div>
                      <div style={{ fontSize: 22, fontWeight: 800, color, fontFamily: "var(--font-mono)", lineHeight: 1 }}>{s.conversions[key]}</div>
                      <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 3, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em" }}>{label}</div>
                      <div style={{ fontSize: 10, color: isSelected ? color : "var(--text-muted)", marginTop: 4, fontWeight: isSelected ? 700 : 400 }}>
                        {isSelected ? "▲ Hide sessions" : "▼ Show sessions"}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Filtered session panel */}
              {selectedConversion && (() => {
                const card     = CONVERSION_CARDS.find(c => c.eventType === selectedConversion);
                const filtered = (s.sessions || []).filter(sess =>
                  (sess.events || []).some(e => e.type === selectedConversion)
                );
                if (!filtered.length) return (
                  <div style={{ marginTop: 16, padding: "12px 0", color: "var(--text-muted)", fontSize: 13 }}>
                    No session detail available — session data may predate the latest snippet.
                  </div>
                );
                return (
                  <div style={{ marginTop: 16, borderTop: "1px solid var(--border)", paddingTop: 16 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 12, color: card?.color }}>
                      {card?.icon} {filtered.length} session{filtered.length !== 1 ? "s" : ""} with {card?.label.toLowerCase()}
                    </div>
                    <ConversionSessionList sessions={filtered} eventType={selectedConversion} />
                  </div>
                );
              })()}
            </SectionCard>
          )}

          {/* Enquiries by form choice and by page (snippet v2.93, app.py v3.67) */}
          <div id="an-choices" style={{ scrollMarginTop: 80 }} />
          <EnquiryChoicesPanel choices={s.form_choices} />
          <div id="an-page-conv" style={{ scrollMarginTop: 80 }} />
          <EnquiryPagesPanel pages={s.page_conversions} hasChoices={(s.form_choices || []).length > 0}
            hasForms={(s.conversions?.form_submits || 0) > 0} isAdmin={isAdmin} />

          {/* Snippet v2.94 conversion insights */}
          <div id="an-confirm" style={{ scrollMarginTop: 80 }} />
          <ConfirmationsPanel conf={s.confirmations} />
          <div id="an-path" style={{ scrollMarginTop: 80 }} />
          <PathToEnquiryPanel path={s.path_to_enquiry} />
          <div id="an-hours" style={{ scrollMarginTop: 80 }} />
          <OutOfHoursPanel ooh={s.out_of_hours} />
          <div id="an-ctas" style={{ scrollMarginTop: 80 }} />
          <CtaPanel ctas={s.cta_performance} />
          <div id="an-fields" style={{ scrollMarginTop: 80 }} />
          <FormFieldsPanel fields={s.form_fields} />
          <div id="an-speed" style={{ scrollMarginTop: 80 }} />
          <SpeedConversionPanel speed={s.speed_conversion} />

          {/* JS errors with expandable stack traces (snippet v2.92+) */}
          <div id="an-errors" style={{ scrollMarginTop: 80 }} />
          <JsErrorsPanel errors={s.js_errors} />

          {/* Rage clicks and 404s, grouped and made actionable */}
          <div id="an-rage" style={{ scrollMarginTop: 80 }} />
          <RageClickPanel detail={s.rage_click_detail} domain={domain} domains={domains} slug={slug} />
          <div id="an-404" style={{ scrollMarginTop: 80 }} />
          <Page404Panel  detail={s.page_404_detail}   domain={domain} domains={domains} />
          {/* Site search terms */}
          <div id="an-search" style={{ scrollMarginTop: 80 }} />
          {s.site_searches?.length > 0 && (
            <SectionCard>
              <CardLabel>Site Search Terms</CardLabel>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 12 }}>
                What visitors searched for on this site — content gaps and intent signals.
              </div>
              <ShowMore>{s.site_searches.map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: i < s.site_searches.length - 1 ? "1px solid var(--border)" : "none" }}>
                  <div style={{ fontSize: 12, flex: 1, fontFamily: "var(--font-mono)" }}>🔍 {item.term}</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font-mono)" }}>{item.count}</div>
                </div>
              ))}</ShowMore>
            </SectionCard>
          )}
          {/* Form field abandonment */}
          <div id="an-forms" style={{ scrollMarginTop: 80 }} />
          {s.field_abandonment?.length > 0 && (
            <SectionCard>
              <CardLabel>Form Abandonment — Last Field Reached</CardLabel>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 12 }}>
                The last field visitors focused before leaving without submitting. Higher counts suggest friction at that field.
              </div>
              <ShowMore>{s.field_abandonment.map((item, i) => {
                const max = s.field_abandonment[0].count;
                return (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                    <div style={{ width: 130, fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--text)", flexShrink: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={item.field}>{item.field}</div>
                    <div style={{ flex: 1, height: 8, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                      <div style={{ width: `${(item.count / max) * 100}%`, height: "100%", background: "#e6b800", borderRadius: 4 }} />
                    </div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#e6b800", fontFamily: "var(--font-mono)", width: 28, textAlign: "right" }}>{item.count}</div>
                  </div>
                );
              })}</ShowMore>
            </SectionCard>
          )}
          {/* Custom events (window.cv() API) */}
          <div id="an-custom" style={{ scrollMarginTop: 80 }} />
          {s.custom_events?.length > 0 && (
            <SectionCard>
              <CardLabel>Custom Events</CardLabel>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 10 }}>
                {s.custom_events.map((ev, i) => (
                  <div key={i} style={{ background: "var(--surface2)", border: "1px solid rgba(191,90,242,0.2)", borderRadius: 8, padding: "10px 14px" }}>
                    <div style={{ fontSize: 16, marginBottom: 4 }}>⭐</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: "#bf5af2", fontFamily: "var(--font-mono)", lineHeight: 1 }}>{ev.count}</div>
                    <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 3, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em" }}>{ev.label}</div>
                    {ev.total_value > 0 && (
                      <div style={{ fontSize: 11, color: "#bf5af2", marginTop: 4, fontWeight: 700 }}>
                        £{ev.total_value.toLocaleString("en-GB", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} total
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 12 }}>
                Custom events fire when <code style={{ fontSize: 10, fontFamily: "var(--font-mono)", background: "var(--surface2)", padding: "1px 5px", borderRadius: 3 }}>window.cv('label', {"{ value: 250 }"})</code> is called on the client site.
              </div>
            </SectionCard>
          )}
          {/* Combined attribution — discovery vs closing, tied per source */}
          <div id="an-attribution" style={{ scrollMarginTop: 80 }} />
          <AttributionPanel attribution={s.attribution} />

          {/* First-touch attribution */}
          <FirstTouchPanel firstTouchSources={s.first_touch_sources} />

          {/* Last-touch attribution (snippet v2.92+) */}
          <LastTouchPanel lastTouchSources={s.last_touch_sources} />

          {/* Ask insights — admin only (app.py v3.69) */}
          {isAdmin && <AskInsightsPanel slug={slug} />}

          {/* Settings — admin only */}
          {isAdmin && (
          <SectionCard style={{ marginTop: 4 }}>
            <CardLabel>Settings</CardLabel>

            {/* Snippet version status */}
            <div id="an-snippet" style={{ scrollMarginTop: 80 }} />
            {s.snippet_versions?.length > 0 && <SnippetVersionBanner versions={s.snippet_versions} current={s.snippet_current} />}
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap", alignItems: "flex-start" }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Tracking Snippet</div>
                <button className="btn btn-secondary btn-sm" onClick={loadSnippet}>{showSnippet ? "Hide Snippet" : "View / Update Snippet"}</button>
              </div>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Data Retention</div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select className="input-sm" value={retention} onChange={e => setRetention(parseInt(e.target.value))}>
                    {[7, 14, 30, 60, 90, 180, 365].map(d => <option key={d} value={d}>{d} days</option>)}
                  </select>
                  <button className="btn btn-primary btn-sm" onClick={saveRetention} disabled={retSaving}>
                    {retSaving ? "..." : "Save"}
                  </button>
                </div>
              </div>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Shareable read-only link</div>
                {shareUrl ? (
                  <div>
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <input className="input-sm" readOnly value={shareUrl} onFocus={e => e.target.select()}
                        style={{ flex: 1, minWidth: 0 }} />
                      <button className="btn btn-secondary btn-sm" onClick={() => { if (navigator.clipboard) navigator.clipboard.writeText(shareUrl).then(() => { setShareCopied(true); setTimeout(() => setShareCopied(false), 2500); }); }}>{shareCopied ? "Copied!" : "Copy"}</button>
                    </div>
                    <button className="btn btn-secondary btn-sm" style={{ marginTop: 6 }} onClick={revokeShare} disabled={shareBusy}>Revoke link</button>
                  </div>
                ) : (
                  <div>
                    <button className="btn btn-secondary btn-sm" onClick={createShare} disabled={shareBusy}>{shareBusy ? "..." : "Create link"}</button>
                    <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 6 }}>A public, read-only analytics page. Good for a prospect taster alongside the snippet.</div>
                  </div>
                )}
              </div>
            </div>
            <ReportScheduleSettings slug={slug} />
            {showSnippet && snippet && (
              <div style={{ marginTop: 16 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <div style={{ fontSize: 11, color: "var(--text-muted)" }}>
                  Paste into {"<head>"} on every page. Tracks sessions, scroll depth milestones, and AI chatbot referrals without cookies.
                  Add <code style={{ fontSize: 10, fontFamily: "var(--font-mono)", background: "var(--surface2)", padding: "1px 5px", borderRadius: 3 }}>data-cv-section="name"</code> to landmark elements to track section visibility.
                </div>
                  <button className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }} onClick={copySnippet}>{copied ? "Copied!" : "Copy"}</button>
                </div>
                <pre style={{ fontSize: 11, background: "var(--surface2)", padding: "12px 14px", borderRadius: 8,
                  overflow: "auto", fontFamily: "var(--font-mono)", whiteSpace: "pre-wrap",
                  border: "1px solid var(--border)", color: "var(--text)", lineHeight: 1.6, maxHeight: 300 }}>{snippet}</pre>
                <div style={{ marginTop: 10, display: "flex", gap: 16, flexWrap: "wrap" }}>
                  <div style={{ fontSize: 11, color: "var(--text-muted)" }}><strong>WordPress:</strong> Use "Insert Headers and Footers" plugin.</div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)" }}><strong>Google Tag Manager:</strong> Custom HTML tag, trigger on All Pages.</div>
                </div>
              </div>
            )}
          </SectionCard>
          )}
        </div>
      )}
    </div>
  );
}


// ── Cookie Compliance ─────────────────────────────────────────────────────────

function CookiesSection({ slug }) {
  const { data, loading } = useTool(slug, "cookies");

  if (loading) return <div style={{ padding: 40, textAlign: "center" }}><span className="spinner" /></div>;
  if (!data?.available) return <NoData tool="cookie compliance" />;

  const d   = data.data || {};
  const sum = d.summary || {};
  const targets = d.targets || [];

  const highIssues   = sum.high_issues   || 0;
  const medIssues    = sum.medium_issues || 0;
  const lowIssues    = sum.low_issues    || 0;
  const totalIssues  = highIssues + medIssues + lowIssues;
  const overallColor = highIssues > 0 ? "#ff2d55" : medIssues > 0 ? "#e6b800" : "#30d158";

  const catColor = { functional: "#30d158", analytics: "#e6b800", marketing: "#ff2d55", unknown: "#86868b" };
  const sevColor = { high: "#ff2d55", medium: "#e6b800", low: "#86868b" };
  const sevBg    = { high: "rgba(255,45,85,0.08)", medium: "rgba(230,184,0,0.08)", low: "rgba(134,134,139,0.08)" };

  return (
    <div>
      <ScannedAt ts={d.scanned_at} />

      {/* Summary strip */}
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 24 }}>
        <StatBadge value={sum.hosts_scanned  || 0} label="Hosts Scanned"    color="var(--accent)" />
        <StatBadge value={sum.total_cookies  || 0} label="Cookies Found"    color="var(--accent)" />
        <StatBadge value={sum.tracker_instances || 0} label="Trackers"      color={sum.tracker_instances > 0 ? "#e6b800" : "#30d158"} />
        <StatBadge value={sum.with_cmp       || 0} label="With CMP"         color={sum.with_cmp > 0 ? "#30d158" : "#ff2d55"} />
        <StatBadge value={totalIssues}             label="Issues"           color={overallColor} />
      </div>

      {/* Per-host cards */}
      {targets.filter(t => t.reachable).map(t => {
        const allCookies = t.cookies_pre_consent || [];
        const byCat = allCookies.reduce((acc, c) => { acc[c.category] = (acc[c.category] || 0) + 1; return acc; }, {});
        const issues  = t.issues || [];
        const highC   = issues.filter(i => i.severity === "high").length;
        const medC    = issues.filter(i => i.severity === "medium").length;
        const hostColor = highC > 0 ? "#ff2d55" : medC > 0 ? "#e6b800" : "#30d158";

        return (
          <SectionCard key={t.url}>
            {/* Host header */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: hostColor, flexShrink: 0 }} />
              <div style={{ fontSize: 14, fontWeight: 700, fontFamily: "var(--font-mono)", color: "var(--text)", flex: 1 }}>{t.url}</div>
              {t.final_url && t.final_url !== t.url && (
                <div style={{ fontSize: 11, color: "var(--text-muted)" }}>→ {t.final_url}</div>
              )}
            </div>

            {/* Indicators row */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: issues.length > 0 ? 16 : 0 }}>
              {[
                { label: "CMP",           ok: t.cmps_detected?.length > 0,  detail: t.cmps_detected?.join(", ") || "None detected" },
                { label: "Consent Banner",ok: t.has_consent_banner || t.cmps_detected?.length > 0, detail: t.cmps_detected?.length > 0 && !t.has_consent_banner ? "Managed by CMP" : null },
                { label: "Policy Link",   ok: t.has_policy_link   || t.cmps_detected?.length > 0, detail: t.cmps_detected?.length > 0 && !t.has_policy_link   ? "Managed by CMP" : null },
              ].map(({ label, ok, detail }) => (
                <div key={label} style={{
                  display: "flex", alignItems: "center", gap: 6,
                  background: ok ? "rgba(48,209,88,0.08)" : "rgba(255,45,85,0.08)",
                  border: `1px solid ${ok ? "rgba(48,209,88,0.25)" : "rgba(255,45,85,0.25)"}`,
                  borderRadius: 6, padding: "4px 10px",
                }}>
                  <span style={{ fontSize: 11, color: ok ? "#30d158" : "#ff2d55" }}>{ok ? "✓" : "✗"}</span>
                  <span style={{ fontSize: 11, fontWeight: 600, color: "var(--text)" }}>{label}</span>
                  {detail && <span style={{ fontSize: 10, color: "var(--text-muted)" }}>({detail})</span>}
                </div>
              ))}
            </div>

            {/* Cookie category breakdown */}
            {allCookies.length > 0 && (
              <div style={{ marginBottom: issues.length > 0 ? 16 : 0 }}>
                <div style={{ fontSize: 10, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>
                  Cookies Set Before Consent ({allCookies.length})
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {Object.entries(byCat).map(([cat, count]) => (
                    <div key={cat} style={{
                      display: "flex", alignItems: "center", gap: 5,
                      background: "var(--surface2)", borderRadius: 5, padding: "3px 8px",
                      border: `1px solid ${catColor[cat] || "#86868b"}30`,
                    }}>
                      <div style={{ width: 6, height: 6, borderRadius: "50%", background: catColor[cat] || "#86868b" }} />
                      <span style={{ fontSize: 11, textTransform: "capitalize", color: "var(--text)" }}>{cat}</span>
                      <span style={{ fontSize: 11, fontWeight: 700, color: catColor[cat] || "#86868b", fontFamily: "var(--font-mono)" }}>{count}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Trackers */}
            {t.trackers_detected?.length > 0 && (
              <div style={{ marginBottom: issues.length > 0 ? 16 : 0 }}>
                <div style={{ fontSize: 10, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>
                  Trackers Detected ({t.trackers_detected.length})
                </div>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {t.trackers_detected.map(tr => (
                    <span key={tr} style={{ fontSize: 11, background: "rgba(230,184,0,0.1)", border: "1px solid rgba(230,184,0,0.25)", borderRadius: 4, padding: "2px 8px", color: "#e6b800" }}>{tr}</span>
                  ))}
                </div>
              </div>
            )}

            {/* Issues */}
            {issues.length > 0 && (
              <div>
                <div style={{ fontSize: 10, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>
                  Issues ({issues.length})
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {issues.map((issue, idx) => (
                    <div key={idx} style={{
                      display: "flex", gap: 10, alignItems: "flex-start",
                      background: sevBg[issue.severity] || sevBg.low,
                      border: `1px solid ${sevColor[issue.severity] || "#86868b"}30`,
                      borderRadius: 6, padding: "8px 12px",
                    }}>
                      <span style={{ fontSize: 10, fontWeight: 700, color: sevColor[issue.severity] || "#86868b",
                        textTransform: "uppercase", letterSpacing: "0.05em", flexShrink: 0, marginTop: 1 }}>{issue.severity}</span>
                      <span style={{ fontSize: 12, color: "var(--text)", lineHeight: 1.5 }}>{issue.detail}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* No issues */}
            {issues.length === 0 && allCookies.length === 0 && (
              <div style={{ fontSize: 12, color: "var(--text-muted)", fontStyle: "italic" }}>No cookies detected on initial page load.</div>
            )}
            {issues.length === 0 && allCookies.length > 0 && (
              <div style={{ fontSize: 12, color: "#30d158", marginTop: 8 }}>No compliance issues detected.</div>
            )}
          </SectionCard>
        );
      })}

      {targets.filter(t => !t.reachable).length > 0 && (
        <SectionCard>
          <div style={{ fontSize: 11, color: "var(--text-muted)" }}>
            {targets.filter(t => !t.reachable).length} host(s) unreachable during scan.
          </div>
        </SectionCard>
      )}
    </div>
  );
}

// ── Marketing tab ─────────────────────────────────────────────────────────────
// Translates SEO/GEO/Performance findings into plain-English client recommendations.

const REC_PRIORITY = {
  high:   { label: "Action required", color: "#ff2d55", bg: "rgba(255,45,85,0.06)",  border: "rgba(255,45,85,0.2)"  },
  medium: { label: "Recommended",     color: "#e6b800", bg: "rgba(230,184,0,0.06)",  border: "rgba(230,184,0,0.2)"  },
  low:    { label: "Nice to Have",    color: "#00d4ff", bg: "rgba(0,212,255,0.06)",   border: "rgba(0,212,255,0.2)"  },
};

const REC_CAT_COLOR = {
  "VISIBILITY":  "#0a84ff",
  "SPEED":       "#30d158",
  "TRUST":       "#ff9f0a",
  "AI PRESENCE": "#bf5af2",
};

function buildRecs(data) {
  if (!data?.results) return [];
  const domains = Object.keys(data.results);
  if (!domains.length) return [];

  // Aggregate: flag if ANY domain fails the check
  const anyFail = key => domains.some(d => !data.results[d]?.seo?.checks?.[key]);

  // Score averages across all domains (ignore 0/missing)
  const avgOf = getter => {
    const vals = domains.map(getter).filter(v => v > 0);
    return vals.length ? Math.round(vals.reduce((a, b) => a + b) / vals.length) : null;
  };
  const perfAvg = avgOf(d => data.results[d]?.performance?.mobile?.scores?.performance || 0);
  const accAvg  = avgOf(d => data.results[d]?.performance?.mobile?.scores?.accessibility || 0);

  // GEO signals
  const anyBlockedCrawler = domains.some(d =>
    Object.values(data.results[d]?.geo?.ai_crawlers || {}).some(c => c.blocked));
  const llmsPresent   = domains.some(d => data.results[d]?.geo?.llms_txt?.present);
  const schemaPresent = domains.some(d => data.results[d]?.seo?.checks?.has_schema_org);

  const recs = [];
  const add = (id, priority, category, title, body, action) =>
    recs.push({ id, priority, category, title, body, action });

  // ── Visibility ────────────────────────────────────────────────────────────
  if (anyFail("has_title"))
    add("title", "high", "VISIBILITY",
      "Your homepage is missing a page title",
      "The page title is the blue link text shown in search results. Without one, search engines display your domain name or random text from the page — rarely a good first impression for someone deciding whether to visit your site.",
      "Add a title tag to your homepage that includes your business name followed by a short description of what you do and where you serve.");

  if (anyFail("has_description"))
    add("desc", "medium", "VISIBILITY",
      "Your search result snippet is missing",
      "When your site appears in search results, a short description normally appears beneath the link. Without one, search engines pull random text from the page — often something unhelpful. Writing your own gives you control over how your business is presented to potential customers.",
      "Add a meta description of 150–160 characters to your homepage that clearly explains what you do and who you help.");

  if (anyFail("has_h1"))
    add("h1", "medium", "VISIBILITY",
      "Your homepage doesn't have a clear main heading",
      "Search engines use the main heading on a page to understand what it's about. Without one, they have to guess from the surrounding content, which can lead to your site being categorised inaccurately.",
      "Add a single, clear main heading to your homepage that describes your business or your primary service.");

  if (anyFail("has_og_tags"))
    add("og", "medium", "VISIBILITY",
      "Links to your site look plain when shared online",
      "When someone shares your website on LinkedIn, in an email, or on a messaging app, it normally shows a preview with an image and description. Without Open Graph tags, the link appears as plain text — far less likely to be clicked.",
      "Add Open Graph tags to your homepage with a title, description, and a suitable image. This is one of the quickest ways to increase traffic from shared links.");

  if (anyFail("has_sitemap"))
    add("sitemap", "medium", "VISIBILITY",
      "Search engines may be missing pages on your site",
      "A sitemap is a file that tells search engines which pages exist on your website. Without one, newer or deeper pages may never appear in search results at all.",
      "Ask your web developer to generate an XML sitemap and submit it to search engines. This is usually a quick task and ensures all your pages can be found.");

  if (anyFail("images_have_alt"))
    add("alt", "low", "VISIBILITY",
      "Images on your site are invisible to search engines",
      "Search engines cannot see images — they rely on descriptive text (alt text) to understand what each image shows. Images without alt text are also inaccessible to visitors using screen readers.",
      "Add a short label to every image on your site describing what it shows. For example, 'Team photo taken at our Birmingham office' rather than leaving it blank.");

  if (anyFail("has_canonical"))
    add("canonical", "low", "VISIBILITY",
      "Your homepage may be splitting its search ranking across multiple URLs",
      "Your site can be accessed via several slightly different addresses (with or without www, with or without a trailing slash). Without a canonical tag, search engines may treat these as separate pages and divide your ranking signals between them.",
      "Ask your web developer to add a canonical tag pointing to the preferred version of your homepage URL. This is a straightforward technical fix.");

  // ── Trust ─────────────────────────────────────────────────────────────────
  if (anyFail("https_redirect"))
    add("https", "high", "TRUST",
      "Visitors can reach your site without a secure connection",
      "Your website doesn't automatically send visitors to the secure (https://) version. Some may see a 'Not Secure' warning in their browser — particularly concerning on contact forms and enquiry pages where people share their details.",
      "Configure your hosting to automatically redirect all http:// requests to https://. Most hosting providers offer this as a simple one-click setting.");

  if (accAvg !== null && accAvg < 70)
    add("acc-low", "medium", "TRUST",
      "Some visitors may be unable to use parts of your website",
      `Your site scores ${accAvg}/100 for accessibility. This means some features may be difficult or impossible for people with visual impairments or those using assistive technology. Accessibility is also increasingly factored into search rankings.`,
      "Ask your web developer to run an accessibility audit. Common quick fixes include improving colour contrast, ensuring buttons have descriptive labels, and checking that the site can be navigated with a keyboard alone.");
  else if (accAvg !== null && accAvg < 85)
    add("acc-med", "low", "TRUST",
      "Your website's accessibility could be improved",
      `Your site scores ${accAvg}/100 for accessibility. While functional, some visitors with disabilities may find parts of the site difficult to use. This is also a factor in how search engines assess site quality.`,
      "Ask your web developer to check colour contrast ratios, form labels, and keyboard navigation across the site.");

  // ── Speed ─────────────────────────────────────────────────────────────────
  if (perfAvg !== null && perfAvg < 50)
    add("perf-low", "high", "SPEED",
      "Your website loads very slowly",
      `Your site scores ${perfAvg}/100 for loading speed on mobile devices. Research consistently shows that most visitors abandon a page that takes more than three seconds to load — and search engines penalise slow sites in their rankings. This is likely costing you visitors and enquiries every day.`,
      "Share this report with your web developer. The Performance tab has a detailed breakdown of exactly what's slowing the site down and how much time could be saved by fixing each issue.");
  else if (perfAvg !== null && perfAvg < 70)
    add("perf-med", "medium", "SPEED",
      "Your website loads slowly on mobile devices",
      `Your site scores ${perfAvg}/100 for loading speed on mobile. Many visitors browse on smartphones, and slow loading causes them to leave before they've seen your content. Faster sites also rank higher in search results.`,
      "Ask your web developer to optimise images, reduce unnecessary scripts, and review anything delaying the page from appearing. The Performance tab has a full breakdown of improvement opportunities.");
  else if (perfAvg !== null && perfAvg < 85)
    add("perf-ok", "low", "SPEED",
      "There are opportunities to make your website a little faster",
      `Your site scores ${perfAvg}/100 for loading speed — acceptable, but not as fast as it could be. Even modest speed improvements can reduce the number of visitors who leave before the page has fully loaded.`,
      "Review the Performance tab for specific opportunities. Compressing images and deferring non-essential scripts are usually the quickest wins.");

  // ── AI Presence ───────────────────────────────────────────────────────────
  if (anyBlockedCrawler)
    add("ai-blocked", "high", "AI PRESENCE",
      "AI assistants are blocked from reading your website",
      "Your website's robots.txt file is preventing AI systems from accessing your content. This means your business will not appear when potential customers ask AI tools for recommendations in your sector or area — an increasingly common way people discover services.",
      "Review your robots.txt file with your web developer and remove restrictions on AI crawlers. Unless there is a specific reason to block them, allowing access is important for future visibility.");

  if (!schemaPresent)
    add("schema", "medium", "AI PRESENCE",
      "Search engines and AI have limited understanding of your business",
      "Structured data is a way of telling search engines and AI systems exactly what your business does — your name, address, services, opening hours, and more. Without it, they have to infer this from your page text, which is less reliable and can lead to inaccurate descriptions.",
      "Ask your web developer to add Schema.org structured data to your website. For most businesses, the Organisation or LocalBusiness type is the right starting point and can typically be added in an hour or less.");

  if (!llmsPresent)
    add("llms", "low", "AI PRESENCE",
      "You're missing an AI-readable summary of your business",
      "An llms.txt file is a new standard that allows AI assistants to quickly find a clear, plain-language description of what your business does without having to crawl the entire site. Early adopters gain a small but meaningful advantage in how AI systems describe their business.",
      "Ask your web developer to create a simple llms.txt file at the root of your domain with a short description of your business, your main services, and who you serve.");

  // ── Content analysis recommendations ───────────────────────────────────────
  // Only fires when content data exists (requires seo-geo-check.py v1.4+)
  const contentOf = d => data.results[d]?.content || {};
  const hasContent = domains.some(d => Object.keys(data.results[d]?.content || {}).length > 0);

  if (hasContent) {

    // Generic / weak H1
    if (domains.some(d => contentOf(d).h1_generic))
      add("h1-generic", "high", "VISIBILITY",
        "Your main homepage heading doesn't describe your business",
        "Your homepage opens with a generic phrase like 'Welcome' or 'Home'. This tells search engines very little about what you do, and gives visitors no immediate reason to stay. The main heading is one of the most influential pieces of text on the entire page.",
        "Rewrite your main heading to clearly state what your business does and who you serve. For example, 'IT Support for Small Businesses in the West Midlands' is far more effective than 'Welcome to Acme Ltd'.");

    // Thin content
    const wcs = domains.map(d => contentOf(d).word_count || 0).filter(v => v > 0);
    const minWc = wcs.length ? Math.min(...wcs) : null;
    if (minWc !== null && minWc < 200)
      add("words-thin", "high", "VISIBILITY",
        "Your homepage has very little content",
        `Your homepage contains around ${minWc} words. Search engines consider pages under 300 words as 'thin content', which limits how well they can rank. It also gives visitors very little information to help them decide whether to contact you.`,
        "Add more content describing your main services, who you help, how you work, and what makes you different. Aim for at least 400–500 words of clear, readable text.");
    else if (minWc !== null && minWc < 350)
      add("words-short", "medium", "VISIBILITY",
        "Your homepage content could be expanded",
        `Your homepage has around ${minWc} words. While not critically short, adding more descriptive content about your services and approach would help search engines rank the page and give visitors more confidence before they contact you.`,
        "Consider adding a short section about your key services, your approach, or what sets you apart. Even an additional 150–200 words of well-written content makes a meaningful difference.");

    // No call to action
    if (!domains.some(d => contentOf(d).has_cta))
      add("no-cta", "high", "TRUST",
        "Your homepage doesn't have a clear call to action",
        "There's no obvious invitation for visitors to take the next step — no 'Contact Us', 'Get a Quote', or 'Call Now' is visible on the page. Visitors who are interested but given no clear direction often simply leave.",
        "Add a prominent call to action in the upper half of your homepage — a button or highlighted panel that tells visitors exactly what to do next and makes it as easy as possible to do it.");

    // No phone number
    if (domains.some(d => !contentOf(d).has_phone))
      add("no-phone", "medium", "TRUST",
        "No phone number is visible on your homepage",
        "Many enquiries — particularly from local customers and older demographics — still come by phone. If your number isn't easy to find on the homepage, you're creating unnecessary friction for these potential customers.",
        "Add your phone number prominently on the homepage, ideally in the header so it's visible without scrolling. Make it a clickable tel: link so mobile users can call with one tap.");

    // No location mention
    if (domains.some(d => !contentOf(d).has_location_mention))
      add("no-location", "medium", "VISIBILITY",
        "Your homepage doesn't mention where you're based",
        "Local search results heavily favour businesses that clearly state their location. Without a location mention, search engines have to guess where you operate — which can result in your site appearing in results for the wrong areas or not appearing at all.",
        "Add your town, city, or service area to your homepage — ideally in the main heading or opening paragraph. If you cover multiple areas, list them. A postal address or postcode also helps significantly.");

    // No customer reviews
    if (domains.some(d => !contentOf(d).has_reviews))
      add("no-reviews", "medium", "TRUST",
        "Your homepage doesn't feature any customer reviews",
        "Most people research a business before making contact. Customer reviews or testimonials on the homepage provide immediate social proof and significantly increase the chance a visitor will reach out rather than move on to a competitor.",
        "Add two or three short customer quotes to your homepage with the customer's name and company where possible. Even brief, genuine testimonials make a meaningful difference to visitor confidence.");

    // H1 identical to page title
    if (domains.some(d => contentOf(d).h1_matches_title))
      add("h1-title-same", "low", "VISIBILITY",
        "Your page title and main heading say exactly the same thing",
        "Your homepage title tag and H1 heading contain identical text. This is a missed opportunity — the title appears in search results and should be optimised for discovery, while the H1 is what visitors see first and can be more conversational and benefit-led.",
        "Keep your title tag focused on search visibility (include your primary keyword and location), and make the H1 more engaging for actual visitors: describe the benefit you deliver, not just your business name.");

    // H1 matches title but different opportunity — heading has no subheadings
    if (domains.some(d => contentOf(d).h2_count === 0))
      add("no-h2", "low", "VISIBILITY",
        "Your homepage has no subheadings to structure the content",
        "Without subheadings (H2s), your page is harder for both visitors and search engines to scan. Subheadings help people quickly find the section relevant to them and signal to search engines what topics the page covers.",
        "Break your homepage content into sections with clear subheadings — for example, 'What We Do', 'Who We Work With', 'Why Choose Us'. This improves readability and gives search engines more signals about your services.");

    // No accreditations
    if (domains.some(d => !contentOf(d).has_accreditations))
      add("no-accreditations", "low", "TRUST",
        "Your accreditations and certifications aren't mentioned on the homepage",
        "Industry accreditations, certifications, and memberships are strong trust signals — particularly for B2B buyers and procurement teams. If you hold relevant credentials, they should be visible without visitors having to look for them.",
        "Add a brief mention or logo strip of your key accreditations — Cyber Essentials, ISO certifications, trade body memberships, or any relevant professional qualifications. Place these where visitors will see them without scrolling.");

    // No years in business / experience
    if (domains.some(d => !contentOf(d).has_experience_mention))
      add("no-experience", "low", "TRUST",
        "How long you've been in business isn't mentioned",
        "Years of trading is a quick, credible trust signal. 'Established 2008' or '15 years of experience' immediately conveys stability and reliability — particularly valuable for visitors who don't already know you.",
        "Add a simple mention of how long you've been trading to your homepage — in your opening paragraph, an about section, or a stats strip. It's a small change that consistently improves first impressions.");

    // Impersonal / passive tone
    if (domains.some(d => !contentOf(d).uses_conversational_tone))
      add("passive-tone", "low", "VISIBILITY",
        "Your homepage uses impersonal language",
        "Content written in first and second person ('we', 'you', 'our') tends to engage visitors more effectively than passive or impersonal phrasing. It reads more naturally and converts better because it feels like a direct conversation.",
        "Review your homepage copy and replace passive phrasing with direct language where possible. 'We help businesses protect their data' is more engaging than 'Data protection services are available'.");

    // No blog or news section
    if (domains.some(d => !contentOf(d).has_blog_or_news))
      add("no-blog", "low", "VISIBILITY",
        "You don't have a blog or news section",
        "Regularly updated content is one of the most reliable ways to improve search rankings over time. A blog or news section also gives you content to share on social media and positions your business as knowledgeable in your sector.",
        "Consider adding a simple blog or news section and committing to publishing something once a month — even a short article, case study, or update. Content that answers common customer questions tends to perform particularly well.");

  }

  // ── Sort: high → medium → low ──────────────────────────────────────────────
  const order = { high: 0, medium: 1, low: 2 };
  return recs.sort((a, b) => order[a.priority] - order[b.priority]);
}

function RecCard({ rec }) {
  const ps = REC_PRIORITY[rec.priority];
  const catColor = REC_CAT_COLOR[rec.category] || "var(--text-muted)";
  return (
    <div style={{
      background: ps.bg, border: `1px solid ${ps.border}`,
      borderRadius: "var(--radius-lg)", padding: "16px 20px", marginBottom: 12,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <span style={{
          fontSize: 9, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
          color: catColor, background: `${catColor}18`, border: `1px solid ${catColor}40`,
          padding: "2px 8px", borderRadius: 4,
        }}>{rec.category}</span>
        <span style={{
          fontSize: 9, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase",
          color: ps.color,
        }}>{ps.label}</span>
      </div>
      <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text)", marginBottom: 8, lineHeight: 1.35 }}>
        {rec.title}
      </div>
      <div style={{ fontSize: 12, color: "var(--text-muted)", lineHeight: 1.65, marginBottom: 12 }}>
        {rec.body}
      </div>
      <div style={{
        fontSize: 11, color: "var(--text)", background: "var(--surface)",
        border: "1px solid var(--border)", borderRadius: 6, padding: "8px 12px",
        display: "flex", gap: 8, alignItems: "flex-start",
      }}>
        <span style={{ color: ps.color, fontWeight: 700, flexShrink: 0 }}>→</span>
        <span style={{ lineHeight: 1.55 }}>{rec.action}</span>
      </div>
    </div>
  );
}

// ── Star rating display ───────────────────────────────────────────────────────

function StarRating({ rating, max = 5 }) {
  if (!rating) return null;
  return (
    <span style={{ display: "inline-flex", gap: 1, alignItems: "center" }}>
      {Array.from({ length: max }).map((_, i) => {
        const filled = rating >= i + 1;
        const half   = !filled && rating >= i + 0.5;
        return (
          <span key={i} style={{ fontSize: 14, color: filled || half ? "#f5a623" : "var(--border)", lineHeight: 1 }}>
            {filled ? "★" : half ? "⯨" : "☆"}
          </span>
        );
      })}
    </span>
  );
}

// ── Reputation panel ──────────────────────────────────────────────────────────

function ReputationPanel({ slug, isAdmin }) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);
  const [selIdx,  setSelIdx]  = useState(0);
  const [query,   setQuery]   = useState("");
  const [editCfg, setEditCfg] = useState(false);
  const [saving,  setSaving]  = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    authFetch(`/api/clients/${slug}/reputation`)
      .then(r => r.json())
      .then(d => { setData(d); setQuery(d?.config?.query || ""); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  useEffect(() => { load(); }, [load]);

  const runNow = async () => {
    setRunning(true);
    await authFetch(`/api/clients/${slug}/reputation/refresh`, { method: "POST" }).catch(() => {});
    setRunning(false);
    load();
  };

  const saveConfig = async () => {
    setSaving(true);
    await authFetch(`/api/clients/${slug}/reputation/config`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query }),
    }).catch(() => {});
    setSaving(false);
    setEditCfg(false);
    if (query) { setRunning(true); load(); }
  };

  if (loading) return <SectionCard><div style={{ padding: 32, textAlign: "center" }}><span className="spinner" /></div></SectionCard>;

  const mode = data?.mode || "single";

  // ── Multi-location rendering ──────────────────────────────────────────────
  if (mode === "locations") {
    const locations = data?.locations || [];

    const renderLocDetail = (loc) => {
      if (!loc) return null;
      const latest  = loc.latest;
      const history = loc.history || [];
      const trend   = history.slice(-12).filter(h => h.rating).map(h => ({ ts: h.ts, rating: h.rating }));
      const delta   = trend.length >= 2 ? (trend[trend.length-1].rating - trend[0].rating).toFixed(1) : null;
      if (!latest) return (
        <div style={{ fontSize: 12, color: "var(--text-muted)", padding: "12px 0" }}>
          No data yet for <strong>{loc.name}</strong>.{" "}
          {loc.config?.query ? "Click Check now to fetch." : "Set a Google reputation query in client Settings."}
        </div>
      );
      return (
        <div>
          <div style={{ display: "flex", gap: 24, alignItems: "flex-start", flexWrap: "wrap", marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 48, fontWeight: 800, color: "#f5a623", fontFamily: "var(--font-mono)", lineHeight: 1 }}>
                {latest.rating?.toFixed(1) || "—"}
              </div>
              <StarRating rating={latest.rating} />
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 4 }}>
                {latest.review_count?.toLocaleString()} Google reviews
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 160 }}>
              {latest.business_name && <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>{latest.business_name}</div>}
              {latest.business_type && <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 4 }}>{latest.business_type}</div>}
              {latest.address && <div style={{ fontSize: 11, color: "var(--text-muted)" }}>📍 {latest.address}</div>}
              {delta !== null && (
                <div style={{ marginTop: 8, fontSize: 12 }}>
                  Trend: <span style={{ color: parseFloat(delta) >= 0 ? "#30d158" : "#ff2d55", fontWeight: 700 }}>
                    {parseFloat(delta) >= 0 ? "+" : ""}{delta} since first check
                  </span>
                </div>
              )}
            </div>
          </div>
          {latest.sources?.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 }}>
              {latest.sources.map((s, i) => (
                <a key={i} href={s.url} target="_blank" rel="noopener noreferrer"
                  className="btn btn-secondary btn-sm">
                  {s.domain} · ⭐ {s.rating} ({s.count})
                </a>
              ))}
            </div>
          )}
          <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 10 }}>
            Last checked: {new Date(latest.ts).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" })} GMT
          </div>
        </div>
      );
    };

    return (
      <SectionCard>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
          <CardLabel style={{ marginBottom: 0 }}>Google Reputation</CardLabel>
          <button className="btn btn-secondary btn-sm" onClick={runNow} disabled={running}>
            {running ? "Checking…" : "↻ Check now"}
          </button>
        </div>
        {!locations.length ? (
          <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
            Add locations in client Settings and set a Google reputation query per branch to start tracking ratings.
          </div>
        ) : (
          <>
            {locations.length > 1 && (
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 16 }}>
                {locations.map((loc, i) => (
                  <button className="btn btn-secondary btn-sm" aria-pressed={selIdx === i} key={i} onClick={() => setSelIdx(i)}>{loc.name || `Location ${i + 1}`}</button>
                ))}
              </div>
            )}
            {renderLocDetail(locations[selIdx] || locations[0])}
          </>
        )}
      </SectionCard>
    );
  }

  // ── Legacy single-location rendering ─────────────────────────────────────
  const latest  = data?.latest;
  const history = data?.history || [];
  const trend   = history.slice(-12).filter(h => h.rating).map(h => ({ ts: h.ts, rating: h.rating, count: h.review_count }));
  const ratingDelta = trend.length >= 2 ? (trend[trend.length - 1].rating - trend[0].rating).toFixed(1) : null;

  if (!data?.config?.query && !editCfg) return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <CardLabel style={{ marginBottom: 0 }}>Google Reputation</CardLabel>
        {isAdmin && <button className="btn btn-secondary btn-sm" onClick={() => setEditCfg(true)}>Configure</button>}
      </div>
      <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
        Set a search query to track this client's Google rating. Or add locations in Settings for multi-branch tracking.
        <br />Example: <em>JK Tyres Autocentre Falkirk</em>
      </div>
    </SectionCard>
  );

  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
        <CardLabel style={{ marginBottom: 0 }}>Google Reputation</CardLabel>
        <div style={{ display: "flex", gap: 8 }}>
          {isAdmin && <button className="btn btn-secondary btn-sm" onClick={() => setEditCfg(e => !e)}>
            {editCfg ? "Cancel" : "Edit query"}
          </button>}
          <button className="btn btn-secondary btn-sm" onClick={runNow} disabled={running}>
            {running ? "Checking…" : "↻ Check now"}
          </button>
        </div>
      </div>
      {editCfg && isAdmin && (
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          <input className="input-sm" value={query} onChange={e => setQuery(e.target.value)}
            placeholder="e.g. JK Tyres Autocentre Falkirk"
            style={{ flex: 1 }} />
          <button className="btn btn-primary btn-sm" onClick={saveConfig} disabled={saving}>
            {saving ? "Saving…" : "Save and run"}
          </button>
        </div>
      )}
      {latest && (
        <div>
          <div style={{ display: "flex", gap: 24, alignItems: "flex-start", flexWrap: "wrap", marginBottom: 20 }}>
            <div>
              <div style={{ fontSize: 48, fontWeight: 800, color: "#f5a623", fontFamily: "var(--font-mono)", lineHeight: 1 }}>
                {latest.rating?.toFixed(1) || "—"}
              </div>
              <StarRating rating={latest.rating} />
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 4 }}>
                {latest.review_count?.toLocaleString()} Google reviews
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 160 }}>
              {latest.business_name && <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>{latest.business_name}</div>}
              {latest.business_type && <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 4 }}>{latest.business_type}</div>}
              {latest.address && <div style={{ fontSize: 11, color: "var(--text-muted)" }}>📍 {latest.address}</div>}
              {ratingDelta !== null && (
                <div style={{ marginTop: 8, fontSize: 12 }}>
                  Trend: <span style={{ color: parseFloat(ratingDelta) >= 0 ? "#30d158" : "#ff2d55", fontWeight: 700 }}>
                    {parseFloat(ratingDelta) >= 0 ? "+" : ""}{ratingDelta} since first check
                  </span>
                </div>
              )}
            </div>
          </div>
          {latest.sources?.length > 0 && (
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 8 }}>Other sources</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {latest.sources.map((s, i) => (
                  <a key={i} href={s.url} target="_blank" rel="noopener noreferrer"
                    className="btn btn-secondary btn-sm">
                    {s.domain} · ⭐ {s.rating} ({s.count})
                  </a>
                ))}
              </div>
            </div>
          )}
          <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 12 }}>
            Last checked: {new Date(latest.ts).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" })} GMT
          </div>
        </div>
      )}
    </SectionCard>
  );
}


// ── Competitor presence panel ─────────────────────────────────────────────────

function CompetitorPanel({ slug, isAdmin }) {
  const [data,      setData]      = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [running,   setRunning]   = useState(false);
  const [editCfg,   setEditCfg]   = useState(false);
  const [keywords,  setKeywords]  = useState("");
  const [ownDoms,   setOwnDoms]   = useState("");
  const [saving,    setSaving]    = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    authFetch(`/api/clients/${slug}/competitors`)
      .then(r => r.json())
      .then(d => {
        setData(d);
        setKeywords((d?.config?.keywords || []).join("\n"));
        setOwnDoms((d?.config?.own_domains || []).join("\n"));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [slug]);

  useEffect(() => { load(); }, [load]);

  const saveConfig = async () => {
    setSaving(true);
    const kws  = keywords.split("\n").map(s => s.trim()).filter(Boolean);
    const doms = ownDoms.split("\n").map(s => s.trim()).filter(Boolean);
    await authFetch(`/api/clients/${slug}/competitors/config`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ keywords: kws, own_domains: doms }),
    }).catch(() => {});
    setSaving(false);
    setEditCfg(false);
    load();
  };

  const runNow = async () => {
    setRunning(true);
    await authFetch(`/api/clients/${slug}/competitors/refresh`, { method: "POST" }).catch(() => {});
    setRunning(false);
    load();
  };

  const latest  = data?.latest;
  const history = data?.history || [];
  const cfg     = data?.config  || {};

  // Build previous scan map for trend arrows: keyword → own_position last week
  const prev = history.length >= 2
    ? Object.fromEntries((history[history.length - 2].results || []).map(r => [r.keyword, r.own_position]))
    : {};

  if (loading) return <SectionCard><div style={{ padding: 32, textAlign: "center" }}><span className="spinner" /></div></SectionCard>;

  if (!cfg.keywords?.length && !editCfg) return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <CardLabel style={{ marginBottom: 0 }}>Competitor Presence</CardLabel>
        {isAdmin && <button className="btn btn-secondary btn-sm" onClick={() => setEditCfg(true)}>Configure</button>}
      </div>
      <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
        Add search keywords to start tracking where this client and their competitors rank on Google.
        <br />Example keywords: <em>MOT Falkirk</em>, <em>tyres Stirling</em>, <em>wheel alignment Central Scotland</em>
      </div>
    </SectionCard>
  );

  return (
    <SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
        <CardLabel style={{ marginBottom: 0 }}>Competitor Presence</CardLabel>
        <div style={{ display: "flex", gap: 8 }}>
          {isAdmin && <button className="btn btn-secondary btn-sm" onClick={() => setEditCfg(e => !e)}>
            {editCfg ? "Cancel" : "Edit keywords"}
          </button>}
          <button className="btn btn-secondary btn-sm" onClick={runNow} disabled={running}>
            {running ? "Scanning…" : "↻ Scan now"}
          </button>
        </div>
      </div>

      {/* Config editor */}
      {editCfg && isAdmin && (
        <div style={{ marginBottom: 16, display: "flex", flexDirection: "column", gap: 10 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", marginBottom: 5 }}>Keywords (one per line, max 10)</div>
            <textarea className="input-sm" value={keywords} onChange={e => setKeywords(e.target.value)} rows={4}
              placeholder={"MOT Falkirk\ntyres Stirling\nwheel alignment Central Scotland"}
              style={{ width: "100%", resize: "vertical" }} />
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", marginBottom: 5 }}>Client's own domains (one per line)</div>
            <textarea className="input-sm" value={ownDoms} onChange={e => setOwnDoms(e.target.value)} rows={2}
              placeholder={"jktyres.co.uk\njktyresautocentre.co.uk"}
              style={{ width: "100%", resize: "vertical" }} />
          </div>
          <button className="btn btn-primary btn-sm" style={{ alignSelf: "flex-start" }} onClick={saveConfig} disabled={saving}>
            {saving ? "Saving…" : "Save and scan"}
          </button>
        </div>
      )}

      {latest ? (
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {(latest.results || []).map((row, ri) => {
              const ownPos  = row.own_position;
              const prevPos = prev[row.keyword];
              const trend   = prevPos != null && ownPos != null
                ? (prevPos > ownPos ? "up" : prevPos < ownPos ? "down" : "same")
                : null;
              const trendIcon = trend === "up" ? "↑" : trend === "down" ? "↓" : trend === "same" ? "→" : "";
              const trendColor = trend === "up" ? "#30d158" : trend === "down" ? "#ff2d55" : "var(--text-muted)";

              // Top 5 non-own results
              const competitors = (row.results || []).filter(r => !r.is_own).slice(0, 5);

              return (
                <div key={ri} style={{ border: "1px solid var(--border)", borderRadius: 8, overflow: "hidden" }}>
                  {/* Keyword header */}
                  <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "var(--surface2)" }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", flex: 1 }}>🔍 {row.keyword}</div>
                    {ownPos ? (
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ fontSize: 11, color: "var(--text-muted)" }}>Your position:</span>
                        <span style={{ fontSize: 14, fontWeight: 800, color: ownPos <= 3 ? "#30d158" : ownPos <= 6 ? "#e6b800" : "#ff2d55", fontFamily: "var(--font-mono)" }}>#{ownPos}</span>
                        {trendIcon && <span style={{ fontSize: 12, fontWeight: 700, color: trendColor }}>{trendIcon}</span>}
                      </div>
                    ) : (
                      <span style={{ fontSize: 11, color: "#ff2d55", fontWeight: 700 }}>Not in top 10</span>
                    )}
                  </div>
                  {/* Competitor list */}
                  <div style={{ padding: "0 14px" }}>
                    {competitors.map((comp, ci) => (
                      <div key={ci} style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 0", borderBottom: ci < competitors.length - 1 ? "1px solid var(--border)" : "none" }}>
                        <div style={{
                          width: 22, height: 22, borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: 11, fontWeight: 800, fontFamily: "var(--font-mono)",
                          background: comp.position <= 3 ? "rgba(255,45,85,0.1)" : "var(--surface2)",
                          color: comp.position <= 3 ? "#ff2d55" : "var(--text-muted)",
                          flexShrink: 0,
                        }}>#{comp.position}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{comp.domain}</div>
                          <div style={{ fontSize: 10, color: "var(--text-muted)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{comp.title}</div>
                        </div>
                      </div>
                    ))}
                    {competitors.length === 0 && (
                      <div style={{ padding: "10px 0", fontSize: 11, color: "var(--text-muted)" }}>No competitor data for this keyword yet.</div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 14 }}>
            Last scanned {fmtRelTime(latest.ts)} · {history.length} scan{history.length !== 1 ? "s" : ""} recorded
          </div>
        </div>
      ) : (
        <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
          No scan data yet — click "Scan now" to run the first check.
        </div>
      )}
    </SectionCard>
  );
}

// ── Presence section (reputation + competitor) ────────────────────────────────

function PresenceSection({ slug, isAdmin }) {  return (
    <div>
      <ReputationPanel  slug={slug} isAdmin={isAdmin} />
    </div>
  );
}


function MarketingSection({ slug }) {
  const { data, loading } = useTool(slug, "seo");
  const [filter, setFilter] = useState("all");

  if (loading) return <div style={{ padding: 40, textAlign: "center" }}><span className="spinner" /></div>;
  if (!data?.available || !data?.results) return <NoData tool="marketing insights" />;

  const recs = buildRecs(data);
  const counts = {
    high:   recs.filter(r => r.priority === "high").length,
    medium: recs.filter(r => r.priority === "medium").length,
    low:    recs.filter(r => r.priority === "low").length,
  };
  const filtered = filter === "all" ? recs : recs.filter(r => r.priority === filter);

  return (
    <div>
      {/* Intro + filter strip */}
      <SectionCard style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 12, color: "var(--text-muted)", lineHeight: 1.6, marginBottom: 16 }}>
          Plain-English recommendations based on this client's latest scan results. Written to share directly with a non-technical business owner — no jargon, just what needs doing and why it matters.
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {[
            { key: "all",    label: "All",             count: recs.length,    color: "var(--accent)" },
            { key: "high",   label: "Action required", count: counts.high,    color: "#ff2d55" },
            { key: "medium", label: "Recommended",     count: counts.medium,  color: "#e6b800" },
            { key: "low",    label: "Nice to Have",    count: counts.low,     color: "#00d4ff" },
          ].map(({ key, label, count, color }) => (
            <button key={key} className="btn btn-secondary btn-sm" aria-pressed={filter === key} onClick={() => setFilter(key)}>
              {label}{count > 0 && <span style={{ fontFamily: "var(--font-mono)", marginLeft: 5 }}>{count}</span>}
            </button>
          ))}
        </div>
      </SectionCard>

      {recs.length === 0 ? (
        <SectionCard>
          <div style={{ textAlign: "center", padding: "24px 0", color: "#30d158" }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>✓</div>
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6 }}>No issues found</div>
            <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
              This client's website is passing all the checks we run. Check back after the next scan.
            </div>
          </div>
        </SectionCard>
      ) : filtered.length === 0 ? (
        <SectionCard><EmptyState message="No items in this category." /></SectionCard>
      ) : (
        filtered.map(rec => <RecCard key={rec.id} rec={rec} />)
      )}
    </div>
  );
}


// ── Search Strength ───────────────────────────────────────────────────────────

function OprRing({ score, decimal, domain, isOwn, referringDomains }) {
  // OPR scale is 0–10; normalise to 0–100 for the ring arc
  const pct      = Math.min(100, (score / 10) * 100);
  const size     = 88;
  const r        = (size / 2) - 7;
  const circ     = 2 * Math.PI * r;
  const dash     = (pct / 100) * circ;
  const colour   = isOwn
    ? "var(--accent)"
    : score >= 5 ? "#30d158" : score >= 2 ? "#e6b800" : "#86868b";
  const displayVal = decimal != null && decimal > 0 ? decimal.toFixed(1) : score;
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, minWidth: 120 }}>
      <div style={{ position: "relative", width: size, height: size }}>
        <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
          <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="var(--border)" strokeWidth={6} />
          <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={colour} strokeWidth={6}
            strokeDasharray={`${dash} ${circ}`} strokeLinecap="round" />
          {isOwn && (
            <circle cx={size/2} cy={size/2} r={r + 7} fill="none"
              stroke={colour} strokeWidth={1.5} opacity={0.2} />
          )}
        </svg>
        <div style={{
          position: "absolute", inset: 0,
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        }}>
          <span style={{ fontSize: 20, fontWeight: 800, color: colour, fontFamily: "var(--font-mono)", lineHeight: 1 }}>
            {displayVal}
          </span>
          <span style={{ fontSize: 9, color: "var(--text-muted)", marginTop: 1 }}>/10</span>
        </div>
      </div>
      <div style={{
        fontSize: 11, color: isOwn ? "var(--text)" : "var(--text-muted)",
        fontWeight: isOwn ? 600 : 400, textAlign: "center",
        wordBreak: "break-all", maxWidth: 120, lineHeight: 1.3,
      }}>
        {domain}
      </div>
      {isOwn && (
        <div style={{ fontSize: 10, color: "var(--accent)", fontWeight: 700, marginTop: -2 }}>Your site</div>
      )}
      {referringDomains > 0 && (
        <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>
          {referringDomains.toLocaleString()} links
        </div>
      )}
    </div>
  );
}

function StrengthTier({ title, description, ownDomains, competitors }) {
  if (!competitors || competitors.length === 0) return null;
  const ownEntries = Object.entries(ownDomains || {});
  return (
    <SectionCard style={{ marginTop: 16 }}>
      <CardLabel>{title}</CardLabel>
      {description && (
        <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 4, marginBottom: 16 }}>
          {description}
        </div>
      )}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 20, alignItems: "flex-start" }}>
        {ownEntries.map(([domain, d]) => (
          <OprRing key={domain} domain={domain} score={d.score ?? 0} decimal={d.decimal} isOwn={true} />
        ))}
        {ownEntries.length > 0 && competitors.length > 0 && (
          <div style={{
            width: 1, alignSelf: "stretch", background: "var(--border)", margin: "0 4px",
          }} />
        )}
        {competitors.map(c => (
          <OprRing key={c.domain} domain={c.domain} score={c.score ?? 0} decimal={c.decimal} isOwn={false} />
        ))}
      </div>
    </SectionCard>
  );
}

function SearchStrengthSection({ slug }) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [selIdx,  setSelIdx]  = useState(0);

  useEffect(() => {
    fetch(`/api/clients/${slug}/search-strength`, { credentials: "include" })
      .then(r => r.json())
      .then(d => setData(d.available ? d : null))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="cd-loading">Loading Search Strength data…</div>;

  if (!data) return (
    <SectionCard>
      <EmptyState message="No Search Strength data yet." />
      <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 12, lineHeight: 1.6 }}>
        Add Locations and Search Terms in client Settings. Data will appear after the next scheduled scan.
      </div>
    </SectionCard>
  );

  const ownDomains  = data.own_domains || {};
  const locations   = data.locations   || [];
  const markets     = data.markets     || [];
  const searchTerms = data.search_terms || [];
  const sector      = searchTerms.length ? searchTerms.join(", ") : (data.sector || "");
  const scannedAt   = data.scanned_at
    ? new Date(data.scanned_at).toLocaleString("en-GB", {
        day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/London",
      }) + " GMT"
    : "";

  const cap = s => s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  const selLoc = locations[selIdx] || null;

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8, flexWrap: "wrap", gap: 8 }}>
        <div style={{ fontSize: 12, color: "var(--text-muted)", display: "flex", gap: 16, flexWrap: "wrap" }}>
          {sector && <span>Terms: <strong style={{ color: "var(--text)" }}>{cap(sector)}</strong></span>}
        </div>
        {scannedAt && <span style={{ fontSize: 11, color: "var(--text-muted)" }}>Updated {scannedAt}</span>}
      </div>

      {/* Own domains — always shown */}
      {Object.keys(ownDomains).length > 0 && (
        <SectionCard style={{ marginBottom: 16 }}>
          <CardLabel>Your Sites</CardLabel>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 20, marginTop: 16 }}>
            {Object.entries(ownDomains).map(([domain, d]) => (
              <OprRing key={domain} domain={domain} score={d.score ?? 0} decimal={d.decimal}
                referringDomains={d.referring_domains} isOwn={true} />
            ))}
          </div>
        </SectionCard>
      )}

      {/* Location selector for local/regional */}
      {locations.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          {locations.length > 1 && (
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
              {locations.map((loc, i) => (
                <button className="btn btn-secondary btn-sm" aria-pressed={selIdx === i} key={i} onClick={() => setSelIdx(i)}>{loc.name || cap(loc.town) || `Location ${i + 1}`}</button>
              ))}
            </div>
          )}
          {selLoc && (
            <>
              <StrengthTier
                title="Local"
                description={selLoc.town ? `Businesses competing in ${cap(selLoc.town)}.` : undefined}
                ownDomains={ownDomains}
                competitors={selLoc.local || []}
              />
              <StrengthTier
                title="Regional"
                description={selLoc.region ? `Broader competition across ${cap(selLoc.region)}.` : undefined}
                ownDomains={ownDomains}
                competitors={selLoc.regional || []}
              />
            </>
          )}
        </div>
      )}

      {!locations.length && !markets.length && (
        <SectionCard>
          <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
            Add Locations and Search Terms in client Settings to see competitor data.
          </div>
        </SectionCard>
      )}

      {/* Market cards — one per configured country */}
      {markets.length > 0 && (
        <div style={{ marginTop: 8 }}>
          {markets.map((market, i) => (
            <StrengthTier
              key={i}
              title={market.country}
              description={`National competitors in ${market.country}.`}
              ownDomains={ownDomains}
              competitors={market.competitors || []}
            />
          ))}
        </div>
      )}

      <div style={{ marginTop: 20, fontSize: 11, color: "var(--text-muted)", lineHeight: 1.7 }}>
        Search Strength is scored 0–10 using Open PageRank. A higher score means more referring websites
        link to that domain — a signal of authority to search engines. Competitors are auto-discovered
        weekly from search results for your terms and locations.
      </div>
    </div>
  );
}


// ── Tab bar ───────────────────────────────────────────────────────────────────

const TABS = [
  { id: "registrations", label: "Domain Registrations" },
  { id: "certs",         label: "Certificates" },
  { id: "seo",           label: "SEO" },
  { id: "geo",           label: "GEO" },
  { id: "performance",   label: "Performance" },
  { id: "analytics",     label: "Analytics" },
  { id: "access-map",       label: "Access Map" },
  { id: "cookies",          label: "Cookie Compliance" },
  { id: "presence",         label: "Presence" },
  { id: "search-strength",  label: "Search Strength" },
  { id: "marketing",        label: "Marketing" },
];

function TabBar({ active, onChange }) {
  return (
    <div style={{ borderBottom: "1px solid var(--border)", marginBottom: 28, overflowX: "auto", scrollbarWidth: "none" }}>
      <div style={{ display: "flex", gap: 0, minWidth: "max-content" }}>
        {TABS.map(t => {
          const isActive = active === t.id;
          return (
            <button className="tab-btn" aria-selected={isActive} key={t.id} onClick={() => onChange(t.id)}>{t.label}</button>
          );
        })}
      </div>
    </div>
  );
}

// ── Main DigitalHub ───────────────────────────────────────────────────────────

export default function DigitalHub({ slug, isAdmin }) {
  // v2.60: links from the analytics report (?panel=...) open on Analytics
  const [subTab, setSubTab] = useState(() => {
    try { return new URLSearchParams(window.location.search).get("panel") ? "analytics" : "registrations"; } catch (e) { return "registrations"; }
  });
  return (
    <div>
      <TabBar active={subTab} onChange={setSubTab} />
      {subTab === "registrations" && <DomainRegistrationsSection slug={slug} />}
      {subTab === "certs"          && <CertsSection slug={slug} />}
      {subTab === "seo"            && <SeoSection slug={slug} />}
      {subTab === "geo"            && <GeoSection slug={slug} />}
      {subTab === "performance"    && <PerformanceSection slug={slug} />}
      {subTab === "analytics"      && <AnalyticsSection slug={slug} isAdmin={isAdmin} />}
      {subTab === "access-map"     && <AccessMapSection slug={slug} />}
      {subTab === "cookies"         && <CookiesSection slug={slug} />}
      {subTab === "presence"         && <PresenceSection slug={slug} isAdmin={isAdmin} />}
      {subTab === "search-strength"  && <SearchStrengthSection slug={slug} />}
      {subTab === "marketing"        && <MarketingSection slug={slug} />}
    </div>
  );
}
